
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree6d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree6d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ciB2Z", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8f43e742b69ccd2d$export$ffb0004e005737fa; }, function (v) { return $8f43e742b69ccd2d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8f43e742b69ccd2d$export$34b9dba7ce09269b; }, function (v) { return $8f43e742b69ccd2d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8f43e742b69ccd2d$export$25062201e9e25d76; }, function (v) { return $8f43e742b69ccd2d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8f43e742b69ccd2d$export$ffb0004e005737fa;
var $8f43e742b69ccd2d$export$34b9dba7ce09269b;
var $8f43e742b69ccd2d$export$25062201e9e25d76;
"use strict";
var $8f43e742b69ccd2d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8f43e742b69ccd2d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8f43e742b69ccd2d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8f43e742b69ccd2d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8f43e742b69ccd2d$export$ffb0004e005737fa = $8f43e742b69ccd2d$var$REACT_FRAGMENT_TYPE;
$8f43e742b69ccd2d$export$34b9dba7ce09269b = $8f43e742b69ccd2d$var$jsxProd;
$8f43e742b69ccd2d$export$25062201e9e25d76 = $8f43e742b69ccd2d$var$jsxProd;

});

parcelRegister("1VYQJ", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $168a50c705a8d809$export$9c16c1426311996d; }, function (v) { return $168a50c705a8d809$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $168a50c705a8d809$export$dca3b0875bd9a954; }, function (v) { return $168a50c705a8d809$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $168a50c705a8d809$export$16fa2f45be04daa8; }, function (v) { return $168a50c705a8d809$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $168a50c705a8d809$export$ffb0004e005737fa; }, function (v) { return $168a50c705a8d809$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $168a50c705a8d809$export$e2c29f18771995cb; }, function (v) { return $168a50c705a8d809$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $168a50c705a8d809$export$221d75b3f55bb0bd; }, function (v) { return $168a50c705a8d809$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $168a50c705a8d809$export$5f8d39834fd61797; }, function (v) { return $168a50c705a8d809$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $168a50c705a8d809$export$74bf444e3cd11ea5; }, function (v) { return $168a50c705a8d809$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $168a50c705a8d809$export$1ced07cd6b1985ce; }, function (v) { return $168a50c705a8d809$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $168a50c705a8d809$export$abd8e32b826d7ea7; }, function (v) { return $168a50c705a8d809$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $168a50c705a8d809$export$69a3209f1a06c04d; }, function (v) { return $168a50c705a8d809$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $168a50c705a8d809$export$8c538325882c7eec; }, function (v) { return $168a50c705a8d809$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $168a50c705a8d809$export$e530037191fcd5d7; }, function (v) { return $168a50c705a8d809$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $168a50c705a8d809$export$fd42f52fd3ae1109; }, function (v) { return $168a50c705a8d809$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $168a50c705a8d809$export$c8a8987d4410bf2d; }, function (v) { return $168a50c705a8d809$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $168a50c705a8d809$export$7d1e3a5e95ceca43; }, function (v) { return $168a50c705a8d809$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $168a50c705a8d809$export$257a8862b851cb5b; }, function (v) { return $168a50c705a8d809$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $168a50c705a8d809$export$a8257692ac88316c; }, function (v) { return $168a50c705a8d809$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $168a50c705a8d809$export$488013bae63b21da; }, function (v) { return $168a50c705a8d809$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $168a50c705a8d809$export$7c73462e0d25e514; }, function (v) { return $168a50c705a8d809$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $168a50c705a8d809$export$7568632d0d33d16d; }, function (v) { return $168a50c705a8d809$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $168a50c705a8d809$export$f93f40ac0ca7e3a8; }, function (v) { return $168a50c705a8d809$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $168a50c705a8d809$export$1f96ae73734a86cc; }, function (v) { return $168a50c705a8d809$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $168a50c705a8d809$export$9a47ced3238df325; }, function (v) { return $168a50c705a8d809$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $168a50c705a8d809$export$35808ee640e87ca7; }, function (v) { return $168a50c705a8d809$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $168a50c705a8d809$export$fae74005e78b1a27; }, function (v) { return $168a50c705a8d809$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $168a50c705a8d809$export$dc8fbce3eb94dc1e; }, function (v) { return $168a50c705a8d809$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $168a50c705a8d809$export$6a7bc4e911dc01cf; }, function (v) { return $168a50c705a8d809$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $168a50c705a8d809$export$6d9c69b0de29b591; }, function (v) { return $168a50c705a8d809$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $168a50c705a8d809$export$7f54fc3180508a52; }, function (v) { return $168a50c705a8d809$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $168a50c705a8d809$export$f680877a34711e37; }, function (v) { return $168a50c705a8d809$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $168a50c705a8d809$export$d5a552a76deda3c2; }, function (v) { return $168a50c705a8d809$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $168a50c705a8d809$export$aaabe4eda9ed9969; }, function (v) { return $168a50c705a8d809$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $168a50c705a8d809$export$e5c5a5f917a5871c; }, function (v) { return $168a50c705a8d809$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $168a50c705a8d809$export$1538c33de8887b59; }, function (v) { return $168a50c705a8d809$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $168a50c705a8d809$export$fca7f784ae7a249a; }, function (v) { return $168a50c705a8d809$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $168a50c705a8d809$export$13e3392192263954; }, function (v) { return $168a50c705a8d809$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $168a50c705a8d809$export$b8f5890fc79d6aca; }, function (v) { return $168a50c705a8d809$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $168a50c705a8d809$export$60241385465d0a34; }, function (v) { return $168a50c705a8d809$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $168a50c705a8d809$export$306c0aa65ff9ec16; }, function (v) { return $168a50c705a8d809$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $168a50c705a8d809$export$7b286972b8d8ccbf; }, function (v) { return $168a50c705a8d809$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $168a50c705a8d809$export$83d89fbfd8236492; }, function (v) { return $168a50c705a8d809$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $168a50c705a8d809$export$9c16c1426311996d;
var $168a50c705a8d809$export$dca3b0875bd9a954;
var $168a50c705a8d809$export$16fa2f45be04daa8;
var $168a50c705a8d809$export$ffb0004e005737fa;
var $168a50c705a8d809$export$e2c29f18771995cb;
var $168a50c705a8d809$export$221d75b3f55bb0bd;
var $168a50c705a8d809$export$5f8d39834fd61797;
var $168a50c705a8d809$export$74bf444e3cd11ea5;
var $168a50c705a8d809$export$1ced07cd6b1985ce;
var $168a50c705a8d809$export$abd8e32b826d7ea7;
var $168a50c705a8d809$export$69a3209f1a06c04d;
var $168a50c705a8d809$export$8c538325882c7eec;
var $168a50c705a8d809$export$e530037191fcd5d7;
var $168a50c705a8d809$export$fd42f52fd3ae1109;
var $168a50c705a8d809$export$c8a8987d4410bf2d;
var $168a50c705a8d809$export$7d1e3a5e95ceca43;
var $168a50c705a8d809$export$257a8862b851cb5b;
var $168a50c705a8d809$export$a8257692ac88316c;
var $168a50c705a8d809$export$488013bae63b21da;
var $168a50c705a8d809$export$7c73462e0d25e514;
var $168a50c705a8d809$export$7568632d0d33d16d;
var $168a50c705a8d809$export$f93f40ac0ca7e3a8;
var $168a50c705a8d809$export$1f96ae73734a86cc;
var $168a50c705a8d809$export$9a47ced3238df325;
var $168a50c705a8d809$export$35808ee640e87ca7;
var $168a50c705a8d809$export$fae74005e78b1a27;
var $168a50c705a8d809$export$dc8fbce3eb94dc1e;
var $168a50c705a8d809$export$6a7bc4e911dc01cf;
var $168a50c705a8d809$export$6d9c69b0de29b591;
var $168a50c705a8d809$export$7f54fc3180508a52;
var $168a50c705a8d809$export$f680877a34711e37;
var $168a50c705a8d809$export$d5a552a76deda3c2;
var $168a50c705a8d809$export$aaabe4eda9ed9969;
var $168a50c705a8d809$export$e5c5a5f917a5871c;
var $168a50c705a8d809$export$1538c33de8887b59;
var $168a50c705a8d809$export$fca7f784ae7a249a;
var $168a50c705a8d809$export$13e3392192263954;
var $168a50c705a8d809$export$b8f5890fc79d6aca;
var $168a50c705a8d809$export$60241385465d0a34;
var $168a50c705a8d809$export$306c0aa65ff9ec16;
var $168a50c705a8d809$export$7b286972b8d8ccbf;
var $168a50c705a8d809$export$83d89fbfd8236492;
"use strict";
var $168a50c705a8d809$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $168a50c705a8d809$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $168a50c705a8d809$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $168a50c705a8d809$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $168a50c705a8d809$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $168a50c705a8d809$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $168a50c705a8d809$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $168a50c705a8d809$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $168a50c705a8d809$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $168a50c705a8d809$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $168a50c705a8d809$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $168a50c705a8d809$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $168a50c705a8d809$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $168a50c705a8d809$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $168a50c705a8d809$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$168a50c705a8d809$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $168a50c705a8d809$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $168a50c705a8d809$var$assign = Object.assign, $168a50c705a8d809$var$emptyObject = {};
function $168a50c705a8d809$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $168a50c705a8d809$var$emptyObject;
    this.updater = updater || $168a50c705a8d809$var$ReactNoopUpdateQueue;
}
$168a50c705a8d809$var$Component.prototype.isReactComponent = {};
$168a50c705a8d809$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$168a50c705a8d809$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $168a50c705a8d809$var$ComponentDummy() {}
$168a50c705a8d809$var$ComponentDummy.prototype = $168a50c705a8d809$var$Component.prototype;
function $168a50c705a8d809$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $168a50c705a8d809$var$emptyObject;
    this.updater = updater || $168a50c705a8d809$var$ReactNoopUpdateQueue;
}
var $168a50c705a8d809$var$pureComponentPrototype = $168a50c705a8d809$var$PureComponent.prototype = new $168a50c705a8d809$var$ComponentDummy();
$168a50c705a8d809$var$pureComponentPrototype.constructor = $168a50c705a8d809$var$PureComponent;
$168a50c705a8d809$var$assign($168a50c705a8d809$var$pureComponentPrototype, $168a50c705a8d809$var$Component.prototype);
$168a50c705a8d809$var$pureComponentPrototype.isPureReactComponent = !0;
var $168a50c705a8d809$var$isArrayImpl = Array.isArray;
function $168a50c705a8d809$var$noop() {}
var $168a50c705a8d809$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $168a50c705a8d809$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $168a50c705a8d809$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $168a50c705a8d809$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $168a50c705a8d809$var$cloneAndReplaceKey(oldElement, newKey) {
    return $168a50c705a8d809$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $168a50c705a8d809$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $168a50c705a8d809$var$REACT_ELEMENT_TYPE;
}
function $168a50c705a8d809$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $168a50c705a8d809$var$userProvidedKeyEscapeRegex = /\/+/g;
function $168a50c705a8d809$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $168a50c705a8d809$var$escape("" + element.key) : index.toString(36);
}
function $168a50c705a8d809$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($168a50c705a8d809$var$noop, $168a50c705a8d809$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $168a50c705a8d809$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $168a50c705a8d809$var$REACT_ELEMENT_TYPE:
                case $168a50c705a8d809$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $168a50c705a8d809$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $168a50c705a8d809$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $168a50c705a8d809$var$getElementKey(children, 0) : nameSoFar, $168a50c705a8d809$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($168a50c705a8d809$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $168a50c705a8d809$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($168a50c705a8d809$var$isValidElement(callback) && (callback = $168a50c705a8d809$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($168a50c705a8d809$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($168a50c705a8d809$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $168a50c705a8d809$var$getElementKey(nameSoFar, i), invokeCallback += $168a50c705a8d809$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $168a50c705a8d809$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $168a50c705a8d809$var$getElementKey(nameSoFar, i++), invokeCallback += $168a50c705a8d809$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $168a50c705a8d809$var$mapIntoArray($168a50c705a8d809$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $168a50c705a8d809$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $168a50c705a8d809$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $168a50c705a8d809$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $168a50c705a8d809$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $168a50c705a8d809$var$Children = {
    map: $168a50c705a8d809$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $168a50c705a8d809$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $168a50c705a8d809$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $168a50c705a8d809$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$168a50c705a8d809$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$168a50c705a8d809$export$9c16c1426311996d = $168a50c705a8d809$var$REACT_ACTIVITY_TYPE;
$168a50c705a8d809$export$dca3b0875bd9a954 = $168a50c705a8d809$var$Children;
$168a50c705a8d809$export$16fa2f45be04daa8 = $168a50c705a8d809$var$Component;
$168a50c705a8d809$export$ffb0004e005737fa = $168a50c705a8d809$var$REACT_FRAGMENT_TYPE;
$168a50c705a8d809$export$e2c29f18771995cb = $168a50c705a8d809$var$REACT_PROFILER_TYPE;
$168a50c705a8d809$export$221d75b3f55bb0bd = $168a50c705a8d809$var$PureComponent;
$168a50c705a8d809$export$5f8d39834fd61797 = $168a50c705a8d809$var$REACT_STRICT_MODE_TYPE;
$168a50c705a8d809$export$74bf444e3cd11ea5 = $168a50c705a8d809$var$REACT_SUSPENSE_TYPE;
$168a50c705a8d809$export$1ced07cd6b1985ce = $168a50c705a8d809$var$ReactSharedInternals;
$168a50c705a8d809$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $168a50c705a8d809$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$168a50c705a8d809$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$168a50c705a8d809$export$8c538325882c7eec = function() {
    return null;
};
$168a50c705a8d809$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $168a50c705a8d809$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$168a50c705a8d809$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $168a50c705a8d809$var$ReactElement(element.type, key, props);
};
$168a50c705a8d809$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $168a50c705a8d809$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $168a50c705a8d809$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$168a50c705a8d809$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$168a50c705a8d809$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $168a50c705a8d809$var$ReactElement(type, key, props);
};
$168a50c705a8d809$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$168a50c705a8d809$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $168a50c705a8d809$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$168a50c705a8d809$export$a8257692ac88316c = $168a50c705a8d809$var$isValidElement;
$168a50c705a8d809$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $168a50c705a8d809$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $168a50c705a8d809$var$lazyInitializer
    };
};
$168a50c705a8d809$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $168a50c705a8d809$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$168a50c705a8d809$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $168a50c705a8d809$var$ReactSharedInternals.T, currentTransition = {};
    $168a50c705a8d809$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $168a50c705a8d809$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($168a50c705a8d809$var$noop, $168a50c705a8d809$var$reportGlobalError);
    } catch (error) {
        $168a50c705a8d809$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $168a50c705a8d809$var$ReactSharedInternals.T = prevTransition;
    }
};
$168a50c705a8d809$export$f93f40ac0ca7e3a8 = function() {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useCacheRefresh();
};
$168a50c705a8d809$export$1f96ae73734a86cc = function(usable) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.use(usable);
};
$168a50c705a8d809$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$168a50c705a8d809$export$35808ee640e87ca7 = function(callback, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$168a50c705a8d809$export$fae74005e78b1a27 = function(Context) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useContext(Context);
};
$168a50c705a8d809$export$dc8fbce3eb94dc1e = function() {};
$168a50c705a8d809$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$168a50c705a8d809$export$6d9c69b0de29b591 = function(create, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useEffect(create, deps);
};
$168a50c705a8d809$export$7f54fc3180508a52 = function(callback) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$168a50c705a8d809$export$f680877a34711e37 = function() {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useId();
};
$168a50c705a8d809$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$168a50c705a8d809$export$aaabe4eda9ed9969 = function(create, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$168a50c705a8d809$export$e5c5a5f917a5871c = function(create, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$168a50c705a8d809$export$1538c33de8887b59 = function(create, deps) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useMemo(create, deps);
};
$168a50c705a8d809$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$168a50c705a8d809$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$168a50c705a8d809$export$b8f5890fc79d6aca = function(initialValue) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useRef(initialValue);
};
$168a50c705a8d809$export$60241385465d0a34 = function(initialState) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useState(initialState);
};
$168a50c705a8d809$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$168a50c705a8d809$export$7b286972b8d8ccbf = function() {
    return $168a50c705a8d809$var$ReactSharedInternals.H.useTransition();
};
$168a50c705a8d809$export$83d89fbfd8236492 = "19.2.7";

});

parcelRegister("62ucW", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $465a5c9a36208e91$export$882461b6382ed46c; }, function (v) { return $465a5c9a36208e91$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $465a5c9a36208e91$export$757ceba2d55c277e; }, function (v) { return $465a5c9a36208e91$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $465a5c9a36208e91$export$83d89fbfd8236492; }, function (v) { return $465a5c9a36208e91$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $465a5c9a36208e91$export$882461b6382ed46c;
var $465a5c9a36208e91$export$757ceba2d55c277e;
var $465a5c9a36208e91$export$83d89fbfd8236492;
"use strict";

var $1oHYN = parcelRequire("1oHYN");

var $fgmOP = parcelRequire("fgmOP");

var $cwk7h = parcelRequire("cwk7h");
function $465a5c9a36208e91$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $465a5c9a36208e91$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $465a5c9a36208e91$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $465a5c9a36208e91$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $465a5c9a36208e91$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $465a5c9a36208e91$var$assertIsMounted(fiber) {
    if ($465a5c9a36208e91$var$getNearestMountedFiber(fiber) !== fiber) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(188));
}
function $465a5c9a36208e91$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $465a5c9a36208e91$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $465a5c9a36208e91$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $465a5c9a36208e91$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $465a5c9a36208e91$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $465a5c9a36208e91$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $465a5c9a36208e91$var$assign = Object.assign, $465a5c9a36208e91$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $465a5c9a36208e91$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $465a5c9a36208e91$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $465a5c9a36208e91$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $465a5c9a36208e91$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $465a5c9a36208e91$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $465a5c9a36208e91$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $465a5c9a36208e91$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $465a5c9a36208e91$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $465a5c9a36208e91$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $465a5c9a36208e91$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $465a5c9a36208e91$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $465a5c9a36208e91$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $465a5c9a36208e91$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $465a5c9a36208e91$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $465a5c9a36208e91$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $465a5c9a36208e91$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$465a5c9a36208e91$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $465a5c9a36208e91$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $465a5c9a36208e91$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $465a5c9a36208e91$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $465a5c9a36208e91$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $465a5c9a36208e91$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $465a5c9a36208e91$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $465a5c9a36208e91$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $465a5c9a36208e91$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $465a5c9a36208e91$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $465a5c9a36208e91$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $465a5c9a36208e91$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $465a5c9a36208e91$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $465a5c9a36208e91$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $465a5c9a36208e91$var$getComponentNameFromType(type.type) || "Memo";
        case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $465a5c9a36208e91$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $465a5c9a36208e91$var$isArrayImpl = Array.isArray, $465a5c9a36208e91$var$ReactSharedInternals = $fgmOP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $465a5c9a36208e91$var$ReactDOMSharedInternals = $cwk7h.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $465a5c9a36208e91$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $465a5c9a36208e91$var$valueStack = [], $465a5c9a36208e91$var$index = -1;
function $465a5c9a36208e91$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $465a5c9a36208e91$var$pop(cursor) {
    0 > $465a5c9a36208e91$var$index || (cursor.current = $465a5c9a36208e91$var$valueStack[$465a5c9a36208e91$var$index], $465a5c9a36208e91$var$valueStack[$465a5c9a36208e91$var$index] = null, $465a5c9a36208e91$var$index--);
}
function $465a5c9a36208e91$var$push(cursor, value) {
    $465a5c9a36208e91$var$index++;
    $465a5c9a36208e91$var$valueStack[$465a5c9a36208e91$var$index] = cursor.current;
    cursor.current = value;
}
var $465a5c9a36208e91$var$contextStackCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$contextFiberStackCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$rootInstanceStackCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$hostTransitionProviderCursor = $465a5c9a36208e91$var$createCursor(null);
function $465a5c9a36208e91$var$pushHostContainer(fiber, nextRootInstance) {
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$rootInstanceStackCursor, nextRootInstance);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$contextFiberStackCursor, fiber);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $465a5c9a36208e91$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $465a5c9a36208e91$var$getOwnHostContext(nextRootInstance), fiber = $465a5c9a36208e91$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$contextStackCursor);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$contextStackCursor, fiber);
}
function $465a5c9a36208e91$var$popHostContainer() {
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$contextStackCursor);
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$contextFiberStackCursor);
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$rootInstanceStackCursor);
}
function $465a5c9a36208e91$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $465a5c9a36208e91$var$push($465a5c9a36208e91$var$hostTransitionProviderCursor, fiber);
    var context = $465a5c9a36208e91$var$contextStackCursor.current;
    var JSCompiler_inline_result = $465a5c9a36208e91$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($465a5c9a36208e91$var$push($465a5c9a36208e91$var$contextFiberStackCursor, fiber), $465a5c9a36208e91$var$push($465a5c9a36208e91$var$contextStackCursor, JSCompiler_inline_result));
}
function $465a5c9a36208e91$var$popHostContext(fiber) {
    $465a5c9a36208e91$var$contextFiberStackCursor.current === fiber && ($465a5c9a36208e91$var$pop($465a5c9a36208e91$var$contextStackCursor), $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$contextFiberStackCursor));
    $465a5c9a36208e91$var$hostTransitionProviderCursor.current === fiber && ($465a5c9a36208e91$var$pop($465a5c9a36208e91$var$hostTransitionProviderCursor), $465a5c9a36208e91$var$HostTransitionContext._currentValue = $465a5c9a36208e91$var$sharedNotPendingObject);
}
var $465a5c9a36208e91$var$prefix, $465a5c9a36208e91$var$suffix;
function $465a5c9a36208e91$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $465a5c9a36208e91$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $465a5c9a36208e91$var$prefix = match && match[1] || "";
        $465a5c9a36208e91$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $465a5c9a36208e91$var$prefix + name + $465a5c9a36208e91$var$suffix;
}
var $465a5c9a36208e91$var$reentry = !1;
function $465a5c9a36208e91$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $465a5c9a36208e91$var$reentry) return "";
    $465a5c9a36208e91$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $465a5c9a36208e91$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $465a5c9a36208e91$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $465a5c9a36208e91$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $465a5c9a36208e91$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $465a5c9a36208e91$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $465a5c9a36208e91$var$describeBuiltInComponentFrame("Suspense Fallback") : $465a5c9a36208e91$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $465a5c9a36208e91$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $465a5c9a36208e91$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $465a5c9a36208e91$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $465a5c9a36208e91$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $465a5c9a36208e91$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $465a5c9a36208e91$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $465a5c9a36208e91$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $465a5c9a36208e91$var$hasOwnProperty = Object.prototype.hasOwnProperty, $465a5c9a36208e91$var$scheduleCallback$3 = $1oHYN.unstable_scheduleCallback, $465a5c9a36208e91$var$cancelCallback$1 = $1oHYN.unstable_cancelCallback, $465a5c9a36208e91$var$shouldYield = $1oHYN.unstable_shouldYield, $465a5c9a36208e91$var$requestPaint = $1oHYN.unstable_requestPaint, $465a5c9a36208e91$var$now = $1oHYN.unstable_now, $465a5c9a36208e91$var$getCurrentPriorityLevel = $1oHYN.unstable_getCurrentPriorityLevel, $465a5c9a36208e91$var$ImmediatePriority = $1oHYN.unstable_ImmediatePriority, $465a5c9a36208e91$var$UserBlockingPriority = $1oHYN.unstable_UserBlockingPriority, $465a5c9a36208e91$var$NormalPriority$1 = $1oHYN.unstable_NormalPriority, $465a5c9a36208e91$var$LowPriority = $1oHYN.unstable_LowPriority, $465a5c9a36208e91$var$IdlePriority = $1oHYN.unstable_IdlePriority, $465a5c9a36208e91$var$log$1 = $1oHYN.log, $465a5c9a36208e91$var$unstable_setDisableYieldValue = $1oHYN.unstable_setDisableYieldValue, $465a5c9a36208e91$var$rendererID = null, $465a5c9a36208e91$var$injectedHook = null;
function $465a5c9a36208e91$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $465a5c9a36208e91$var$log$1 && $465a5c9a36208e91$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($465a5c9a36208e91$var$injectedHook && "function" === typeof $465a5c9a36208e91$var$injectedHook.setStrictMode) try {
        $465a5c9a36208e91$var$injectedHook.setStrictMode($465a5c9a36208e91$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $465a5c9a36208e91$var$clz32 = Math.clz32 ? Math.clz32 : $465a5c9a36208e91$var$clz32Fallback, $465a5c9a36208e91$var$log = Math.log, $465a5c9a36208e91$var$LN2 = Math.LN2;
function $465a5c9a36208e91$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($465a5c9a36208e91$var$log(x) / $465a5c9a36208e91$var$LN2 | 0) | 0;
}
var $465a5c9a36208e91$var$nextTransitionUpdateLane = 256, $465a5c9a36208e91$var$nextTransitionDeferredLane = 262144, $465a5c9a36208e91$var$nextRetryLane = 4194304;
function $465a5c9a36208e91$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $465a5c9a36208e91$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $465a5c9a36208e91$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $465a5c9a36208e91$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $465a5c9a36208e91$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $465a5c9a36208e91$var$claimNextRetryLane() {
    var lane = $465a5c9a36208e91$var$nextRetryLane;
    $465a5c9a36208e91$var$nextRetryLane <<= 1;
    0 === ($465a5c9a36208e91$var$nextRetryLane & 62914560) && ($465a5c9a36208e91$var$nextRetryLane = 4194304);
    return lane;
}
function $465a5c9a36208e91$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $465a5c9a36208e91$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $465a5c9a36208e91$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $465a5c9a36208e91$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $465a5c9a36208e91$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $465a5c9a36208e91$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $465a5c9a36208e91$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $465a5c9a36208e91$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $465a5c9a36208e91$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $465a5c9a36208e91$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $465a5c9a36208e91$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $465a5c9a36208e91$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $465a5c9a36208e91$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $465a5c9a36208e91$var$resolveUpdatePriority() {
    var updatePriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $465a5c9a36208e91$var$getEventPriority(updatePriority.type);
}
function $465a5c9a36208e91$var$runWithPriority(priority, fn) {
    var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    try {
        return $465a5c9a36208e91$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $465a5c9a36208e91$var$randomKey = Math.random().toString(36).slice(2), $465a5c9a36208e91$var$internalInstanceKey = "__reactFiber$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalPropsKey = "__reactProps$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalContainerInstanceKey = "__reactContainer$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalEventHandlersKey = "__reactEvents$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalEventHandlerListenersKey = "__reactListeners$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalEventHandlesSetKey = "__reactHandles$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalRootNodeResourcesKey = "__reactResources$" + $465a5c9a36208e91$var$randomKey, $465a5c9a36208e91$var$internalHoistableMarker = "__reactMarker$" + $465a5c9a36208e91$var$randomKey;
function $465a5c9a36208e91$var$detachDeletedInstance(node) {
    delete node[$465a5c9a36208e91$var$internalInstanceKey];
    delete node[$465a5c9a36208e91$var$internalPropsKey];
    delete node[$465a5c9a36208e91$var$internalEventHandlersKey];
    delete node[$465a5c9a36208e91$var$internalEventHandlerListenersKey];
    delete node[$465a5c9a36208e91$var$internalEventHandlesSetKey];
}
function $465a5c9a36208e91$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$465a5c9a36208e91$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$465a5c9a36208e91$var$internalContainerInstanceKey] || parentNode[$465a5c9a36208e91$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $465a5c9a36208e91$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$465a5c9a36208e91$var$internalInstanceKey]) return parentNode;
                targetNode = $465a5c9a36208e91$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $465a5c9a36208e91$var$getInstanceFromNode(node) {
    if (node = node[$465a5c9a36208e91$var$internalInstanceKey] || node[$465a5c9a36208e91$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $465a5c9a36208e91$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(33));
}
function $465a5c9a36208e91$var$getResourcesFromRoot(root) {
    var resources = root[$465a5c9a36208e91$var$internalRootNodeResourcesKey];
    resources || (resources = root[$465a5c9a36208e91$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $465a5c9a36208e91$var$markNodeAsHoistable(node) {
    node[$465a5c9a36208e91$var$internalHoistableMarker] = !0;
}
var $465a5c9a36208e91$var$allNativeEvents = new Set(), $465a5c9a36208e91$var$registrationNameDependencies = {};
function $465a5c9a36208e91$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $465a5c9a36208e91$var$registerDirectEvent(registrationName, dependencies);
    $465a5c9a36208e91$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $465a5c9a36208e91$var$registerDirectEvent(registrationName, dependencies) {
    $465a5c9a36208e91$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$465a5c9a36208e91$var$allNativeEvents.add(dependencies[registrationName]);
}
var $465a5c9a36208e91$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $465a5c9a36208e91$var$illegalAttributeNameCache = {}, $465a5c9a36208e91$var$validatedAttributeNameCache = {};
function $465a5c9a36208e91$var$isAttributeNameSafe(attributeName) {
    if ($465a5c9a36208e91$var$hasOwnProperty.call($465a5c9a36208e91$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($465a5c9a36208e91$var$hasOwnProperty.call($465a5c9a36208e91$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($465a5c9a36208e91$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $465a5c9a36208e91$var$validatedAttributeNameCache[attributeName] = !0;
    $465a5c9a36208e91$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $465a5c9a36208e91$var$setValueForAttribute(node, name, value) {
    if ($465a5c9a36208e91$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $465a5c9a36208e91$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $465a5c9a36208e91$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $465a5c9a36208e91$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $465a5c9a36208e91$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $465a5c9a36208e91$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $465a5c9a36208e91$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $465a5c9a36208e91$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $465a5c9a36208e91$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $465a5c9a36208e91$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $465a5c9a36208e91$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $465a5c9a36208e91$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $465a5c9a36208e91$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $465a5c9a36208e91$var$getToStringValue(value);
        } else element.value !== "" + $465a5c9a36208e91$var$getToStringValue(value) && (element.value = "" + $465a5c9a36208e91$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $465a5c9a36208e91$var$setDefaultValue(element, type, $465a5c9a36208e91$var$getToStringValue(value)) : null != defaultValue ? $465a5c9a36208e91$var$setDefaultValue(element, type, $465a5c9a36208e91$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $465a5c9a36208e91$var$getToStringValue(name) : element.removeAttribute("name");
}
function $465a5c9a36208e91$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $465a5c9a36208e91$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $465a5c9a36208e91$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $465a5c9a36208e91$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $465a5c9a36208e91$var$track(element);
}
function $465a5c9a36208e91$var$setDefaultValue(node, type, value) {
    "number" === type && $465a5c9a36208e91$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $465a5c9a36208e91$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $465a5c9a36208e91$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $465a5c9a36208e91$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $465a5c9a36208e91$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $465a5c9a36208e91$var$getToStringValue(defaultValue) : "";
}
function $465a5c9a36208e91$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(92));
            if ($465a5c9a36208e91$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $465a5c9a36208e91$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $465a5c9a36208e91$var$track(element);
}
function $465a5c9a36208e91$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $465a5c9a36208e91$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $465a5c9a36208e91$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $465a5c9a36208e91$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $465a5c9a36208e91$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $465a5c9a36208e91$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $465a5c9a36208e91$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $465a5c9a36208e91$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $465a5c9a36208e91$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $465a5c9a36208e91$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $465a5c9a36208e91$var$sanitizeURL(url) {
    return $465a5c9a36208e91$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $465a5c9a36208e91$var$noop$1() {}
var $465a5c9a36208e91$var$currentReplayingEvent = null;
function $465a5c9a36208e91$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $465a5c9a36208e91$var$restoreTarget = null, $465a5c9a36208e91$var$restoreQueue = null;
function $465a5c9a36208e91$var$restoreStateOfTarget(target) {
    var internalInstance = $465a5c9a36208e91$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$465a5c9a36208e91$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $465a5c9a36208e91$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$465a5c9a36208e91$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(90));
                            $465a5c9a36208e91$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $465a5c9a36208e91$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $465a5c9a36208e91$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $465a5c9a36208e91$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $465a5c9a36208e91$var$isInsideEventHandler = !1;
function $465a5c9a36208e91$var$batchedUpdates$1(fn, a, b) {
    if ($465a5c9a36208e91$var$isInsideEventHandler) return fn(a, b);
    $465a5c9a36208e91$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($465a5c9a36208e91$var$isInsideEventHandler = !1, null !== $465a5c9a36208e91$var$restoreTarget || null !== $465a5c9a36208e91$var$restoreQueue) {
            if ($465a5c9a36208e91$var$flushSyncWork$1(), $465a5c9a36208e91$var$restoreTarget && (a = $465a5c9a36208e91$var$restoreTarget, fn = $465a5c9a36208e91$var$restoreQueue, $465a5c9a36208e91$var$restoreQueue = $465a5c9a36208e91$var$restoreTarget = null, $465a5c9a36208e91$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$465a5c9a36208e91$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $465a5c9a36208e91$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$465a5c9a36208e91$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $465a5c9a36208e91$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $465a5c9a36208e91$var$passiveBrowserEventsSupported = !1;
if ($465a5c9a36208e91$var$canUseDOM) try {
    var $465a5c9a36208e91$var$options = {};
    Object.defineProperty($465a5c9a36208e91$var$options, "passive", {
        get: function() {
            $465a5c9a36208e91$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $465a5c9a36208e91$var$options, $465a5c9a36208e91$var$options);
    window.removeEventListener("test", $465a5c9a36208e91$var$options, $465a5c9a36208e91$var$options);
} catch (e) {
    $465a5c9a36208e91$var$passiveBrowserEventsSupported = !1;
}
var $465a5c9a36208e91$var$root = null, $465a5c9a36208e91$var$startText = null, $465a5c9a36208e91$var$fallbackText = null;
function $465a5c9a36208e91$var$getData() {
    if ($465a5c9a36208e91$var$fallbackText) return $465a5c9a36208e91$var$fallbackText;
    var start, startValue = $465a5c9a36208e91$var$startText, startLength = startValue.length, end, endValue = "value" in $465a5c9a36208e91$var$root ? $465a5c9a36208e91$var$root.value : $465a5c9a36208e91$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $465a5c9a36208e91$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $465a5c9a36208e91$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $465a5c9a36208e91$var$functionThatReturnsTrue() {
    return !0;
}
function $465a5c9a36208e91$var$functionThatReturnsFalse() {
    return !1;
}
function $465a5c9a36208e91$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $465a5c9a36208e91$var$functionThatReturnsTrue : $465a5c9a36208e91$var$functionThatReturnsFalse;
        this.isPropagationStopped = $465a5c9a36208e91$var$functionThatReturnsFalse;
        return this;
    }
    $465a5c9a36208e91$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $465a5c9a36208e91$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $465a5c9a36208e91$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $465a5c9a36208e91$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $465a5c9a36208e91$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $465a5c9a36208e91$var$SyntheticEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$EventInterface), $465a5c9a36208e91$var$UIEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    view: 0,
    detail: 0
}), $465a5c9a36208e91$var$SyntheticUIEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$UIEventInterface), $465a5c9a36208e91$var$lastMovementX, $465a5c9a36208e91$var$lastMovementY, $465a5c9a36208e91$var$lastMouseEvent, $465a5c9a36208e91$var$MouseEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $465a5c9a36208e91$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $465a5c9a36208e91$var$lastMouseEvent && ($465a5c9a36208e91$var$lastMouseEvent && "mousemove" === event.type ? ($465a5c9a36208e91$var$lastMovementX = event.screenX - $465a5c9a36208e91$var$lastMouseEvent.screenX, $465a5c9a36208e91$var$lastMovementY = event.screenY - $465a5c9a36208e91$var$lastMouseEvent.screenY) : $465a5c9a36208e91$var$lastMovementY = $465a5c9a36208e91$var$lastMovementX = 0, $465a5c9a36208e91$var$lastMouseEvent = event);
        return $465a5c9a36208e91$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $465a5c9a36208e91$var$lastMovementY;
    }
}), $465a5c9a36208e91$var$SyntheticMouseEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$MouseEventInterface), $465a5c9a36208e91$var$DragEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$MouseEventInterface, {
    dataTransfer: 0
}), $465a5c9a36208e91$var$SyntheticDragEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$DragEventInterface), $465a5c9a36208e91$var$FocusEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$UIEventInterface, {
    relatedTarget: 0
}), $465a5c9a36208e91$var$SyntheticFocusEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$FocusEventInterface), $465a5c9a36208e91$var$AnimationEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $465a5c9a36208e91$var$SyntheticAnimationEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$AnimationEventInterface), $465a5c9a36208e91$var$ClipboardEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $465a5c9a36208e91$var$SyntheticClipboardEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$ClipboardEventInterface), $465a5c9a36208e91$var$CompositionEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    data: 0
}), $465a5c9a36208e91$var$SyntheticCompositionEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$CompositionEventInterface), $465a5c9a36208e91$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $465a5c9a36208e91$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $465a5c9a36208e91$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $465a5c9a36208e91$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $465a5c9a36208e91$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $465a5c9a36208e91$var$getEventModifierState() {
    return $465a5c9a36208e91$var$modifierStateGetter;
}
var $465a5c9a36208e91$var$KeyboardEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $465a5c9a36208e91$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $465a5c9a36208e91$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $465a5c9a36208e91$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $465a5c9a36208e91$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $465a5c9a36208e91$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $465a5c9a36208e91$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $465a5c9a36208e91$var$SyntheticKeyboardEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$KeyboardEventInterface), $465a5c9a36208e91$var$PointerEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $465a5c9a36208e91$var$SyntheticPointerEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$PointerEventInterface), $465a5c9a36208e91$var$TouchEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $465a5c9a36208e91$var$getEventModifierState
}), $465a5c9a36208e91$var$SyntheticTouchEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$TouchEventInterface), $465a5c9a36208e91$var$TransitionEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $465a5c9a36208e91$var$SyntheticTransitionEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$TransitionEventInterface), $465a5c9a36208e91$var$WheelEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $465a5c9a36208e91$var$SyntheticWheelEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$WheelEventInterface), $465a5c9a36208e91$var$ToggleEventInterface = $465a5c9a36208e91$var$assign({}, $465a5c9a36208e91$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $465a5c9a36208e91$var$SyntheticToggleEvent = $465a5c9a36208e91$var$createSyntheticEvent($465a5c9a36208e91$var$ToggleEventInterface), $465a5c9a36208e91$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $465a5c9a36208e91$var$canUseCompositionEvent = $465a5c9a36208e91$var$canUseDOM && "CompositionEvent" in window, $465a5c9a36208e91$var$documentMode = null;
$465a5c9a36208e91$var$canUseDOM && "documentMode" in document && ($465a5c9a36208e91$var$documentMode = document.documentMode);
var $465a5c9a36208e91$var$canUseTextInputEvent = $465a5c9a36208e91$var$canUseDOM && "TextEvent" in window && !$465a5c9a36208e91$var$documentMode, $465a5c9a36208e91$var$useFallbackCompositionData = $465a5c9a36208e91$var$canUseDOM && (!$465a5c9a36208e91$var$canUseCompositionEvent || $465a5c9a36208e91$var$documentMode && 8 < $465a5c9a36208e91$var$documentMode && 11 >= $465a5c9a36208e91$var$documentMode), $465a5c9a36208e91$var$SPACEBAR_CHAR = String.fromCharCode(32), $465a5c9a36208e91$var$hasSpaceKeypress = !1;
function $465a5c9a36208e91$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $465a5c9a36208e91$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $465a5c9a36208e91$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $465a5c9a36208e91$var$isComposing = !1;
function $465a5c9a36208e91$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $465a5c9a36208e91$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $465a5c9a36208e91$var$hasSpaceKeypress = !0;
            return $465a5c9a36208e91$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $465a5c9a36208e91$var$SPACEBAR_CHAR && $465a5c9a36208e91$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $465a5c9a36208e91$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($465a5c9a36208e91$var$isComposing) return "compositionend" === domEventName || !$465a5c9a36208e91$var$canUseCompositionEvent && $465a5c9a36208e91$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $465a5c9a36208e91$var$getData(), $465a5c9a36208e91$var$fallbackText = $465a5c9a36208e91$var$startText = $465a5c9a36208e91$var$root = null, $465a5c9a36208e91$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $465a5c9a36208e91$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $465a5c9a36208e91$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $465a5c9a36208e91$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$465a5c9a36208e91$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $465a5c9a36208e91$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $465a5c9a36208e91$var$restoreTarget ? $465a5c9a36208e91$var$restoreQueue ? $465a5c9a36208e91$var$restoreQueue.push(target) : $465a5c9a36208e91$var$restoreQueue = [
        target
    ] : $465a5c9a36208e91$var$restoreTarget = target;
    inst = $465a5c9a36208e91$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $465a5c9a36208e91$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $465a5c9a36208e91$var$activeElement$1 = null, $465a5c9a36208e91$var$activeElementInst$1 = null;
function $465a5c9a36208e91$var$runEventInBatch(dispatchQueue) {
    $465a5c9a36208e91$var$processDispatchQueue(dispatchQueue, 0);
}
function $465a5c9a36208e91$var$getInstIfValueChanged(targetInst) {
    var targetNode = $465a5c9a36208e91$var$getNodeFromInstance(targetInst);
    if ($465a5c9a36208e91$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $465a5c9a36208e91$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $465a5c9a36208e91$var$isInputEventSupported = !1;
if ($465a5c9a36208e91$var$canUseDOM) {
    var $465a5c9a36208e91$var$JSCompiler_inline_result$jscomp$286;
    if ($465a5c9a36208e91$var$canUseDOM) {
        var $465a5c9a36208e91$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$465a5c9a36208e91$var$isSupported$jscomp$inline_427) {
            var $465a5c9a36208e91$var$element$jscomp$inline_428 = document.createElement("div");
            $465a5c9a36208e91$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $465a5c9a36208e91$var$isSupported$jscomp$inline_427 = "function" === typeof $465a5c9a36208e91$var$element$jscomp$inline_428.oninput;
        }
        $465a5c9a36208e91$var$JSCompiler_inline_result$jscomp$286 = $465a5c9a36208e91$var$isSupported$jscomp$inline_427;
    } else $465a5c9a36208e91$var$JSCompiler_inline_result$jscomp$286 = !1;
    $465a5c9a36208e91$var$isInputEventSupported = $465a5c9a36208e91$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $465a5c9a36208e91$var$stopWatchingForValueChange() {
    $465a5c9a36208e91$var$activeElement$1 && ($465a5c9a36208e91$var$activeElement$1.detachEvent("onpropertychange", $465a5c9a36208e91$var$handlePropertyChange), $465a5c9a36208e91$var$activeElementInst$1 = $465a5c9a36208e91$var$activeElement$1 = null);
}
function $465a5c9a36208e91$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $465a5c9a36208e91$var$getInstIfValueChanged($465a5c9a36208e91$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $465a5c9a36208e91$var$createAndAccumulateChangeEvent(dispatchQueue, $465a5c9a36208e91$var$activeElementInst$1, nativeEvent, $465a5c9a36208e91$var$getEventTarget(nativeEvent));
        $465a5c9a36208e91$var$batchedUpdates$1($465a5c9a36208e91$var$runEventInBatch, dispatchQueue);
    }
}
function $465a5c9a36208e91$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($465a5c9a36208e91$var$stopWatchingForValueChange(), $465a5c9a36208e91$var$activeElement$1 = target, $465a5c9a36208e91$var$activeElementInst$1 = targetInst, $465a5c9a36208e91$var$activeElement$1.attachEvent("onpropertychange", $465a5c9a36208e91$var$handlePropertyChange)) : "focusout" === domEventName && $465a5c9a36208e91$var$stopWatchingForValueChange();
}
function $465a5c9a36208e91$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $465a5c9a36208e91$var$getInstIfValueChanged($465a5c9a36208e91$var$activeElementInst$1);
}
function $465a5c9a36208e91$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $465a5c9a36208e91$var$getInstIfValueChanged(targetInst);
}
function $465a5c9a36208e91$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $465a5c9a36208e91$var$getInstIfValueChanged(targetInst);
}
function $465a5c9a36208e91$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $465a5c9a36208e91$var$objectIs = "function" === typeof Object.is ? Object.is : $465a5c9a36208e91$var$is;
function $465a5c9a36208e91$var$shallowEqual(objA, objB) {
    if ($465a5c9a36208e91$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$465a5c9a36208e91$var$hasOwnProperty.call(objB, currentKey) || !$465a5c9a36208e91$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $465a5c9a36208e91$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $465a5c9a36208e91$var$getNodeForCharacterOffset(root, offset) {
    var node = $465a5c9a36208e91$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $465a5c9a36208e91$var$getLeafNode(node);
    }
}
function $465a5c9a36208e91$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $465a5c9a36208e91$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $465a5c9a36208e91$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $465a5c9a36208e91$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $465a5c9a36208e91$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $465a5c9a36208e91$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $465a5c9a36208e91$var$skipSelectionChangeEvent = $465a5c9a36208e91$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $465a5c9a36208e91$var$activeElement = null, $465a5c9a36208e91$var$activeElementInst = null, $465a5c9a36208e91$var$lastSelection = null, $465a5c9a36208e91$var$mouseDown = !1;
function $465a5c9a36208e91$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $465a5c9a36208e91$var$mouseDown || null == $465a5c9a36208e91$var$activeElement || $465a5c9a36208e91$var$activeElement !== $465a5c9a36208e91$var$getActiveElement(doc) || (doc = $465a5c9a36208e91$var$activeElement, "selectionStart" in doc && $465a5c9a36208e91$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $465a5c9a36208e91$var$lastSelection && $465a5c9a36208e91$var$shallowEqual($465a5c9a36208e91$var$lastSelection, doc) || ($465a5c9a36208e91$var$lastSelection = doc, doc = $465a5c9a36208e91$var$accumulateTwoPhaseListeners($465a5c9a36208e91$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $465a5c9a36208e91$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $465a5c9a36208e91$var$activeElement)));
}
function $465a5c9a36208e91$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $465a5c9a36208e91$var$vendorPrefixes = {
    animationend: $465a5c9a36208e91$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $465a5c9a36208e91$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $465a5c9a36208e91$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $465a5c9a36208e91$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $465a5c9a36208e91$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $465a5c9a36208e91$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $465a5c9a36208e91$var$makePrefixMap("Transition", "TransitionEnd")
}, $465a5c9a36208e91$var$prefixedEventNames = {}, $465a5c9a36208e91$var$style = {};
$465a5c9a36208e91$var$canUseDOM && ($465a5c9a36208e91$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $465a5c9a36208e91$var$vendorPrefixes.animationend.animation, delete $465a5c9a36208e91$var$vendorPrefixes.animationiteration.animation, delete $465a5c9a36208e91$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $465a5c9a36208e91$var$vendorPrefixes.transitionend.transition);
function $465a5c9a36208e91$var$getVendorPrefixedEventName(eventName) {
    if ($465a5c9a36208e91$var$prefixedEventNames[eventName]) return $465a5c9a36208e91$var$prefixedEventNames[eventName];
    if (!$465a5c9a36208e91$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $465a5c9a36208e91$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $465a5c9a36208e91$var$style) return $465a5c9a36208e91$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $465a5c9a36208e91$var$ANIMATION_END = $465a5c9a36208e91$var$getVendorPrefixedEventName("animationend"), $465a5c9a36208e91$var$ANIMATION_ITERATION = $465a5c9a36208e91$var$getVendorPrefixedEventName("animationiteration"), $465a5c9a36208e91$var$ANIMATION_START = $465a5c9a36208e91$var$getVendorPrefixedEventName("animationstart"), $465a5c9a36208e91$var$TRANSITION_RUN = $465a5c9a36208e91$var$getVendorPrefixedEventName("transitionrun"), $465a5c9a36208e91$var$TRANSITION_START = $465a5c9a36208e91$var$getVendorPrefixedEventName("transitionstart"), $465a5c9a36208e91$var$TRANSITION_CANCEL = $465a5c9a36208e91$var$getVendorPrefixedEventName("transitioncancel"), $465a5c9a36208e91$var$TRANSITION_END = $465a5c9a36208e91$var$getVendorPrefixedEventName("transitionend"), $465a5c9a36208e91$var$topLevelEventsToReactNames = new Map(), $465a5c9a36208e91$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$465a5c9a36208e91$var$simpleEventPluginEvents.push("scrollEnd");
function $465a5c9a36208e91$var$registerSimpleEvent(domEventName, reactName) {
    $465a5c9a36208e91$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $465a5c9a36208e91$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $465a5c9a36208e91$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $465a5c9a36208e91$var$concurrentQueues = [], $465a5c9a36208e91$var$concurrentQueuesIndex = 0, $465a5c9a36208e91$var$concurrentlyUpdatedLanes = 0;
function $465a5c9a36208e91$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $465a5c9a36208e91$var$concurrentQueuesIndex, i = $465a5c9a36208e91$var$concurrentlyUpdatedLanes = $465a5c9a36208e91$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $465a5c9a36208e91$var$concurrentQueues[i];
        $465a5c9a36208e91$var$concurrentQueues[i++] = null;
        var queue = $465a5c9a36208e91$var$concurrentQueues[i];
        $465a5c9a36208e91$var$concurrentQueues[i++] = null;
        var update = $465a5c9a36208e91$var$concurrentQueues[i];
        $465a5c9a36208e91$var$concurrentQueues[i++] = null;
        var lane = $465a5c9a36208e91$var$concurrentQueues[i];
        $465a5c9a36208e91$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $465a5c9a36208e91$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $465a5c9a36208e91$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $465a5c9a36208e91$var$concurrentQueues[$465a5c9a36208e91$var$concurrentQueuesIndex++] = fiber;
    $465a5c9a36208e91$var$concurrentQueues[$465a5c9a36208e91$var$concurrentQueuesIndex++] = queue;
    $465a5c9a36208e91$var$concurrentQueues[$465a5c9a36208e91$var$concurrentQueuesIndex++] = update;
    $465a5c9a36208e91$var$concurrentQueues[$465a5c9a36208e91$var$concurrentQueuesIndex++] = lane;
    $465a5c9a36208e91$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $465a5c9a36208e91$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $465a5c9a36208e91$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $465a5c9a36208e91$var$getRootForUpdatedFiber(fiber);
}
function $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $465a5c9a36208e91$var$enqueueUpdate$1(fiber, null, null, lane);
    return $465a5c9a36208e91$var$getRootForUpdatedFiber(fiber);
}
function $465a5c9a36208e91$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $465a5c9a36208e91$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $465a5c9a36208e91$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $465a5c9a36208e91$var$nestedUpdateCount) throw $465a5c9a36208e91$var$nestedUpdateCount = 0, $465a5c9a36208e91$var$rootWithNestedUpdates = null, Error($465a5c9a36208e91$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $465a5c9a36208e91$var$emptyContextObject = {};
function $465a5c9a36208e91$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $465a5c9a36208e91$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $465a5c9a36208e91$var$FiberNode(tag, pendingProps, key, mode);
}
function $465a5c9a36208e91$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $465a5c9a36208e91$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $465a5c9a36208e91$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $465a5c9a36208e91$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $465a5c9a36208e91$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $465a5c9a36208e91$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $465a5c9a36208e91$var$isHostHoistableType(type, pendingProps, $465a5c9a36208e91$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $465a5c9a36208e91$var$REACT_ACTIVITY_TYPE:
            return type = $465a5c9a36208e91$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $465a5c9a36208e91$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE:
            return $465a5c9a36208e91$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $465a5c9a36208e91$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $465a5c9a36208e91$var$REACT_PROFILER_TYPE:
            return type = $465a5c9a36208e91$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $465a5c9a36208e91$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $465a5c9a36208e91$var$REACT_SUSPENSE_TYPE:
            return type = $465a5c9a36208e91$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $465a5c9a36208e91$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $465a5c9a36208e91$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $465a5c9a36208e91$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $465a5c9a36208e91$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $465a5c9a36208e91$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $465a5c9a36208e91$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $465a5c9a36208e91$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $465a5c9a36208e91$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($465a5c9a36208e91$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $465a5c9a36208e91$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $465a5c9a36208e91$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $465a5c9a36208e91$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $465a5c9a36208e91$var$createFiberFromText(content, mode, lanes) {
    content = $465a5c9a36208e91$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $465a5c9a36208e91$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $465a5c9a36208e91$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $465a5c9a36208e91$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $465a5c9a36208e91$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $465a5c9a36208e91$var$CapturedStacks = new WeakMap();
function $465a5c9a36208e91$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $465a5c9a36208e91$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $465a5c9a36208e91$var$getStackByFiberInDevAndProd(source)
        };
        $465a5c9a36208e91$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $465a5c9a36208e91$var$getStackByFiberInDevAndProd(source)
    };
}
var $465a5c9a36208e91$var$forkStack = [], $465a5c9a36208e91$var$forkStackIndex = 0, $465a5c9a36208e91$var$treeForkProvider = null, $465a5c9a36208e91$var$treeForkCount = 0, $465a5c9a36208e91$var$idStack = [], $465a5c9a36208e91$var$idStackIndex = 0, $465a5c9a36208e91$var$treeContextProvider = null, $465a5c9a36208e91$var$treeContextId = 1, $465a5c9a36208e91$var$treeContextOverflow = "";
function $465a5c9a36208e91$var$pushTreeFork(workInProgress, totalChildren) {
    $465a5c9a36208e91$var$forkStack[$465a5c9a36208e91$var$forkStackIndex++] = $465a5c9a36208e91$var$treeForkCount;
    $465a5c9a36208e91$var$forkStack[$465a5c9a36208e91$var$forkStackIndex++] = $465a5c9a36208e91$var$treeForkProvider;
    $465a5c9a36208e91$var$treeForkProvider = workInProgress;
    $465a5c9a36208e91$var$treeForkCount = totalChildren;
}
function $465a5c9a36208e91$var$pushTreeId(workInProgress, totalChildren, index) {
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextId;
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextOverflow;
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextProvider;
    $465a5c9a36208e91$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $465a5c9a36208e91$var$treeContextId;
    workInProgress = $465a5c9a36208e91$var$treeContextOverflow;
    var baseLength = 32 - $465a5c9a36208e91$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $465a5c9a36208e91$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $465a5c9a36208e91$var$treeContextId = 1 << 32 - $465a5c9a36208e91$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $465a5c9a36208e91$var$treeContextOverflow = length + workInProgress;
    } else $465a5c9a36208e91$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $465a5c9a36208e91$var$treeContextOverflow = workInProgress;
}
function $465a5c9a36208e91$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($465a5c9a36208e91$var$pushTreeFork(workInProgress, 1), $465a5c9a36208e91$var$pushTreeId(workInProgress, 1, 0));
}
function $465a5c9a36208e91$var$popTreeContext(workInProgress) {
    for(; workInProgress === $465a5c9a36208e91$var$treeForkProvider;)$465a5c9a36208e91$var$treeForkProvider = $465a5c9a36208e91$var$forkStack[--$465a5c9a36208e91$var$forkStackIndex], $465a5c9a36208e91$var$forkStack[$465a5c9a36208e91$var$forkStackIndex] = null, $465a5c9a36208e91$var$treeForkCount = $465a5c9a36208e91$var$forkStack[--$465a5c9a36208e91$var$forkStackIndex], $465a5c9a36208e91$var$forkStack[$465a5c9a36208e91$var$forkStackIndex] = null;
    for(; workInProgress === $465a5c9a36208e91$var$treeContextProvider;)$465a5c9a36208e91$var$treeContextProvider = $465a5c9a36208e91$var$idStack[--$465a5c9a36208e91$var$idStackIndex], $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex] = null, $465a5c9a36208e91$var$treeContextOverflow = $465a5c9a36208e91$var$idStack[--$465a5c9a36208e91$var$idStackIndex], $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex] = null, $465a5c9a36208e91$var$treeContextId = $465a5c9a36208e91$var$idStack[--$465a5c9a36208e91$var$idStackIndex], $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex] = null;
}
function $465a5c9a36208e91$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextId;
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextOverflow;
    $465a5c9a36208e91$var$idStack[$465a5c9a36208e91$var$idStackIndex++] = $465a5c9a36208e91$var$treeContextProvider;
    $465a5c9a36208e91$var$treeContextId = suspendedContext.id;
    $465a5c9a36208e91$var$treeContextOverflow = suspendedContext.overflow;
    $465a5c9a36208e91$var$treeContextProvider = workInProgress;
}
var $465a5c9a36208e91$var$hydrationParentFiber = null, $465a5c9a36208e91$var$nextHydratableInstance = null, $465a5c9a36208e91$var$isHydrating = !1, $465a5c9a36208e91$var$hydrationErrors = null, $465a5c9a36208e91$var$rootOrSingletonContext = !1, $465a5c9a36208e91$var$HydrationMismatchException = Error($465a5c9a36208e91$var$formatProdErrorMessage(519));
function $465a5c9a36208e91$var$throwOnHydrationMismatch(fiber) {
    var error = Error($465a5c9a36208e91$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $465a5c9a36208e91$var$queueHydrationError($465a5c9a36208e91$var$createCapturedValueAtFiber(error, fiber));
    throw $465a5c9a36208e91$var$HydrationMismatchException;
}
function $465a5c9a36208e91$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$465a5c9a36208e91$var$internalInstanceKey] = fiber;
    instance[$465a5c9a36208e91$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("cancel", instance);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $465a5c9a36208e91$var$mediaEventTypes.length; type++)$465a5c9a36208e91$var$listenToNonDelegatedEvent($465a5c9a36208e91$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("error", instance);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", instance);
            $465a5c9a36208e91$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", instance), $465a5c9a36208e91$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $465a5c9a36208e91$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($465a5c9a36208e91$var$listenToNonDelegatedEvent("beforetoggle", instance), $465a5c9a36208e91$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $465a5c9a36208e91$var$noop$1), instance = !0) : instance = !1;
    instance || $465a5c9a36208e91$var$throwOnHydrationMismatch(fiber, !0);
}
function $465a5c9a36208e91$var$popToNextHostParent(fiber) {
    for($465a5c9a36208e91$var$hydrationParentFiber = fiber.return; $465a5c9a36208e91$var$hydrationParentFiber;)switch($465a5c9a36208e91$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $465a5c9a36208e91$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $465a5c9a36208e91$var$rootOrSingletonContext = !0;
            return;
        default:
            $465a5c9a36208e91$var$hydrationParentFiber = $465a5c9a36208e91$var$hydrationParentFiber.return;
    }
}
function $465a5c9a36208e91$var$popHydrationState(fiber) {
    if (fiber !== $465a5c9a36208e91$var$hydrationParentFiber) return !1;
    if (!$465a5c9a36208e91$var$isHydrating) return $465a5c9a36208e91$var$popToNextHostParent(fiber), $465a5c9a36208e91$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $465a5c9a36208e91$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $465a5c9a36208e91$var$nextHydratableInstance && $465a5c9a36208e91$var$throwOnHydrationMismatch(fiber);
    $465a5c9a36208e91$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(317));
        $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(317));
        $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $465a5c9a36208e91$var$nextHydratableInstance, $465a5c9a36208e91$var$isSingletonScope(fiber.type) ? (fiber = $465a5c9a36208e91$var$previousHydratableOnEnteringScopedSingleton, $465a5c9a36208e91$var$previousHydratableOnEnteringScopedSingleton = null, $465a5c9a36208e91$var$nextHydratableInstance = fiber) : $465a5c9a36208e91$var$nextHydratableInstance = tag) : $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$hydrationParentFiber ? $465a5c9a36208e91$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $465a5c9a36208e91$var$resetHydrationState() {
    $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$hydrationParentFiber = null;
    $465a5c9a36208e91$var$isHydrating = !1;
}
function $465a5c9a36208e91$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $465a5c9a36208e91$var$hydrationErrors;
    null !== queuedErrors && (null === $465a5c9a36208e91$var$workInProgressRootRecoverableErrors ? $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = queuedErrors : $465a5c9a36208e91$var$workInProgressRootRecoverableErrors.push.apply($465a5c9a36208e91$var$workInProgressRootRecoverableErrors, queuedErrors), $465a5c9a36208e91$var$hydrationErrors = null);
    return queuedErrors;
}
function $465a5c9a36208e91$var$queueHydrationError(error) {
    null === $465a5c9a36208e91$var$hydrationErrors ? $465a5c9a36208e91$var$hydrationErrors = [
        error
    ] : $465a5c9a36208e91$var$hydrationErrors.push(error);
}
var $465a5c9a36208e91$var$valueCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$currentlyRenderingFiber$1 = null, $465a5c9a36208e91$var$lastContextDependency = null;
function $465a5c9a36208e91$var$pushProvider(providerFiber, context, nextValue) {
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $465a5c9a36208e91$var$popProvider(context) {
    context._currentValue = $465a5c9a36208e91$var$valueCursor.current;
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$valueCursor);
}
function $465a5c9a36208e91$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $465a5c9a36208e91$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $465a5c9a36208e91$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $465a5c9a36208e91$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $465a5c9a36208e91$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $465a5c9a36208e91$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($465a5c9a36208e91$var$HostTransitionContext) : current = [
                $465a5c9a36208e91$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $465a5c9a36208e91$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $465a5c9a36208e91$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$465a5c9a36208e91$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $465a5c9a36208e91$var$prepareToReadContext(workInProgress) {
    $465a5c9a36208e91$var$currentlyRenderingFiber$1 = workInProgress;
    $465a5c9a36208e91$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $465a5c9a36208e91$var$readContext(context) {
    return $465a5c9a36208e91$var$readContextForConsumer($465a5c9a36208e91$var$currentlyRenderingFiber$1, context);
}
function $465a5c9a36208e91$var$readContextDuringReconciliation(consumer, context) {
    null === $465a5c9a36208e91$var$currentlyRenderingFiber$1 && $465a5c9a36208e91$var$prepareToReadContext(consumer);
    return $465a5c9a36208e91$var$readContextForConsumer(consumer, context);
}
function $465a5c9a36208e91$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $465a5c9a36208e91$var$lastContextDependency) {
        if (null === consumer) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(308));
        $465a5c9a36208e91$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $465a5c9a36208e91$var$lastContextDependency = $465a5c9a36208e91$var$lastContextDependency.next = context;
    return value;
}
var $465a5c9a36208e91$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $465a5c9a36208e91$var$scheduleCallback$2 = $1oHYN.unstable_scheduleCallback, $465a5c9a36208e91$var$NormalPriority = $1oHYN.unstable_NormalPriority, $465a5c9a36208e91$var$CacheContext = {
    $$typeof: $465a5c9a36208e91$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $465a5c9a36208e91$var$createCache() {
    return {
        controller: new $465a5c9a36208e91$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $465a5c9a36208e91$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $465a5c9a36208e91$var$scheduleCallback$2($465a5c9a36208e91$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $465a5c9a36208e91$var$currentEntangledListeners = null, $465a5c9a36208e91$var$currentEntangledPendingCount = 0, $465a5c9a36208e91$var$currentEntangledLane = 0, $465a5c9a36208e91$var$currentEntangledActionThenable = null;
function $465a5c9a36208e91$var$entangleAsyncAction(transition, thenable) {
    if (null === $465a5c9a36208e91$var$currentEntangledListeners) {
        var entangledListeners = $465a5c9a36208e91$var$currentEntangledListeners = [];
        $465a5c9a36208e91$var$currentEntangledPendingCount = 0;
        $465a5c9a36208e91$var$currentEntangledLane = $465a5c9a36208e91$var$requestTransitionLane();
        $465a5c9a36208e91$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $465a5c9a36208e91$var$currentEntangledPendingCount++;
    thenable.then($465a5c9a36208e91$var$pingEngtangledActionScope, $465a5c9a36208e91$var$pingEngtangledActionScope);
    return thenable;
}
function $465a5c9a36208e91$var$pingEngtangledActionScope() {
    if (0 === --$465a5c9a36208e91$var$currentEntangledPendingCount && null !== $465a5c9a36208e91$var$currentEntangledListeners) {
        null !== $465a5c9a36208e91$var$currentEntangledActionThenable && ($465a5c9a36208e91$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $465a5c9a36208e91$var$currentEntangledListeners;
        $465a5c9a36208e91$var$currentEntangledListeners = null;
        $465a5c9a36208e91$var$currentEntangledLane = 0;
        $465a5c9a36208e91$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $465a5c9a36208e91$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $465a5c9a36208e91$var$prevOnStartTransitionFinish = $465a5c9a36208e91$var$ReactSharedInternals.S;
$465a5c9a36208e91$var$ReactSharedInternals.S = function(transition, returnValue) {
    $465a5c9a36208e91$var$globalMostRecentTransitionTime = $465a5c9a36208e91$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $465a5c9a36208e91$var$entangleAsyncAction(transition, returnValue);
    null !== $465a5c9a36208e91$var$prevOnStartTransitionFinish && $465a5c9a36208e91$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $465a5c9a36208e91$var$resumedCache = $465a5c9a36208e91$var$createCursor(null);
function $465a5c9a36208e91$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $465a5c9a36208e91$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $465a5c9a36208e91$var$workInProgressRoot.pooledCache;
}
function $465a5c9a36208e91$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $465a5c9a36208e91$var$push($465a5c9a36208e91$var$resumedCache, $465a5c9a36208e91$var$resumedCache.current) : $465a5c9a36208e91$var$push($465a5c9a36208e91$var$resumedCache, prevCachePool.pool);
}
function $465a5c9a36208e91$var$getSuspendedCache() {
    var cacheFromPool = $465a5c9a36208e91$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $465a5c9a36208e91$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $465a5c9a36208e91$var$SuspenseException = Error($465a5c9a36208e91$var$formatProdErrorMessage(460)), $465a5c9a36208e91$var$SuspenseyCommitException = Error($465a5c9a36208e91$var$formatProdErrorMessage(474)), $465a5c9a36208e91$var$SuspenseActionException = Error($465a5c9a36208e91$var$formatProdErrorMessage(542)), $465a5c9a36208e91$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $465a5c9a36208e91$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $465a5c9a36208e91$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($465a5c9a36208e91$var$noop$1, $465a5c9a36208e91$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $465a5c9a36208e91$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($465a5c9a36208e91$var$noop$1, $465a5c9a36208e91$var$noop$1);
            else {
                thenableState = $465a5c9a36208e91$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $465a5c9a36208e91$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $465a5c9a36208e91$var$suspendedThenable = thenable;
            throw $465a5c9a36208e91$var$SuspenseException;
    }
}
function $465a5c9a36208e91$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $465a5c9a36208e91$var$suspendedThenable = x, $465a5c9a36208e91$var$SuspenseException;
        throw x;
    }
}
var $465a5c9a36208e91$var$suspendedThenable = null;
function $465a5c9a36208e91$var$getSuspendedThenable() {
    if (null === $465a5c9a36208e91$var$suspendedThenable) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(459));
    var thenable = $465a5c9a36208e91$var$suspendedThenable;
    $465a5c9a36208e91$var$suspendedThenable = null;
    return thenable;
}
function $465a5c9a36208e91$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $465a5c9a36208e91$var$SuspenseException || rejectedReason === $465a5c9a36208e91$var$SuspenseActionException) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(483));
}
var $465a5c9a36208e91$var$thenableState$1 = null, $465a5c9a36208e91$var$thenableIndexCounter$1 = 0;
function $465a5c9a36208e91$var$unwrapThenable(thenable) {
    var index = $465a5c9a36208e91$var$thenableIndexCounter$1;
    $465a5c9a36208e91$var$thenableIndexCounter$1 += 1;
    null === $465a5c9a36208e91$var$thenableState$1 && ($465a5c9a36208e91$var$thenableState$1 = []);
    return $465a5c9a36208e91$var$trackUsedThenable($465a5c9a36208e91$var$thenableState$1, thenable, index);
}
function $465a5c9a36208e91$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $465a5c9a36208e91$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $465a5c9a36208e91$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $465a5c9a36208e91$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $465a5c9a36208e91$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $465a5c9a36208e91$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $465a5c9a36208e91$var$REACT_LAZY_TYPE && $465a5c9a36208e91$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $465a5c9a36208e91$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $465a5c9a36208e91$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $465a5c9a36208e91$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $465a5c9a36208e91$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $465a5c9a36208e91$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $465a5c9a36208e91$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $465a5c9a36208e91$var$REACT_ELEMENT_TYPE:
                    return lanes = $465a5c9a36208e91$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $465a5c9a36208e91$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $465a5c9a36208e91$var$REACT_PORTAL_TYPE:
                    return newChild = $465a5c9a36208e91$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
                    return newChild = $465a5c9a36208e91$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($465a5c9a36208e91$var$isArrayImpl(newChild) || $465a5c9a36208e91$var$getIteratorFn(newChild)) return newChild = $465a5c9a36208e91$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $465a5c9a36208e91$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $465a5c9a36208e91$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $465a5c9a36208e91$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $465a5c9a36208e91$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $465a5c9a36208e91$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $465a5c9a36208e91$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
                    return newChild = $465a5c9a36208e91$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($465a5c9a36208e91$var$isArrayImpl(newChild) || $465a5c9a36208e91$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $465a5c9a36208e91$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $465a5c9a36208e91$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $465a5c9a36208e91$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $465a5c9a36208e91$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $465a5c9a36208e91$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $465a5c9a36208e91$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
                    return newChild = $465a5c9a36208e91$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($465a5c9a36208e91$var$isArrayImpl(newChild) || $465a5c9a36208e91$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $465a5c9a36208e91$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $465a5c9a36208e91$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $465a5c9a36208e91$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $465a5c9a36208e91$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $465a5c9a36208e91$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $465a5c9a36208e91$var$REACT_LAZY_TYPE && $465a5c9a36208e91$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $465a5c9a36208e91$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $465a5c9a36208e91$var$REACT_FRAGMENT_TYPE ? (lanes = $465a5c9a36208e91$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $465a5c9a36208e91$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $465a5c9a36208e91$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $465a5c9a36208e91$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $465a5c9a36208e91$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $465a5c9a36208e91$var$REACT_LAZY_TYPE:
                    return newChild = $465a5c9a36208e91$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($465a5c9a36208e91$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($465a5c9a36208e91$var$getIteratorFn(newChild)) {
                key = $465a5c9a36208e91$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $465a5c9a36208e91$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $465a5c9a36208e91$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $465a5c9a36208e91$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $465a5c9a36208e91$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $465a5c9a36208e91$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $465a5c9a36208e91$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $465a5c9a36208e91$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $465a5c9a36208e91$var$SuspenseException || x === $465a5c9a36208e91$var$SuspenseActionException) throw x;
            var fiber = $465a5c9a36208e91$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $465a5c9a36208e91$var$reconcileChildFibers = $465a5c9a36208e91$var$createChildReconciler(!0), $465a5c9a36208e91$var$mountChildFibers = $465a5c9a36208e91$var$createChildReconciler(!1), $465a5c9a36208e91$var$hasForceUpdate = !1;
function $465a5c9a36208e91$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $465a5c9a36208e91$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $465a5c9a36208e91$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $465a5c9a36208e91$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($465a5c9a36208e91$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $465a5c9a36208e91$var$getRootForUpdatedFiber(fiber);
        $465a5c9a36208e91$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $465a5c9a36208e91$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $465a5c9a36208e91$var$getRootForUpdatedFiber(fiber);
}
function $465a5c9a36208e91$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $465a5c9a36208e91$var$markRootEntangled(root, lane);
    }
}
function $465a5c9a36208e91$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $465a5c9a36208e91$var$didReadFromEntangledAsyncAction = !1;
function $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($465a5c9a36208e91$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $465a5c9a36208e91$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $465a5c9a36208e91$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $465a5c9a36208e91$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $465a5c9a36208e91$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($465a5c9a36208e91$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $465a5c9a36208e91$var$currentEntangledLane && ($465a5c9a36208e91$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $465a5c9a36208e91$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $465a5c9a36208e91$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $465a5c9a36208e91$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $465a5c9a36208e91$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$465a5c9a36208e91$var$callCallback(callbacks[updateQueue], context);
}
var $465a5c9a36208e91$var$currentTreeHiddenStackCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$prevEntangledRenderLanesCursor = $465a5c9a36208e91$var$createCursor(0);
function $465a5c9a36208e91$var$pushHiddenContext(fiber, context) {
    fiber = $465a5c9a36208e91$var$entangledRenderLanes;
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$prevEntangledRenderLanesCursor, fiber);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$currentTreeHiddenStackCursor, context);
    $465a5c9a36208e91$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $465a5c9a36208e91$var$reuseHiddenContextOnStack() {
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$prevEntangledRenderLanesCursor, $465a5c9a36208e91$var$entangledRenderLanes);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$currentTreeHiddenStackCursor, $465a5c9a36208e91$var$currentTreeHiddenStackCursor.current);
}
function $465a5c9a36208e91$var$popHiddenContext() {
    $465a5c9a36208e91$var$entangledRenderLanes = $465a5c9a36208e91$var$prevEntangledRenderLanesCursor.current;
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$currentTreeHiddenStackCursor);
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$prevEntangledRenderLanesCursor);
}
var $465a5c9a36208e91$var$suspenseHandlerStackCursor = $465a5c9a36208e91$var$createCursor(null), $465a5c9a36208e91$var$shellBoundary = null;
function $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current & 1);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseHandlerStackCursor, handler);
    null === $465a5c9a36208e91$var$shellBoundary && (null === current || null !== $465a5c9a36208e91$var$currentTreeHiddenStackCursor.current ? $465a5c9a36208e91$var$shellBoundary = handler : null !== current.memoizedState && ($465a5c9a36208e91$var$shellBoundary = handler));
}
function $465a5c9a36208e91$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseHandlerStackCursor, fiber);
    null === $465a5c9a36208e91$var$shellBoundary && ($465a5c9a36208e91$var$shellBoundary = fiber);
}
function $465a5c9a36208e91$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current), $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseHandlerStackCursor, fiber), null === $465a5c9a36208e91$var$shellBoundary && ($465a5c9a36208e91$var$shellBoundary = fiber)) : $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(fiber);
}
function $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack() {
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current);
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseHandlerStackCursor, $465a5c9a36208e91$var$suspenseHandlerStackCursor.current);
}
function $465a5c9a36208e91$var$popSuspenseHandler(fiber) {
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$suspenseHandlerStackCursor);
    $465a5c9a36208e91$var$shellBoundary === fiber && ($465a5c9a36208e91$var$shellBoundary = null);
    $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$suspenseStackCursor);
}
var $465a5c9a36208e91$var$suspenseStackCursor = $465a5c9a36208e91$var$createCursor(0);
function $465a5c9a36208e91$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $465a5c9a36208e91$var$isSuspenseInstancePending(state) || $465a5c9a36208e91$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $465a5c9a36208e91$var$renderLanes = 0, $465a5c9a36208e91$var$currentlyRenderingFiber = null, $465a5c9a36208e91$var$currentHook = null, $465a5c9a36208e91$var$workInProgressHook = null, $465a5c9a36208e91$var$didScheduleRenderPhaseUpdate = !1, $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $465a5c9a36208e91$var$localIdCounter = 0, $465a5c9a36208e91$var$thenableIndexCounter = 0, $465a5c9a36208e91$var$thenableState = null, $465a5c9a36208e91$var$globalClientIdCounter = 0;
function $465a5c9a36208e91$var$throwInvalidHookError() {
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(321));
}
function $465a5c9a36208e91$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$465a5c9a36208e91$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $465a5c9a36208e91$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $465a5c9a36208e91$var$renderLanes = nextRenderLanes;
    $465a5c9a36208e91$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $465a5c9a36208e91$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $465a5c9a36208e91$var$HooksDispatcherOnMount : $465a5c9a36208e91$var$HooksDispatcherOnUpdate;
    $465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $465a5c9a36208e91$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $465a5c9a36208e91$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $465a5c9a36208e91$var$finishRenderingHooks(current) {
    $465a5c9a36208e91$var$ReactSharedInternals.H = $465a5c9a36208e91$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $465a5c9a36208e91$var$currentHook && null !== $465a5c9a36208e91$var$currentHook.next;
    $465a5c9a36208e91$var$renderLanes = 0;
    $465a5c9a36208e91$var$workInProgressHook = $465a5c9a36208e91$var$currentHook = $465a5c9a36208e91$var$currentlyRenderingFiber = null;
    $465a5c9a36208e91$var$didScheduleRenderPhaseUpdate = !1;
    $465a5c9a36208e91$var$thenableIndexCounter = 0;
    $465a5c9a36208e91$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(300));
    null === current || $465a5c9a36208e91$var$didReceiveUpdate || (current = current.dependencies, null !== current && $465a5c9a36208e91$var$checkIfContextChanged(current) && ($465a5c9a36208e91$var$didReceiveUpdate = !0));
}
function $465a5c9a36208e91$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $465a5c9a36208e91$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass && ($465a5c9a36208e91$var$thenableState = null);
        $465a5c9a36208e91$var$thenableIndexCounter = 0;
        $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $465a5c9a36208e91$var$workInProgressHook = $465a5c9a36208e91$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $465a5c9a36208e91$var$ReactSharedInternals.H = $465a5c9a36208e91$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $465a5c9a36208e91$var$TransitionAwareHostComponent() {
    var dispatcher = $465a5c9a36208e91$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $465a5c9a36208e91$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $465a5c9a36208e91$var$currentHook ? $465a5c9a36208e91$var$currentHook.memoizedState : null) !== dispatcher && ($465a5c9a36208e91$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $465a5c9a36208e91$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $465a5c9a36208e91$var$localIdCounter;
    $465a5c9a36208e91$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $465a5c9a36208e91$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $465a5c9a36208e91$var$resetHooksOnUnwind(workInProgress) {
    if ($465a5c9a36208e91$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $465a5c9a36208e91$var$didScheduleRenderPhaseUpdate = !1;
    }
    $465a5c9a36208e91$var$renderLanes = 0;
    $465a5c9a36208e91$var$workInProgressHook = $465a5c9a36208e91$var$currentHook = $465a5c9a36208e91$var$currentlyRenderingFiber = null;
    $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $465a5c9a36208e91$var$thenableIndexCounter = $465a5c9a36208e91$var$localIdCounter = 0;
    $465a5c9a36208e91$var$thenableState = null;
}
function $465a5c9a36208e91$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $465a5c9a36208e91$var$workInProgressHook ? $465a5c9a36208e91$var$currentlyRenderingFiber.memoizedState = $465a5c9a36208e91$var$workInProgressHook = hook : $465a5c9a36208e91$var$workInProgressHook = $465a5c9a36208e91$var$workInProgressHook.next = hook;
    return $465a5c9a36208e91$var$workInProgressHook;
}
function $465a5c9a36208e91$var$updateWorkInProgressHook() {
    if (null === $465a5c9a36208e91$var$currentHook) {
        var nextCurrentHook = $465a5c9a36208e91$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $465a5c9a36208e91$var$currentHook.next;
    var nextWorkInProgressHook = null === $465a5c9a36208e91$var$workInProgressHook ? $465a5c9a36208e91$var$currentlyRenderingFiber.memoizedState : $465a5c9a36208e91$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $465a5c9a36208e91$var$workInProgressHook = nextWorkInProgressHook, $465a5c9a36208e91$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $465a5c9a36208e91$var$currentlyRenderingFiber.alternate) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(467));
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(310));
        }
        $465a5c9a36208e91$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $465a5c9a36208e91$var$currentHook.memoizedState,
            baseState: $465a5c9a36208e91$var$currentHook.baseState,
            baseQueue: $465a5c9a36208e91$var$currentHook.baseQueue,
            queue: $465a5c9a36208e91$var$currentHook.queue,
            next: null
        };
        null === $465a5c9a36208e91$var$workInProgressHook ? $465a5c9a36208e91$var$currentlyRenderingFiber.memoizedState = $465a5c9a36208e91$var$workInProgressHook = nextCurrentHook : $465a5c9a36208e91$var$workInProgressHook = $465a5c9a36208e91$var$workInProgressHook.next = nextCurrentHook;
    }
    return $465a5c9a36208e91$var$workInProgressHook;
}
function $465a5c9a36208e91$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $465a5c9a36208e91$var$useThenable(thenable) {
    var index = $465a5c9a36208e91$var$thenableIndexCounter;
    $465a5c9a36208e91$var$thenableIndexCounter += 1;
    null === $465a5c9a36208e91$var$thenableState && ($465a5c9a36208e91$var$thenableState = []);
    thenable = $465a5c9a36208e91$var$trackUsedThenable($465a5c9a36208e91$var$thenableState, thenable, index);
    index = $465a5c9a36208e91$var$currentlyRenderingFiber;
    null === (null === $465a5c9a36208e91$var$workInProgressHook ? index.memoizedState : $465a5c9a36208e91$var$workInProgressHook.next) && (index = index.alternate, $465a5c9a36208e91$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $465a5c9a36208e91$var$HooksDispatcherOnMount : $465a5c9a36208e91$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $465a5c9a36208e91$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $465a5c9a36208e91$var$useThenable(usable);
        if (usable.$$typeof === $465a5c9a36208e91$var$REACT_CONTEXT_TYPE) return $465a5c9a36208e91$var$readContext(usable);
    }
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(438, String(usable)));
}
function $465a5c9a36208e91$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $465a5c9a36208e91$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $465a5c9a36208e91$var$createFunctionComponentUpdateQueue(), $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $465a5c9a36208e91$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $465a5c9a36208e91$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $465a5c9a36208e91$var$updateReducer(reducer) {
    var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    return $465a5c9a36208e91$var$updateReducerImpl(hook, $465a5c9a36208e91$var$currentHook, reducer);
}
function $465a5c9a36208e91$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($465a5c9a36208e91$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($465a5c9a36208e91$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $465a5c9a36208e91$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($465a5c9a36208e91$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $465a5c9a36208e91$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $465a5c9a36208e91$var$currentlyRenderingFiber.lanes |= revertLane, $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $465a5c9a36208e91$var$currentlyRenderingFiber.lanes |= updateLane, $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$465a5c9a36208e91$var$objectIs(pendingQueue, hook.memoizedState) && ($465a5c9a36208e91$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $465a5c9a36208e91$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $465a5c9a36208e91$var$rerenderReducer(reducer) {
    var hook = $465a5c9a36208e91$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $465a5c9a36208e91$var$objectIs(newState, hook.memoizedState) || ($465a5c9a36208e91$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $465a5c9a36208e91$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $465a5c9a36208e91$var$currentlyRenderingFiber, hook = $465a5c9a36208e91$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $465a5c9a36208e91$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$465a5c9a36208e91$var$objectIs(($465a5c9a36208e91$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $465a5c9a36208e91$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $465a5c9a36208e91$var$updateEffect($465a5c9a36208e91$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $465a5c9a36208e91$var$workInProgressHook && $465a5c9a36208e91$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $465a5c9a36208e91$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $465a5c9a36208e91$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $465a5c9a36208e91$var$workInProgressRoot) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($465a5c9a36208e91$var$renderLanes & 127) || $465a5c9a36208e91$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $465a5c9a36208e91$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $465a5c9a36208e91$var$createFunctionComponentUpdateQueue(), $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $465a5c9a36208e91$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $465a5c9a36208e91$var$checkIfSnapshotChanged(inst) && $465a5c9a36208e91$var$forceStoreRerender(fiber);
}
function $465a5c9a36208e91$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $465a5c9a36208e91$var$checkIfSnapshotChanged(inst) && $465a5c9a36208e91$var$forceStoreRerender(fiber);
    });
}
function $465a5c9a36208e91$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$465a5c9a36208e91$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $465a5c9a36208e91$var$forceStoreRerender(fiber) {
    var root = $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $465a5c9a36208e91$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $465a5c9a36208e91$var$mountStateImpl(initialState) {
    var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $465a5c9a36208e91$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $465a5c9a36208e91$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $465a5c9a36208e91$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $465a5c9a36208e91$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $465a5c9a36208e91$var$updateReducerImpl(hook, $465a5c9a36208e91$var$currentHook, "function" === typeof reducer ? reducer : $465a5c9a36208e91$var$basicStateReducer);
}
function $465a5c9a36208e91$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($465a5c9a36208e91$var$isRenderPhaseUpdate(fiber)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $465a5c9a36208e91$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $465a5c9a36208e91$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $465a5c9a36208e91$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $465a5c9a36208e91$var$ReactSharedInternals.T, currentTransition = {};
        $465a5c9a36208e91$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $465a5c9a36208e91$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $465a5c9a36208e91$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $465a5c9a36208e91$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $465a5c9a36208e91$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $465a5c9a36208e91$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $465a5c9a36208e91$var$onActionError(actionQueue, node, error$66);
    }
}
function $465a5c9a36208e91$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $465a5c9a36208e91$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $465a5c9a36208e91$var$onActionError(actionQueue, node, error);
    }) : $465a5c9a36208e91$var$onActionSuccess(actionQueue, node, returnValue);
}
function $465a5c9a36208e91$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $465a5c9a36208e91$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $465a5c9a36208e91$var$runActionStateAction(actionQueue, nextState)));
}
function $465a5c9a36208e91$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $465a5c9a36208e91$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $465a5c9a36208e91$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $465a5c9a36208e91$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $465a5c9a36208e91$var$mountActionState(action, initialStateProp) {
    if ($465a5c9a36208e91$var$isHydrating) {
        var ssrFormState = $465a5c9a36208e91$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $465a5c9a36208e91$var$currentlyRenderingFiber;
                if ($465a5c9a36208e91$var$isHydrating) {
                    if ($465a5c9a36208e91$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $465a5c9a36208e91$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $465a5c9a36208e91$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $465a5c9a36208e91$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $465a5c9a36208e91$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $465a5c9a36208e91$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $465a5c9a36208e91$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $465a5c9a36208e91$var$dispatchSetState.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $465a5c9a36208e91$var$mountStateImpl(!1);
    inRootOrSingleton = $465a5c9a36208e91$var$dispatchOptimisticSetState.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $465a5c9a36208e91$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $465a5c9a36208e91$var$dispatchActionState.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $465a5c9a36208e91$var$updateActionState(action) {
    var stateHook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    return $465a5c9a36208e91$var$updateActionStateImpl(stateHook, $465a5c9a36208e91$var$currentHook, action);
}
function $465a5c9a36208e91$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $465a5c9a36208e91$var$updateReducerImpl(stateHook, currentStateHook, $465a5c9a36208e91$var$actionStateReducer)[0];
    stateHook = $465a5c9a36208e91$var$updateReducer($465a5c9a36208e91$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $465a5c9a36208e91$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $465a5c9a36208e91$var$SuspenseException) throw $465a5c9a36208e91$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($465a5c9a36208e91$var$currentlyRenderingFiber.flags |= 2048, $465a5c9a36208e91$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $465a5c9a36208e91$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $465a5c9a36208e91$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $465a5c9a36208e91$var$rerenderActionState(action) {
    var stateHook = $465a5c9a36208e91$var$updateWorkInProgressHook(), currentStateHook = $465a5c9a36208e91$var$currentHook;
    if (null !== currentStateHook) return $465a5c9a36208e91$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $465a5c9a36208e91$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $465a5c9a36208e91$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $465a5c9a36208e91$var$createFunctionComponentUpdateQueue(), $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $465a5c9a36208e91$var$updateRef() {
    return $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
}
function $465a5c9a36208e91$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
    $465a5c9a36208e91$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $465a5c9a36208e91$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $465a5c9a36208e91$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $465a5c9a36208e91$var$currentHook && null !== deps && $465a5c9a36208e91$var$areHookInputsEqual(deps, $465a5c9a36208e91$var$currentHook.memoizedState.deps) ? hook.memoizedState = $465a5c9a36208e91$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($465a5c9a36208e91$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $465a5c9a36208e91$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $465a5c9a36208e91$var$mountEffect(create, deps) {
    $465a5c9a36208e91$var$mountEffectImpl(8390656, 8, create, deps);
}
function $465a5c9a36208e91$var$updateEffect(create, deps) {
    $465a5c9a36208e91$var$updateEffectImpl(2048, 8, create, deps);
}
function $465a5c9a36208e91$var$useEffectEventImpl(payload) {
    $465a5c9a36208e91$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $465a5c9a36208e91$var$createFunctionComponentUpdateQueue(), $465a5c9a36208e91$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $465a5c9a36208e91$var$updateEvent(callback) {
    var ref = $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
    $465a5c9a36208e91$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($465a5c9a36208e91$var$executionContext & 2)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $465a5c9a36208e91$var$updateInsertionEffect(create, deps) {
    return $465a5c9a36208e91$var$updateEffectImpl(4, 2, create, deps);
}
function $465a5c9a36208e91$var$updateLayoutEffect(create, deps) {
    return $465a5c9a36208e91$var$updateEffectImpl(4, 4, create, deps);
}
function $465a5c9a36208e91$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $465a5c9a36208e91$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $465a5c9a36208e91$var$updateEffectImpl(4, 4, $465a5c9a36208e91$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $465a5c9a36208e91$var$mountDebugValue() {}
function $465a5c9a36208e91$var$updateCallback(callback, deps) {
    var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $465a5c9a36208e91$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $465a5c9a36208e91$var$updateMemo(nextCreate, deps) {
    var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $465a5c9a36208e91$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $465a5c9a36208e91$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $465a5c9a36208e91$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $465a5c9a36208e91$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($465a5c9a36208e91$var$renderLanes & 1073741824) && 0 === ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $465a5c9a36208e91$var$requestDeferredLane();
    $465a5c9a36208e91$var$currentlyRenderingFiber.lanes |= hook;
    $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $465a5c9a36208e91$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($465a5c9a36208e91$var$objectIs(value, prevValue)) return value;
    if (null !== $465a5c9a36208e91$var$currentTreeHiddenStackCursor.current) return hook = $465a5c9a36208e91$var$mountDeferredValueImpl(hook, value, initialValue), $465a5c9a36208e91$var$objectIs(hook, prevValue) || ($465a5c9a36208e91$var$didReceiveUpdate = !0), hook;
    if (0 === ($465a5c9a36208e91$var$renderLanes & 42) || 0 !== ($465a5c9a36208e91$var$renderLanes & 1073741824) && 0 === ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 261930)) return $465a5c9a36208e91$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $465a5c9a36208e91$var$requestDeferredLane();
    $465a5c9a36208e91$var$currentlyRenderingFiber.lanes |= hook;
    $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $465a5c9a36208e91$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $465a5c9a36208e91$var$ReactSharedInternals.T, currentTransition = {};
    $465a5c9a36208e91$var$ReactSharedInternals.T = currentTransition;
    $465a5c9a36208e91$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $465a5c9a36208e91$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $465a5c9a36208e91$var$chainThenableValue(returnValue, finishedState);
            $465a5c9a36208e91$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $465a5c9a36208e91$var$requestUpdateLane(fiber));
        } else $465a5c9a36208e91$var$dispatchSetStateInternal(fiber, queue, finishedState, $465a5c9a36208e91$var$requestUpdateLane(fiber));
    } catch (error) {
        $465a5c9a36208e91$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $465a5c9a36208e91$var$requestUpdateLane());
    } finally{
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $465a5c9a36208e91$var$ReactSharedInternals.T = prevTransition;
    }
}
function $465a5c9a36208e91$var$noop() {}
function $465a5c9a36208e91$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(476));
    var queue = $465a5c9a36208e91$var$ensureFormComponentIsStateful(formFiber).queue;
    $465a5c9a36208e91$var$startTransition(formFiber, queue, pendingState, $465a5c9a36208e91$var$sharedNotPendingObject, null === action ? $465a5c9a36208e91$var$noop : function() {
        $465a5c9a36208e91$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $465a5c9a36208e91$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $465a5c9a36208e91$var$sharedNotPendingObject,
        baseState: $465a5c9a36208e91$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $465a5c9a36208e91$var$basicStateReducer,
            lastRenderedState: $465a5c9a36208e91$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $465a5c9a36208e91$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $465a5c9a36208e91$var$requestFormReset$1(formFiber) {
    var stateHook = $465a5c9a36208e91$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $465a5c9a36208e91$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $465a5c9a36208e91$var$requestUpdateLane());
}
function $465a5c9a36208e91$var$useHostTransitionStatus() {
    return $465a5c9a36208e91$var$readContext($465a5c9a36208e91$var$HostTransitionContext);
}
function $465a5c9a36208e91$var$updateId() {
    return $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
}
function $465a5c9a36208e91$var$updateRefresh() {
    return $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
}
function $465a5c9a36208e91$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $465a5c9a36208e91$var$requestUpdateLane();
                fiber = $465a5c9a36208e91$var$createUpdate(lane);
                var root$69 = $465a5c9a36208e91$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(root$69, provider, lane), $465a5c9a36208e91$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $465a5c9a36208e91$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $465a5c9a36208e91$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $465a5c9a36208e91$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $465a5c9a36208e91$var$isRenderPhaseUpdate(fiber) ? $465a5c9a36208e91$var$enqueueRenderPhaseUpdate(queue, action) : (action = $465a5c9a36208e91$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(action, fiber, lane), $465a5c9a36208e91$var$entangleTransitionUpdate(action, queue, lane)));
}
function $465a5c9a36208e91$var$dispatchSetState(fiber, queue, action) {
    var lane = $465a5c9a36208e91$var$requestUpdateLane();
    $465a5c9a36208e91$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $465a5c9a36208e91$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($465a5c9a36208e91$var$isRenderPhaseUpdate(fiber)) $465a5c9a36208e91$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($465a5c9a36208e91$var$objectIs(eagerState, currentState)) return $465a5c9a36208e91$var$enqueueUpdate$1(fiber, queue, update, 0), null === $465a5c9a36208e91$var$workInProgressRoot && $465a5c9a36208e91$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $465a5c9a36208e91$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $465a5c9a36208e91$var$scheduleUpdateOnFiber(action, fiber, lane), $465a5c9a36208e91$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $465a5c9a36208e91$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $465a5c9a36208e91$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($465a5c9a36208e91$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $465a5c9a36208e91$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $465a5c9a36208e91$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $465a5c9a36208e91$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $465a5c9a36208e91$var$currentlyRenderingFiber || null !== alternate && alternate === $465a5c9a36208e91$var$currentlyRenderingFiber;
}
function $465a5c9a36208e91$var$enqueueRenderPhaseUpdate(queue, update) {
    $465a5c9a36208e91$var$didScheduleRenderPhaseUpdateDuringThisPass = $465a5c9a36208e91$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $465a5c9a36208e91$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $465a5c9a36208e91$var$markRootEntangled(root, lane);
    }
}
var $465a5c9a36208e91$var$ContextOnlyDispatcher = {
    readContext: $465a5c9a36208e91$var$readContext,
    use: $465a5c9a36208e91$var$use,
    useCallback: $465a5c9a36208e91$var$throwInvalidHookError,
    useContext: $465a5c9a36208e91$var$throwInvalidHookError,
    useEffect: $465a5c9a36208e91$var$throwInvalidHookError,
    useImperativeHandle: $465a5c9a36208e91$var$throwInvalidHookError,
    useLayoutEffect: $465a5c9a36208e91$var$throwInvalidHookError,
    useInsertionEffect: $465a5c9a36208e91$var$throwInvalidHookError,
    useMemo: $465a5c9a36208e91$var$throwInvalidHookError,
    useReducer: $465a5c9a36208e91$var$throwInvalidHookError,
    useRef: $465a5c9a36208e91$var$throwInvalidHookError,
    useState: $465a5c9a36208e91$var$throwInvalidHookError,
    useDebugValue: $465a5c9a36208e91$var$throwInvalidHookError,
    useDeferredValue: $465a5c9a36208e91$var$throwInvalidHookError,
    useTransition: $465a5c9a36208e91$var$throwInvalidHookError,
    useSyncExternalStore: $465a5c9a36208e91$var$throwInvalidHookError,
    useId: $465a5c9a36208e91$var$throwInvalidHookError,
    useHostTransitionStatus: $465a5c9a36208e91$var$throwInvalidHookError,
    useFormState: $465a5c9a36208e91$var$throwInvalidHookError,
    useActionState: $465a5c9a36208e91$var$throwInvalidHookError,
    useOptimistic: $465a5c9a36208e91$var$throwInvalidHookError,
    useMemoCache: $465a5c9a36208e91$var$throwInvalidHookError,
    useCacheRefresh: $465a5c9a36208e91$var$throwInvalidHookError
};
$465a5c9a36208e91$var$ContextOnlyDispatcher.useEffectEvent = $465a5c9a36208e91$var$throwInvalidHookError;
var $465a5c9a36208e91$var$HooksDispatcherOnMount = {
    readContext: $465a5c9a36208e91$var$readContext,
    use: $465a5c9a36208e91$var$use,
    useCallback: function(callback, deps) {
        $465a5c9a36208e91$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $465a5c9a36208e91$var$readContext,
    useEffect: $465a5c9a36208e91$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $465a5c9a36208e91$var$mountEffectImpl(4194308, 4, $465a5c9a36208e91$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $465a5c9a36208e91$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $465a5c9a36208e91$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $465a5c9a36208e91$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $465a5c9a36208e91$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($465a5c9a36208e91$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $465a5c9a36208e91$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $465a5c9a36208e91$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $465a5c9a36208e91$var$dispatchReducerAction.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $465a5c9a36208e91$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $465a5c9a36208e91$var$dispatchSetState.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $465a5c9a36208e91$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        return $465a5c9a36208e91$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $465a5c9a36208e91$var$mountStateImpl(!1);
        stateHook = $465a5c9a36208e91$var$startTransition.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $465a5c9a36208e91$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $465a5c9a36208e91$var$currentlyRenderingFiber, hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        if ($465a5c9a36208e91$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $465a5c9a36208e91$var$workInProgressRoot) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(349));
            0 !== ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 127) || $465a5c9a36208e91$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $465a5c9a36208e91$var$mountEffect($465a5c9a36208e91$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $465a5c9a36208e91$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $465a5c9a36208e91$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook(), identifierPrefix = $465a5c9a36208e91$var$workInProgressRoot.identifierPrefix;
        if ($465a5c9a36208e91$var$isHydrating) {
            var JSCompiler_inline_result = $465a5c9a36208e91$var$treeContextOverflow;
            var idWithLeadingBit = $465a5c9a36208e91$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $465a5c9a36208e91$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $465a5c9a36208e91$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $465a5c9a36208e91$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $465a5c9a36208e91$var$useHostTransitionStatus,
    useFormState: $465a5c9a36208e91$var$mountActionState,
    useActionState: $465a5c9a36208e91$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $465a5c9a36208e91$var$dispatchOptimisticSetState.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $465a5c9a36208e91$var$useMemoCache,
    useCacheRefresh: function() {
        return $465a5c9a36208e91$var$mountWorkInProgressHook().memoizedState = $465a5c9a36208e91$var$refreshCache.bind(null, $465a5c9a36208e91$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $465a5c9a36208e91$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($465a5c9a36208e91$var$executionContext & 2)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $465a5c9a36208e91$var$HooksDispatcherOnUpdate = {
    readContext: $465a5c9a36208e91$var$readContext,
    use: $465a5c9a36208e91$var$use,
    useCallback: $465a5c9a36208e91$var$updateCallback,
    useContext: $465a5c9a36208e91$var$readContext,
    useEffect: $465a5c9a36208e91$var$updateEffect,
    useImperativeHandle: $465a5c9a36208e91$var$updateImperativeHandle,
    useInsertionEffect: $465a5c9a36208e91$var$updateInsertionEffect,
    useLayoutEffect: $465a5c9a36208e91$var$updateLayoutEffect,
    useMemo: $465a5c9a36208e91$var$updateMemo,
    useReducer: $465a5c9a36208e91$var$updateReducer,
    useRef: $465a5c9a36208e91$var$updateRef,
    useState: function() {
        return $465a5c9a36208e91$var$updateReducer($465a5c9a36208e91$var$basicStateReducer);
    },
    useDebugValue: $465a5c9a36208e91$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
        return $465a5c9a36208e91$var$updateDeferredValueImpl(hook, $465a5c9a36208e91$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $465a5c9a36208e91$var$updateReducer($465a5c9a36208e91$var$basicStateReducer)[0], start = $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $465a5c9a36208e91$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $465a5c9a36208e91$var$updateSyncExternalStore,
    useId: $465a5c9a36208e91$var$updateId,
    useHostTransitionStatus: $465a5c9a36208e91$var$useHostTransitionStatus,
    useFormState: $465a5c9a36208e91$var$updateActionState,
    useActionState: $465a5c9a36208e91$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
        return $465a5c9a36208e91$var$updateOptimisticImpl(hook, $465a5c9a36208e91$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $465a5c9a36208e91$var$useMemoCache,
    useCacheRefresh: $465a5c9a36208e91$var$updateRefresh
};
$465a5c9a36208e91$var$HooksDispatcherOnUpdate.useEffectEvent = $465a5c9a36208e91$var$updateEvent;
var $465a5c9a36208e91$var$HooksDispatcherOnRerender = {
    readContext: $465a5c9a36208e91$var$readContext,
    use: $465a5c9a36208e91$var$use,
    useCallback: $465a5c9a36208e91$var$updateCallback,
    useContext: $465a5c9a36208e91$var$readContext,
    useEffect: $465a5c9a36208e91$var$updateEffect,
    useImperativeHandle: $465a5c9a36208e91$var$updateImperativeHandle,
    useInsertionEffect: $465a5c9a36208e91$var$updateInsertionEffect,
    useLayoutEffect: $465a5c9a36208e91$var$updateLayoutEffect,
    useMemo: $465a5c9a36208e91$var$updateMemo,
    useReducer: $465a5c9a36208e91$var$rerenderReducer,
    useRef: $465a5c9a36208e91$var$updateRef,
    useState: function() {
        return $465a5c9a36208e91$var$rerenderReducer($465a5c9a36208e91$var$basicStateReducer);
    },
    useDebugValue: $465a5c9a36208e91$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
        return null === $465a5c9a36208e91$var$currentHook ? $465a5c9a36208e91$var$mountDeferredValueImpl(hook, value, initialValue) : $465a5c9a36208e91$var$updateDeferredValueImpl(hook, $465a5c9a36208e91$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $465a5c9a36208e91$var$rerenderReducer($465a5c9a36208e91$var$basicStateReducer)[0], start = $465a5c9a36208e91$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $465a5c9a36208e91$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $465a5c9a36208e91$var$updateSyncExternalStore,
    useId: $465a5c9a36208e91$var$updateId,
    useHostTransitionStatus: $465a5c9a36208e91$var$useHostTransitionStatus,
    useFormState: $465a5c9a36208e91$var$rerenderActionState,
    useActionState: $465a5c9a36208e91$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $465a5c9a36208e91$var$updateWorkInProgressHook();
        if (null !== $465a5c9a36208e91$var$currentHook) return $465a5c9a36208e91$var$updateOptimisticImpl(hook, $465a5c9a36208e91$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $465a5c9a36208e91$var$useMemoCache,
    useCacheRefresh: $465a5c9a36208e91$var$updateRefresh
};
$465a5c9a36208e91$var$HooksDispatcherOnRerender.useEffectEvent = $465a5c9a36208e91$var$updateEvent;
function $465a5c9a36208e91$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $465a5c9a36208e91$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $465a5c9a36208e91$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $465a5c9a36208e91$var$requestUpdateLane(), update = $465a5c9a36208e91$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $465a5c9a36208e91$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(payload, inst, lane), $465a5c9a36208e91$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $465a5c9a36208e91$var$requestUpdateLane(), update = $465a5c9a36208e91$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $465a5c9a36208e91$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(payload, inst, lane), $465a5c9a36208e91$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $465a5c9a36208e91$var$requestUpdateLane(), update = $465a5c9a36208e91$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $465a5c9a36208e91$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(callback, inst, lane), $465a5c9a36208e91$var$entangleTransitions(callback, inst, lane));
    }
};
function $465a5c9a36208e91$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$465a5c9a36208e91$var$shallowEqual(oldProps, newProps) || !$465a5c9a36208e91$var$shallowEqual(oldState, newState) : !0;
}
function $465a5c9a36208e91$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $465a5c9a36208e91$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $465a5c9a36208e91$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $465a5c9a36208e91$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $465a5c9a36208e91$var$defaultOnUncaughtError(error) {
    $465a5c9a36208e91$var$reportGlobalError(error);
}
function $465a5c9a36208e91$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $465a5c9a36208e91$var$defaultOnRecoverableError(error) {
    $465a5c9a36208e91$var$reportGlobalError(error);
}
function $465a5c9a36208e91$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $465a5c9a36208e91$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $465a5c9a36208e91$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $465a5c9a36208e91$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $465a5c9a36208e91$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $465a5c9a36208e91$var$createClassErrorUpdate(lane) {
    lane = $465a5c9a36208e91$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $465a5c9a36208e91$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $465a5c9a36208e91$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $465a5c9a36208e91$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed ? $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $465a5c9a36208e91$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $465a5c9a36208e91$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $465a5c9a36208e91$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $465a5c9a36208e91$var$shellBoundary ? $465a5c9a36208e91$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $465a5c9a36208e91$var$workInProgressRootExitStatus && ($465a5c9a36208e91$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $465a5c9a36208e91$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $465a5c9a36208e91$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $465a5c9a36208e91$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $465a5c9a36208e91$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $465a5c9a36208e91$var$attachPingListener(root, value, rootRenderLanes);
        $465a5c9a36208e91$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($465a5c9a36208e91$var$isHydrating) return returnFiber = $465a5c9a36208e91$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $465a5c9a36208e91$var$HydrationMismatchException && (root = Error($465a5c9a36208e91$var$formatProdErrorMessage(422), {
        cause: value
    }), $465a5c9a36208e91$var$queueHydrationError($465a5c9a36208e91$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $465a5c9a36208e91$var$HydrationMismatchException && (returnFiber = Error($465a5c9a36208e91$var$formatProdErrorMessage(423), {
        cause: value
    }), $465a5c9a36208e91$var$queueHydrationError($465a5c9a36208e91$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $465a5c9a36208e91$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $465a5c9a36208e91$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $465a5c9a36208e91$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $465a5c9a36208e91$var$workInProgressRootExitStatus && ($465a5c9a36208e91$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($465a5c9a36208e91$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $465a5c9a36208e91$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $465a5c9a36208e91$var$workInProgressRootConcurrentErrors ? $465a5c9a36208e91$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $465a5c9a36208e91$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $465a5c9a36208e91$var$workInProgressRootExitStatus && ($465a5c9a36208e91$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $465a5c9a36208e91$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $465a5c9a36208e91$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $465a5c9a36208e91$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed || !$465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $465a5c9a36208e91$var$createClassErrorUpdate(rootRenderLanes), $465a5c9a36208e91$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $465a5c9a36208e91$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $465a5c9a36208e91$var$SelectiveHydrationException = Error($465a5c9a36208e91$var$formatProdErrorMessage(461)), $465a5c9a36208e91$var$didReceiveUpdate = !1;
function $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $465a5c9a36208e91$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $465a5c9a36208e91$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $465a5c9a36208e91$var$prepareToReadContext(workInProgress);
    nextProps = $465a5c9a36208e91$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $465a5c9a36208e91$var$checkDidRenderIdHook();
    if (null !== current && !$465a5c9a36208e91$var$didReceiveUpdate) return $465a5c9a36208e91$var$bailoutHooks(current, workInProgress, renderLanes), $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $465a5c9a36208e91$var$isHydrating && key && $465a5c9a36208e91$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $465a5c9a36208e91$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$465a5c9a36208e91$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $465a5c9a36208e91$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $465a5c9a36208e91$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$465a5c9a36208e91$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $465a5c9a36208e91$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $465a5c9a36208e91$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $465a5c9a36208e91$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($465a5c9a36208e91$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($465a5c9a36208e91$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $465a5c9a36208e91$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($465a5c9a36208e91$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $465a5c9a36208e91$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $465a5c9a36208e91$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $465a5c9a36208e91$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $465a5c9a36208e91$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $465a5c9a36208e91$var$pushHiddenContext(workInProgress, prevState) : $465a5c9a36208e91$var$reuseHiddenContextOnStack(), $465a5c9a36208e91$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $465a5c9a36208e91$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($465a5c9a36208e91$var$pushTransition(workInProgress, prevState.cachePool), $465a5c9a36208e91$var$pushHiddenContext(workInProgress, prevState), $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $465a5c9a36208e91$var$pushTransition(workInProgress, null), $465a5c9a36208e91$var$reuseHiddenContextOnStack(), $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress));
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $465a5c9a36208e91$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $465a5c9a36208e91$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $465a5c9a36208e91$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $465a5c9a36208e91$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $465a5c9a36208e91$var$pushTransition(workInProgress, null);
    $465a5c9a36208e91$var$reuseHiddenContextOnStack();
    $465a5c9a36208e91$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $465a5c9a36208e91$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $465a5c9a36208e91$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $465a5c9a36208e91$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $465a5c9a36208e91$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $465a5c9a36208e91$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($465a5c9a36208e91$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $465a5c9a36208e91$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $465a5c9a36208e91$var$bailoutOffscreenComponent(null, current);
            $465a5c9a36208e91$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $465a5c9a36208e91$var$nextHydratableInstance) ? (current = $465a5c9a36208e91$var$canHydrateHydrationBoundary(current, $465a5c9a36208e91$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $465a5c9a36208e91$var$treeContextProvider ? {
                    id: $465a5c9a36208e91$var$treeContextId,
                    overflow: $465a5c9a36208e91$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $465a5c9a36208e91$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $465a5c9a36208e91$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $465a5c9a36208e91$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $465a5c9a36208e91$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $465a5c9a36208e91$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($465a5c9a36208e91$var$formatProdErrorMessage(558));
        } else if ($465a5c9a36208e91$var$didReceiveUpdate || $465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $465a5c9a36208e91$var$didReceiveUpdate || didSuspend) {
            nextProps = $465a5c9a36208e91$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $465a5c9a36208e91$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(current, dehydrated), $465a5c9a36208e91$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $465a5c9a36208e91$var$SelectiveHydrationException;
            $465a5c9a36208e91$var$renderDidSuspendDelayIfPossible();
            workInProgress = $465a5c9a36208e91$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(dehydrated.nextSibling), $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$isHydrating = !0, $465a5c9a36208e91$var$hydrationErrors = null, $465a5c9a36208e91$var$rootOrSingletonContext = !1, null !== current && $465a5c9a36208e91$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $465a5c9a36208e91$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $465a5c9a36208e91$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $465a5c9a36208e91$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $465a5c9a36208e91$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $465a5c9a36208e91$var$prepareToReadContext(workInProgress);
    Component = $465a5c9a36208e91$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $465a5c9a36208e91$var$checkDidRenderIdHook();
    if (null !== current && !$465a5c9a36208e91$var$didReceiveUpdate) return $465a5c9a36208e91$var$bailoutHooks(current, workInProgress, renderLanes), $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $465a5c9a36208e91$var$isHydrating && nextProps && $465a5c9a36208e91$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $465a5c9a36208e91$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $465a5c9a36208e91$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $465a5c9a36208e91$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $465a5c9a36208e91$var$finishRenderingHooks(current);
    Component = $465a5c9a36208e91$var$checkDidRenderIdHook();
    if (null !== current && !$465a5c9a36208e91$var$didReceiveUpdate) return $465a5c9a36208e91$var$bailoutHooks(current, workInProgress, renderLanes), $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $465a5c9a36208e91$var$isHydrating && Component && $465a5c9a36208e91$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $465a5c9a36208e91$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $465a5c9a36208e91$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $465a5c9a36208e91$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $465a5c9a36208e91$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $465a5c9a36208e91$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $465a5c9a36208e91$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $465a5c9a36208e91$var$readContext(contextType) : $465a5c9a36208e91$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($465a5c9a36208e91$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $465a5c9a36208e91$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $465a5c9a36208e91$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $465a5c9a36208e91$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $465a5c9a36208e91$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $465a5c9a36208e91$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $465a5c9a36208e91$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $465a5c9a36208e91$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $465a5c9a36208e91$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $465a5c9a36208e91$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($465a5c9a36208e91$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $465a5c9a36208e91$var$hasForceUpdate || $465a5c9a36208e91$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $465a5c9a36208e91$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $465a5c9a36208e91$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $465a5c9a36208e91$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $465a5c9a36208e91$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $465a5c9a36208e91$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $465a5c9a36208e91$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $465a5c9a36208e91$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $465a5c9a36208e91$var$hasForceUpdate || null !== current && null !== current.dependencies && $465a5c9a36208e91$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($465a5c9a36208e91$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $465a5c9a36208e91$var$hasForceUpdate || $465a5c9a36208e91$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $465a5c9a36208e91$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $465a5c9a36208e91$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $465a5c9a36208e91$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $465a5c9a36208e91$var$resetHydrationState();
    workInProgress.flags |= 256;
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $465a5c9a36208e91$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $465a5c9a36208e91$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $465a5c9a36208e91$var$getSuspendedCache()
    };
}
function $465a5c9a36208e91$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $465a5c9a36208e91$var$workInProgressDeferredLane);
    return current;
}
function $465a5c9a36208e91$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($465a5c9a36208e91$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($465a5c9a36208e91$var$isHydrating) {
            showFallback ? $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $465a5c9a36208e91$var$nextHydratableInstance) ? (current = $465a5c9a36208e91$var$canHydrateHydrationBoundary(current, $465a5c9a36208e91$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $465a5c9a36208e91$var$treeContextProvider ? {
                    id: $465a5c9a36208e91$var$treeContextId,
                    overflow: $465a5c9a36208e91$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $465a5c9a36208e91$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $465a5c9a36208e91$var$throwOnHydrationMismatch(workInProgress);
            $465a5c9a36208e91$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $465a5c9a36208e91$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $465a5c9a36208e91$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $465a5c9a36208e91$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $465a5c9a36208e91$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $465a5c9a36208e91$var$SUSPENDED_MARKER, $465a5c9a36208e91$var$bailoutOffscreenComponent(null, nextProps);
        $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $465a5c9a36208e91$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $465a5c9a36208e91$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $465a5c9a36208e91$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $465a5c9a36208e91$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $465a5c9a36208e91$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $465a5c9a36208e91$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $465a5c9a36208e91$var$SUSPENDED_MARKER, workInProgress = $465a5c9a36208e91$var$bailoutOffscreenComponent(null, nextProps));
        else if ($465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress), $465a5c9a36208e91$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($465a5c9a36208e91$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $465a5c9a36208e91$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $465a5c9a36208e91$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($465a5c9a36208e91$var$didReceiveUpdate || $465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $465a5c9a36208e91$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $465a5c9a36208e91$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $465a5c9a36208e91$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(current, nextProps), $465a5c9a36208e91$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $465a5c9a36208e91$var$SelectiveHydrationException;
            $465a5c9a36208e91$var$isSuspenseInstancePending(nextPrimaryChildren) || $465a5c9a36208e91$var$renderDidSuspendDelayIfPossible();
            workInProgress = $465a5c9a36208e91$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $465a5c9a36208e91$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(nextPrimaryChildren.nextSibling), $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$isHydrating = !0, $465a5c9a36208e91$var$hydrationErrors = null, $465a5c9a36208e91$var$rootOrSingletonContext = !1, null !== current && $465a5c9a36208e91$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $465a5c9a36208e91$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $465a5c9a36208e91$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $465a5c9a36208e91$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $465a5c9a36208e91$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $465a5c9a36208e91$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $465a5c9a36208e91$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $465a5c9a36208e91$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $465a5c9a36208e91$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $465a5c9a36208e91$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $465a5c9a36208e91$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $465a5c9a36208e91$var$SUSPENDED_MARKER, $465a5c9a36208e91$var$bailoutOffscreenComponent(current.child, nextProps);
    $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $465a5c9a36208e91$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $465a5c9a36208e91$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $465a5c9a36208e91$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $465a5c9a36208e91$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $465a5c9a36208e91$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $465a5c9a36208e91$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $465a5c9a36208e91$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $465a5c9a36208e91$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $465a5c9a36208e91$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $465a5c9a36208e91$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $465a5c9a36208e91$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $465a5c9a36208e91$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, suspenseContext);
    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $465a5c9a36208e91$var$isHydrating ? $465a5c9a36208e91$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $465a5c9a36208e91$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $465a5c9a36208e91$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $465a5c9a36208e91$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $465a5c9a36208e91$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $465a5c9a36208e91$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $465a5c9a36208e91$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $465a5c9a36208e91$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $465a5c9a36208e91$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $465a5c9a36208e91$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $465a5c9a36208e91$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $465a5c9a36208e91$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $465a5c9a36208e91$var$checkIfContextChanged(current) ? !0 : !1;
}
function $465a5c9a36208e91$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $465a5c9a36208e91$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, current.memoizedState.cache);
            $465a5c9a36208e91$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $465a5c9a36208e91$var$pushHostContext(workInProgress);
            break;
        case 4:
            $465a5c9a36208e91$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $465a5c9a36208e91$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $465a5c9a36208e91$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $465a5c9a36208e91$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $465a5c9a36208e91$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($465a5c9a36208e91$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $465a5c9a36208e91$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $465a5c9a36208e91$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, current.memoizedState.cache);
    }
    return $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $465a5c9a36208e91$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $465a5c9a36208e91$var$didReceiveUpdate = !0;
        else {
            if (!$465a5c9a36208e91$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $465a5c9a36208e91$var$didReceiveUpdate = !1, $465a5c9a36208e91$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $465a5c9a36208e91$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $465a5c9a36208e91$var$didReceiveUpdate = !1, $465a5c9a36208e91$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $465a5c9a36208e91$var$pushTreeId(workInProgress, $465a5c9a36208e91$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $465a5c9a36208e91$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $465a5c9a36208e91$var$shouldConstruct(current) ? (props = $465a5c9a36208e91$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $465a5c9a36208e91$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $465a5c9a36208e91$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $465a5c9a36208e91$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $465a5c9a36208e91$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $465a5c9a36208e91$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $465a5c9a36208e91$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $465a5c9a36208e91$var$getComponentNameFromType(current) || current;
                    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $465a5c9a36208e91$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $465a5c9a36208e91$var$resolveClassComponentProps(props, workInProgress.pendingProps), $465a5c9a36208e91$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $465a5c9a36208e91$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $465a5c9a36208e91$var$cloneUpdateQueue(current, workInProgress);
                $465a5c9a36208e91$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, props);
                props !== prevState.cache && $465a5c9a36208e91$var$propagateContextChanges(workInProgress, [
                    $465a5c9a36208e91$var$CacheContext
                ], renderLanes, !0);
                $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $465a5c9a36208e91$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $465a5c9a36208e91$var$createCapturedValueAtFiber(Error($465a5c9a36208e91$var$formatProdErrorMessage(424)), workInProgress);
                        $465a5c9a36208e91$var$queueHydrationError($$typeof);
                        workInProgress = $465a5c9a36208e91$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(current.firstChild);
                        $465a5c9a36208e91$var$hydrationParentFiber = workInProgress;
                        $465a5c9a36208e91$var$isHydrating = !0;
                        $465a5c9a36208e91$var$hydrationErrors = null;
                        $465a5c9a36208e91$var$rootOrSingletonContext = !0;
                        renderLanes = $465a5c9a36208e91$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $465a5c9a36208e91$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $465a5c9a36208e91$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $465a5c9a36208e91$var$markRef(current, workInProgress), null === current ? (renderLanes = $465a5c9a36208e91$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $465a5c9a36208e91$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $465a5c9a36208e91$var$getOwnerDocumentFromRootContainer($465a5c9a36208e91$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress, props[$465a5c9a36208e91$var$internalPropsKey] = current, $465a5c9a36208e91$var$setInitialProperties(props, renderLanes, current), $465a5c9a36208e91$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $465a5c9a36208e91$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $465a5c9a36208e91$var$pushHostContext(workInProgress), null === current && $465a5c9a36208e91$var$isHydrating && (props = workInProgress.stateNode = $465a5c9a36208e91$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $465a5c9a36208e91$var$rootInstanceStackCursor.current), $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$rootOrSingletonContext = !0, $$typeof = $465a5c9a36208e91$var$nextHydratableInstance, $465a5c9a36208e91$var$isSingletonScope(workInProgress.type) ? ($465a5c9a36208e91$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(props.firstChild)) : $465a5c9a36208e91$var$nextHydratableInstance = $$typeof), $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $465a5c9a36208e91$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $465a5c9a36208e91$var$isHydrating) {
                if ($$typeof = props = $465a5c9a36208e91$var$nextHydratableInstance) props = $465a5c9a36208e91$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $465a5c9a36208e91$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$nextHydratableInstance = $465a5c9a36208e91$var$getNextHydratable(props.firstChild), $465a5c9a36208e91$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $465a5c9a36208e91$var$throwOnHydrationMismatch(workInProgress);
            }
            $465a5c9a36208e91$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $465a5c9a36208e91$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $465a5c9a36208e91$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $465a5c9a36208e91$var$renderWithHooks(current, workInProgress, $465a5c9a36208e91$var$TransitionAwareHostComponent, null, null, renderLanes), $465a5c9a36208e91$var$HostTransitionContext._currentValue = $$typeof);
            $465a5c9a36208e91$var$markRef(current, workInProgress);
            $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $465a5c9a36208e91$var$isHydrating) {
                if (current = renderLanes = $465a5c9a36208e91$var$nextHydratableInstance) renderLanes = $465a5c9a36208e91$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $465a5c9a36208e91$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $465a5c9a36208e91$var$hydrationParentFiber = workInProgress, $465a5c9a36208e91$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $465a5c9a36208e91$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $465a5c9a36208e91$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $465a5c9a36208e91$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $465a5c9a36208e91$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $465a5c9a36208e91$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $465a5c9a36208e91$var$pushProvider(workInProgress, workInProgress.type, props.value), $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $465a5c9a36208e91$var$prepareToReadContext(workInProgress), $$typeof = $465a5c9a36208e91$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $465a5c9a36208e91$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $465a5c9a36208e91$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $465a5c9a36208e91$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $465a5c9a36208e91$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $465a5c9a36208e91$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $465a5c9a36208e91$var$prepareToReadContext(workInProgress), props = $465a5c9a36208e91$var$readContext($465a5c9a36208e91$var$CacheContext), null === current ? ($$typeof = $465a5c9a36208e91$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $465a5c9a36208e91$var$workInProgressRoot, prevState = $465a5c9a36208e91$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $465a5c9a36208e91$var$initializeUpdateQueue(workInProgress), $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($465a5c9a36208e91$var$cloneUpdateQueue(current, workInProgress), $465a5c9a36208e91$var$processUpdateQueue(workInProgress, null, null, renderLanes), $465a5c9a36208e91$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, props)) : (props = prevState.cache, $465a5c9a36208e91$var$pushProvider(workInProgress, $465a5c9a36208e91$var$CacheContext, props), props !== $$typeof.cache && $465a5c9a36208e91$var$propagateContextChanges(workInProgress, [
                $465a5c9a36208e91$var$CacheContext
            ], renderLanes, !0))), $465a5c9a36208e91$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $465a5c9a36208e91$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $465a5c9a36208e91$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($465a5c9a36208e91$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $465a5c9a36208e91$var$suspendedThenable = $465a5c9a36208e91$var$noopSuspenseyCommitThenable, $465a5c9a36208e91$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $465a5c9a36208e91$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$465a5c9a36208e91$var$preloadResource(resource)) {
        if ($465a5c9a36208e91$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $465a5c9a36208e91$var$suspendedThenable = $465a5c9a36208e91$var$noopSuspenseyCommitThenable, $465a5c9a36208e91$var$SuspenseyCommitException;
    }
}
function $465a5c9a36208e91$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $465a5c9a36208e91$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $465a5c9a36208e91$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$465a5c9a36208e91$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $465a5c9a36208e91$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $465a5c9a36208e91$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $465a5c9a36208e91$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
        case 1:
            return $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext);
            $465a5c9a36208e91$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $465a5c9a36208e91$var$popHydrationState(workInProgress) ? $465a5c9a36208e91$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $465a5c9a36208e91$var$upgradeHydrationErrorsToRecoverable());
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($465a5c9a36208e91$var$markUpdate(workInProgress), null !== nextResource ? ($465a5c9a36208e91$var$bubbleProperties(workInProgress), $465a5c9a36208e91$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($465a5c9a36208e91$var$bubbleProperties(workInProgress), $465a5c9a36208e91$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($465a5c9a36208e91$var$markUpdate(workInProgress), $465a5c9a36208e91$var$bubbleProperties(workInProgress), $465a5c9a36208e91$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($465a5c9a36208e91$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $465a5c9a36208e91$var$markUpdate(workInProgress), $465a5c9a36208e91$var$bubbleProperties(workInProgress), $465a5c9a36208e91$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $465a5c9a36208e91$var$popHostContext(workInProgress);
            renderLanes = $465a5c9a36208e91$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $465a5c9a36208e91$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(166));
                    $465a5c9a36208e91$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $465a5c9a36208e91$var$contextStackCursor.current;
                $465a5c9a36208e91$var$popHydrationState(workInProgress) ? $465a5c9a36208e91$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $465a5c9a36208e91$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $465a5c9a36208e91$var$markUpdate(workInProgress));
            }
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $465a5c9a36208e91$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $465a5c9a36208e91$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(166));
                    $465a5c9a36208e91$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $465a5c9a36208e91$var$contextStackCursor.current;
                if ($465a5c9a36208e91$var$popHydrationState(workInProgress)) $465a5c9a36208e91$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $465a5c9a36208e91$var$getOwnerDocumentFromRootContainer($465a5c9a36208e91$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress;
                    nextResource[$465a5c9a36208e91$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($465a5c9a36208e91$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $465a5c9a36208e91$var$markUpdate(workInProgress);
                }
            }
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            $465a5c9a36208e91$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $465a5c9a36208e91$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(166));
                current = $465a5c9a36208e91$var$rootInstanceStackCursor.current;
                if ($465a5c9a36208e91$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $465a5c9a36208e91$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $465a5c9a36208e91$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $465a5c9a36208e91$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $465a5c9a36208e91$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $465a5c9a36208e91$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(557));
                        current[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress;
                    } else $465a5c9a36208e91$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $465a5c9a36208e91$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $465a5c9a36208e91$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $465a5c9a36208e91$var$popSuspenseHandler(workInProgress), workInProgress;
                    $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(558));
            }
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $465a5c9a36208e91$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(317));
                        type[$465a5c9a36208e91$var$internalInstanceKey] = workInProgress;
                    } else $465a5c9a36208e91$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $465a5c9a36208e91$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $465a5c9a36208e91$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $465a5c9a36208e91$var$popSuspenseHandler(workInProgress), workInProgress;
                    $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $465a5c9a36208e91$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $465a5c9a36208e91$var$popHostContainer(), null === current && $465a5c9a36208e91$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
        case 10:
            return $465a5c9a36208e91$var$popProvider(workInProgress.type), $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
        case 19:
            $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $465a5c9a36208e91$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $465a5c9a36208e91$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $465a5c9a36208e91$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $465a5c9a36208e91$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $465a5c9a36208e91$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$465a5c9a36208e91$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, $465a5c9a36208e91$var$suspenseStackCursor.current & 1 | 2);
                            $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $465a5c9a36208e91$var$now() > $465a5c9a36208e91$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $465a5c9a36208e91$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $465a5c9a36208e91$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $465a5c9a36208e91$var$scheduleRetryEffect(workInProgress, current), $465a5c9a36208e91$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$465a5c9a36208e91$var$isHydrating) return $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
                    } else 2 * $465a5c9a36208e91$var$now() - newProps.renderingStartTime > $465a5c9a36208e91$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $465a5c9a36208e91$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $465a5c9a36208e91$var$now(), current.sibling = null, renderLanes = $465a5c9a36208e91$var$suspenseStackCursor.current, $465a5c9a36208e91$var$push($465a5c9a36208e91$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $465a5c9a36208e91$var$isHydrating && $465a5c9a36208e91$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $465a5c9a36208e91$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $465a5c9a36208e91$var$popSuspenseHandler(workInProgress), $465a5c9a36208e91$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($465a5c9a36208e91$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $465a5c9a36208e91$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $465a5c9a36208e91$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext), $465a5c9a36208e91$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $465a5c9a36208e91$var$unwindWork(current, workInProgress) {
    $465a5c9a36208e91$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext), $465a5c9a36208e91$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $465a5c9a36208e91$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(340));
                $465a5c9a36208e91$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $465a5c9a36208e91$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(340));
                $465a5c9a36208e91$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$suspenseStackCursor), null;
        case 4:
            return $465a5c9a36208e91$var$popHostContainer(), null;
        case 10:
            return $465a5c9a36208e91$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $465a5c9a36208e91$var$popSuspenseHandler(workInProgress), $465a5c9a36208e91$var$popHiddenContext(), null !== current && $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $465a5c9a36208e91$var$unwindInterruptedWork(current, interruptedWork) {
    $465a5c9a36208e91$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext);
            $465a5c9a36208e91$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $465a5c9a36208e91$var$popHostContext(interruptedWork);
            break;
        case 4:
            $465a5c9a36208e91$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $465a5c9a36208e91$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $465a5c9a36208e91$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$suspenseStackCursor);
            break;
        case 10:
            $465a5c9a36208e91$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $465a5c9a36208e91$var$popSuspenseHandler(interruptedWork);
            $465a5c9a36208e91$var$popHiddenContext();
            null !== current && $465a5c9a36208e91$var$pop($465a5c9a36208e91$var$resumedCache);
            break;
        case 24:
            $465a5c9a36208e91$var$popProvider($465a5c9a36208e91$var$CacheContext);
    }
}
function $465a5c9a36208e91$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $465a5c9a36208e91$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $465a5c9a36208e91$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $465a5c9a36208e91$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $465a5c9a36208e91$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $465a5c9a36208e91$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $465a5c9a36208e91$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $465a5c9a36208e91$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $465a5c9a36208e91$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $465a5c9a36208e91$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $465a5c9a36208e91$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $465a5c9a36208e91$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $465a5c9a36208e91$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $465a5c9a36208e91$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$465a5c9a36208e91$var$internalPropsKey] = newProps;
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $465a5c9a36208e91$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $465a5c9a36208e91$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $465a5c9a36208e91$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $465a5c9a36208e91$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $465a5c9a36208e91$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $465a5c9a36208e91$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $465a5c9a36208e91$var$noop$1));
    else if (4 !== tag && (27 === tag && $465a5c9a36208e91$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($465a5c9a36208e91$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$465a5c9a36208e91$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $465a5c9a36208e91$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $465a5c9a36208e91$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($465a5c9a36208e91$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$465a5c9a36208e91$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $465a5c9a36208e91$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $465a5c9a36208e91$var$setInitialProperties(singleton, type, props);
        singleton[$465a5c9a36208e91$var$internalInstanceKey] = finishedWork;
        singleton[$465a5c9a36208e91$var$internalPropsKey] = props;
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $465a5c9a36208e91$var$offscreenSubtreeIsHidden = !1, $465a5c9a36208e91$var$offscreenSubtreeWasHidden = !1, $465a5c9a36208e91$var$needsFormReset = !1, $465a5c9a36208e91$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $465a5c9a36208e91$var$nextEffect = null;
function $465a5c9a36208e91$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $465a5c9a36208e91$var$eventsEnabled = $465a5c9a36208e91$var$_enabled;
    root = $465a5c9a36208e91$var$getActiveElementDeep(root);
    if ($465a5c9a36208e91$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $465a5c9a36208e91$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $465a5c9a36208e91$var$_enabled = !1;
    for($465a5c9a36208e91$var$nextEffect = firstChild; null !== $465a5c9a36208e91$var$nextEffect;)if (firstChild = $465a5c9a36208e91$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $465a5c9a36208e91$var$nextEffect = root;
    else for(; null !== $465a5c9a36208e91$var$nextEffect;){
        firstChild = $465a5c9a36208e91$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $465a5c9a36208e91$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $465a5c9a36208e91$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $465a5c9a36208e91$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $465a5c9a36208e91$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $465a5c9a36208e91$var$nextEffect = root;
            break;
        }
        $465a5c9a36208e91$var$nextEffect = firstChild.return;
    }
}
function $465a5c9a36208e91$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $465a5c9a36208e91$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $465a5c9a36208e91$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $465a5c9a36208e91$var$commitClassCallbacks(finishedWork);
            flags & 512 && $465a5c9a36208e91$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $465a5c9a36208e91$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $465a5c9a36208e91$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $465a5c9a36208e91$var$commitHostMount(finishedWork);
            flags & 512 && $465a5c9a36208e91$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $465a5c9a36208e91$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $465a5c9a36208e91$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $465a5c9a36208e91$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $465a5c9a36208e91$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $465a5c9a36208e91$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $465a5c9a36208e91$var$offscreenSubtreeWasHidden;
                prevProps = $465a5c9a36208e91$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $465a5c9a36208e91$var$offscreenSubtreeWasHidden;
                $465a5c9a36208e91$var$offscreenSubtreeIsHidden = flags;
                ($465a5c9a36208e91$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $465a5c9a36208e91$var$offscreenSubtreeIsHidden = prevProps;
                $465a5c9a36208e91$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $465a5c9a36208e91$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $465a5c9a36208e91$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $465a5c9a36208e91$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $465a5c9a36208e91$var$hostParent = null, $465a5c9a36208e91$var$hostParentIsContainer = !1;
function $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$465a5c9a36208e91$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $465a5c9a36208e91$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($465a5c9a36208e91$var$injectedHook && "function" === typeof $465a5c9a36208e91$var$injectedHook.onCommitFiberUnmount) try {
        $465a5c9a36208e91$var$injectedHook.onCommitFiberUnmount($465a5c9a36208e91$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden || $465a5c9a36208e91$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden || $465a5c9a36208e91$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $465a5c9a36208e91$var$hostParent, prevHostParentIsContainer = $465a5c9a36208e91$var$hostParentIsContainer;
            $465a5c9a36208e91$var$isSingletonScope(deletedFiber.type) && ($465a5c9a36208e91$var$hostParent = deletedFiber.stateNode, $465a5c9a36208e91$var$hostParentIsContainer = !1);
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $465a5c9a36208e91$var$releaseSingletonInstance(deletedFiber.stateNode);
            $465a5c9a36208e91$var$hostParent = prevHostParent;
            $465a5c9a36208e91$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden || $465a5c9a36208e91$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $465a5c9a36208e91$var$hostParent;
            prevHostParentIsContainer = $465a5c9a36208e91$var$hostParentIsContainer;
            $465a5c9a36208e91$var$hostParent = null;
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $465a5c9a36208e91$var$hostParent = prevHostParent;
            $465a5c9a36208e91$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $465a5c9a36208e91$var$hostParent) {
                if ($465a5c9a36208e91$var$hostParentIsContainer) try {
                    (9 === $465a5c9a36208e91$var$hostParent.nodeType ? $465a5c9a36208e91$var$hostParent.body : "HTML" === $465a5c9a36208e91$var$hostParent.nodeName ? $465a5c9a36208e91$var$hostParent.ownerDocument.body : $465a5c9a36208e91$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $465a5c9a36208e91$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $465a5c9a36208e91$var$hostParent && ($465a5c9a36208e91$var$hostParentIsContainer ? (finishedRoot = $465a5c9a36208e91$var$hostParent, $465a5c9a36208e91$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $465a5c9a36208e91$var$retryIfBlockedOn(finishedRoot)) : $465a5c9a36208e91$var$clearHydrationBoundary($465a5c9a36208e91$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $465a5c9a36208e91$var$hostParent;
            prevHostParentIsContainer = $465a5c9a36208e91$var$hostParentIsContainer;
            $465a5c9a36208e91$var$hostParent = deletedFiber.stateNode.containerInfo;
            $465a5c9a36208e91$var$hostParentIsContainer = !0;
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $465a5c9a36208e91$var$hostParent = prevHostParent;
            $465a5c9a36208e91$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $465a5c9a36208e91$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden || $465a5c9a36208e91$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden || ($465a5c9a36208e91$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $465a5c9a36208e91$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden = (prevHostParent = $465a5c9a36208e91$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $465a5c9a36208e91$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $465a5c9a36208e91$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $465a5c9a36208e91$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $465a5c9a36208e91$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $465a5c9a36208e91$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $465a5c9a36208e91$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $465a5c9a36208e91$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $465a5c9a36208e91$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $465a5c9a36208e91$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $465a5c9a36208e91$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $465a5c9a36208e91$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($465a5c9a36208e91$var$isSingletonScope(parent.type)) {
                        $465a5c9a36208e91$var$hostParent = parent.stateNode;
                        $465a5c9a36208e91$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $465a5c9a36208e91$var$hostParent = parent.stateNode;
                    $465a5c9a36208e91$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $465a5c9a36208e91$var$hostParent = parent.stateNode.containerInfo;
                    $465a5c9a36208e91$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $465a5c9a36208e91$var$hostParent) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(160));
        $465a5c9a36208e91$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $465a5c9a36208e91$var$hostParent = null;
        $465a5c9a36208e91$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$465a5c9a36208e91$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $465a5c9a36208e91$var$currentHoistableRoot = null;
function $465a5c9a36208e91$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($465a5c9a36208e91$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $465a5c9a36208e91$var$commitHookEffectListMount(3, finishedWork), $465a5c9a36208e91$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($465a5c9a36208e91$var$offscreenSubtreeWasHidden || null === current || $465a5c9a36208e91$var$safelyDetachRef(current, current.return));
            flags & 64 && $465a5c9a36208e91$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $465a5c9a36208e91$var$currentHoistableRoot;
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($465a5c9a36208e91$var$offscreenSubtreeWasHidden || null === current || $465a5c9a36208e91$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$465a5c9a36208e91$var$internalHoistableMarker] || currentResource[$465a5c9a36208e91$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $465a5c9a36208e91$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$465a5c9a36208e91$var$internalInstanceKey] = finishedWork;
                                        $465a5c9a36208e91$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $465a5c9a36208e91$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $465a5c9a36208e91$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $465a5c9a36208e91$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $465a5c9a36208e91$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($465a5c9a36208e91$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$465a5c9a36208e91$var$internalInstanceKey] = finishedWork;
                                $465a5c9a36208e91$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $465a5c9a36208e91$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $465a5c9a36208e91$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $465a5c9a36208e91$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $465a5c9a36208e91$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $465a5c9a36208e91$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($465a5c9a36208e91$var$offscreenSubtreeWasHidden || null === current || $465a5c9a36208e91$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $465a5c9a36208e91$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($465a5c9a36208e91$var$offscreenSubtreeWasHidden || null === current || $465a5c9a36208e91$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $465a5c9a36208e91$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $465a5c9a36208e91$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($465a5c9a36208e91$var$needsFormReset = !0);
            break;
        case 6:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $465a5c9a36208e91$var$tagCaches = null;
            hoistableRoot = $465a5c9a36208e91$var$currentHoistableRoot;
            $465a5c9a36208e91$var$currentHoistableRoot = $465a5c9a36208e91$var$getHoistableRoot(root.containerInfo);
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$currentHoistableRoot = hoistableRoot;
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $465a5c9a36208e91$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $465a5c9a36208e91$var$needsFormReset && ($465a5c9a36208e91$var$needsFormReset = !1, $465a5c9a36208e91$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $465a5c9a36208e91$var$currentHoistableRoot;
            $465a5c9a36208e91$var$currentHoistableRoot = $465a5c9a36208e91$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            $465a5c9a36208e91$var$currentHoistableRoot = flags;
            break;
        case 12:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $465a5c9a36208e91$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($465a5c9a36208e91$var$globalMostRecentFallbackTime = $465a5c9a36208e91$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $465a5c9a36208e91$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $465a5c9a36208e91$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $465a5c9a36208e91$var$offscreenSubtreeWasHidden;
            $465a5c9a36208e91$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $465a5c9a36208e91$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $465a5c9a36208e91$var$offscreenSubtreeIsHidden || $465a5c9a36208e91$var$offscreenSubtreeWasHidden || $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $465a5c9a36208e91$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $465a5c9a36208e91$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $465a5c9a36208e91$var$hideOrUnhideDehydratedBoundary(instance, !0) : $465a5c9a36208e91$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $465a5c9a36208e91$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $465a5c9a36208e91$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $465a5c9a36208e91$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $465a5c9a36208e91$var$recursivelyTraverseMutationEffects(root, finishedWork), $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork);
    }
}
function $465a5c9a36208e91$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($465a5c9a36208e91$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $465a5c9a36208e91$var$getHostSibling(finishedWork);
                    $465a5c9a36208e91$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($465a5c9a36208e91$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $465a5c9a36208e91$var$getHostSibling(finishedWork);
                    $465a5c9a36208e91$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $465a5c9a36208e91$var$getHostSibling(finishedWork);
                    $465a5c9a36208e91$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $465a5c9a36208e91$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $465a5c9a36208e91$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $465a5c9a36208e91$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$465a5c9a36208e91$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $465a5c9a36208e91$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $465a5c9a36208e91$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $465a5c9a36208e91$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $465a5c9a36208e91$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $465a5c9a36208e91$var$safelyDetachRef(finishedWork, finishedWork.return);
                $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $465a5c9a36208e91$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $465a5c9a36208e91$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$465a5c9a36208e91$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $465a5c9a36208e91$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $465a5c9a36208e91$var$commitClassCallbacks(finishedWork);
                $465a5c9a36208e91$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $465a5c9a36208e91$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $465a5c9a36208e91$var$commitHostMount(finishedWork);
                $465a5c9a36208e91$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $465a5c9a36208e91$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $465a5c9a36208e91$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $465a5c9a36208e91$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $465a5c9a36208e91$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $465a5c9a36208e91$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $465a5c9a36208e91$var$releaseCache(previousCache));
}
function $465a5c9a36208e91$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $465a5c9a36208e91$var$releaseCache(current));
}
function $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$465a5c9a36208e91$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $465a5c9a36208e91$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $465a5c9a36208e91$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $465a5c9a36208e91$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $465a5c9a36208e91$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $465a5c9a36208e91$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $465a5c9a36208e91$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $465a5c9a36208e91$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $465a5c9a36208e91$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $465a5c9a36208e91$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $465a5c9a36208e91$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $465a5c9a36208e91$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $465a5c9a36208e91$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $465a5c9a36208e91$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $465a5c9a36208e91$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $465a5c9a36208e91$var$suspenseyCommitFlag = 8192;
function $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $465a5c9a36208e91$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$465a5c9a36208e91$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $465a5c9a36208e91$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $465a5c9a36208e91$var$suspenseyCommitFlag && null !== fiber.memoizedState && $465a5c9a36208e91$var$suspendResource(suspendedState, $465a5c9a36208e91$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $465a5c9a36208e91$var$currentHoistableRoot;
            $465a5c9a36208e91$var$currentHoistableRoot = $465a5c9a36208e91$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $465a5c9a36208e91$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $465a5c9a36208e91$var$suspenseyCommitFlag, $465a5c9a36208e91$var$suspenseyCommitFlag = 16777216, $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $465a5c9a36208e91$var$suspenseyCommitFlag = previousHoistableRoot) : $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $465a5c9a36208e91$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $465a5c9a36208e91$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $465a5c9a36208e91$var$nextEffect = childToDelete;
            $465a5c9a36208e91$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $465a5c9a36208e91$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$465a5c9a36208e91$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $465a5c9a36208e91$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $465a5c9a36208e91$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $465a5c9a36208e91$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $465a5c9a36208e91$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $465a5c9a36208e91$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $465a5c9a36208e91$var$nextEffect = childToDelete;
            $465a5c9a36208e91$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $465a5c9a36208e91$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $465a5c9a36208e91$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $465a5c9a36208e91$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $465a5c9a36208e91$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $465a5c9a36208e91$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $465a5c9a36208e91$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $465a5c9a36208e91$var$nextEffect;){
        var fiber = $465a5c9a36208e91$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $465a5c9a36208e91$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $465a5c9a36208e91$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $465a5c9a36208e91$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $465a5c9a36208e91$var$nextEffect;){
            cache = $465a5c9a36208e91$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $465a5c9a36208e91$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $465a5c9a36208e91$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $465a5c9a36208e91$var$nextEffect = sibling;
                break a;
            }
            $465a5c9a36208e91$var$nextEffect = returnFiber;
        }
    }
}
var $465a5c9a36208e91$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $465a5c9a36208e91$var$readContext($465a5c9a36208e91$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $465a5c9a36208e91$var$readContext($465a5c9a36208e91$var$CacheContext).controller.signal;
    }
}, $465a5c9a36208e91$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $465a5c9a36208e91$var$executionContext = 0, $465a5c9a36208e91$var$workInProgressRoot = null, $465a5c9a36208e91$var$workInProgress = null, $465a5c9a36208e91$var$workInProgressRootRenderLanes = 0, $465a5c9a36208e91$var$workInProgressSuspendedReason = 0, $465a5c9a36208e91$var$workInProgressThrownValue = null, $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings = !1, $465a5c9a36208e91$var$workInProgressRootIsPrerendering = !1, $465a5c9a36208e91$var$workInProgressRootDidAttachPingListener = !1, $465a5c9a36208e91$var$entangledRenderLanes = 0, $465a5c9a36208e91$var$workInProgressRootExitStatus = 0, $465a5c9a36208e91$var$workInProgressRootSkippedLanes = 0, $465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes = 0, $465a5c9a36208e91$var$workInProgressRootPingedLanes = 0, $465a5c9a36208e91$var$workInProgressDeferredLane = 0, $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes = 0, $465a5c9a36208e91$var$workInProgressRootConcurrentErrors = null, $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = null, $465a5c9a36208e91$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $465a5c9a36208e91$var$globalMostRecentFallbackTime = 0, $465a5c9a36208e91$var$globalMostRecentTransitionTime = 0, $465a5c9a36208e91$var$workInProgressRootRenderTargetTime = Infinity, $465a5c9a36208e91$var$workInProgressTransitions = null, $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed = null, $465a5c9a36208e91$var$pendingEffectsStatus = 0, $465a5c9a36208e91$var$pendingEffectsRoot = null, $465a5c9a36208e91$var$pendingFinishedWork = null, $465a5c9a36208e91$var$pendingEffectsLanes = 0, $465a5c9a36208e91$var$pendingEffectsRemainingLanes = 0, $465a5c9a36208e91$var$pendingPassiveTransitions = null, $465a5c9a36208e91$var$pendingRecoverableErrors = null, $465a5c9a36208e91$var$nestedUpdateCount = 0, $465a5c9a36208e91$var$rootWithNestedUpdates = null;
function $465a5c9a36208e91$var$requestUpdateLane() {
    return 0 !== ($465a5c9a36208e91$var$executionContext & 2) && 0 !== $465a5c9a36208e91$var$workInProgressRootRenderLanes ? $465a5c9a36208e91$var$workInProgressRootRenderLanes & -$465a5c9a36208e91$var$workInProgressRootRenderLanes : null !== $465a5c9a36208e91$var$ReactSharedInternals.T ? $465a5c9a36208e91$var$requestTransitionLane() : $465a5c9a36208e91$var$resolveUpdatePriority();
}
function $465a5c9a36208e91$var$requestDeferredLane() {
    if (0 === $465a5c9a36208e91$var$workInProgressDeferredLane) {
        if (0 === ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 536870912) || $465a5c9a36208e91$var$isHydrating) {
            var lane = $465a5c9a36208e91$var$nextTransitionDeferredLane;
            $465a5c9a36208e91$var$nextTransitionDeferredLane <<= 1;
            0 === ($465a5c9a36208e91$var$nextTransitionDeferredLane & 3932160) && ($465a5c9a36208e91$var$nextTransitionDeferredLane = 262144);
            $465a5c9a36208e91$var$workInProgressDeferredLane = lane;
        } else $465a5c9a36208e91$var$workInProgressDeferredLane = 536870912;
    }
    lane = $465a5c9a36208e91$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $465a5c9a36208e91$var$workInProgressDeferredLane;
}
function $465a5c9a36208e91$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $465a5c9a36208e91$var$workInProgressRoot && (2 === $465a5c9a36208e91$var$workInProgressSuspendedReason || 9 === $465a5c9a36208e91$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $465a5c9a36208e91$var$prepareFreshStack(root, 0), $465a5c9a36208e91$var$markRootSuspended(root, $465a5c9a36208e91$var$workInProgressRootRenderLanes, $465a5c9a36208e91$var$workInProgressDeferredLane, !1);
    $465a5c9a36208e91$var$markRootUpdated$1(root, lane);
    if (0 === ($465a5c9a36208e91$var$executionContext & 2) || root !== $465a5c9a36208e91$var$workInProgressRoot) root === $465a5c9a36208e91$var$workInProgressRoot && (0 === ($465a5c9a36208e91$var$executionContext & 2) && ($465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $465a5c9a36208e91$var$workInProgressRootExitStatus && $465a5c9a36208e91$var$markRootSuspended(root, $465a5c9a36208e91$var$workInProgressRootRenderLanes, $465a5c9a36208e91$var$workInProgressDeferredLane, !1)), $465a5c9a36208e91$var$ensureRootIsScheduled(root);
}
function $465a5c9a36208e91$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($465a5c9a36208e91$var$executionContext & 6)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $465a5c9a36208e91$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $465a5c9a36208e91$var$renderRootConcurrent(root$jscomp$0, lanes) : $465a5c9a36208e91$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $465a5c9a36208e91$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $465a5c9a36208e91$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$465a5c9a36208e91$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $465a5c9a36208e91$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $465a5c9a36208e91$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($465a5c9a36208e91$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $465a5c9a36208e91$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($465a5c9a36208e91$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $465a5c9a36208e91$var$workInProgressRootRecoverableErrors;
                            $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $465a5c9a36208e91$var$workInProgressRootRecoverableErrors ? $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $465a5c9a36208e91$var$workInProgressRootRecoverableErrors.push.apply($465a5c9a36208e91$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $465a5c9a36208e91$var$prepareFreshStack(root$jscomp$0, 0);
                $465a5c9a36208e91$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($465a5c9a36208e91$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $465a5c9a36208e91$var$markRootSuspended(shouldTimeSlice, lanes, $465a5c9a36208e91$var$workInProgressDeferredLane, !$465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($465a5c9a36208e91$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $465a5c9a36208e91$var$globalMostRecentFallbackTime + 300 - $465a5c9a36208e91$var$now(), 10 < exitStatus)) {
                    $465a5c9a36208e91$var$markRootSuspended(shouldTimeSlice, lanes, $465a5c9a36208e91$var$workInProgressDeferredLane, !$465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $465a5c9a36208e91$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $465a5c9a36208e91$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $465a5c9a36208e91$var$scheduleTimeout($465a5c9a36208e91$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $465a5c9a36208e91$var$workInProgressRootRecoverableErrors, $465a5c9a36208e91$var$workInProgressTransitions, $465a5c9a36208e91$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $465a5c9a36208e91$var$workInProgressDeferredLane, $465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes, $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes, $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $465a5c9a36208e91$var$commitRootWhenReady(shouldTimeSlice, forceSync, $465a5c9a36208e91$var$workInProgressRootRecoverableErrors, $465a5c9a36208e91$var$workInProgressTransitions, $465a5c9a36208e91$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $465a5c9a36208e91$var$workInProgressDeferredLane, $465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes, $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes, $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $465a5c9a36208e91$var$ensureRootIsScheduled(root$jscomp$0);
}
function $465a5c9a36208e91$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $465a5c9a36208e91$var$noop$1
        };
        $465a5c9a36208e91$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $465a5c9a36208e91$var$globalMostRecentFallbackTime - $465a5c9a36208e91$var$now() : (lanes & 4194048) === lanes ? $465a5c9a36208e91$var$globalMostRecentTransitionTime - $465a5c9a36208e91$var$now() : 0;
        timeoutOffset = $465a5c9a36208e91$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $465a5c9a36208e91$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($465a5c9a36208e91$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $465a5c9a36208e91$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $465a5c9a36208e91$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $465a5c9a36208e91$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$465a5c9a36208e91$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $465a5c9a36208e91$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$465a5c9a36208e91$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $465a5c9a36208e91$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $465a5c9a36208e91$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $465a5c9a36208e91$var$flushSyncWork$1() {
    return 0 === ($465a5c9a36208e91$var$executionContext & 6) ? ($465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $465a5c9a36208e91$var$resetWorkInProgressStack() {
    if (null !== $465a5c9a36208e91$var$workInProgress) {
        if (0 === $465a5c9a36208e91$var$workInProgressSuspendedReason) var interruptedWork = $465a5c9a36208e91$var$workInProgress.return;
        else interruptedWork = $465a5c9a36208e91$var$workInProgress, $465a5c9a36208e91$var$lastContextDependency = $465a5c9a36208e91$var$currentlyRenderingFiber$1 = null, $465a5c9a36208e91$var$resetHooksOnUnwind(interruptedWork), $465a5c9a36208e91$var$thenableState$1 = null, $465a5c9a36208e91$var$thenableIndexCounter$1 = 0, interruptedWork = $465a5c9a36208e91$var$workInProgress;
        for(; null !== interruptedWork;)$465a5c9a36208e91$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $465a5c9a36208e91$var$workInProgress = null;
    }
}
function $465a5c9a36208e91$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $465a5c9a36208e91$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $465a5c9a36208e91$var$pendingEffectsLanes = 0;
    $465a5c9a36208e91$var$resetWorkInProgressStack();
    $465a5c9a36208e91$var$workInProgressRoot = root;
    $465a5c9a36208e91$var$workInProgress = timeoutHandle = $465a5c9a36208e91$var$createWorkInProgress(root.current, null);
    $465a5c9a36208e91$var$workInProgressRootRenderLanes = lanes;
    $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
    $465a5c9a36208e91$var$workInProgressThrownValue = null;
    $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $465a5c9a36208e91$var$workInProgressRootIsPrerendering = $465a5c9a36208e91$var$checkIfRootIsPrerendering(root, lanes);
    $465a5c9a36208e91$var$workInProgressRootDidAttachPingListener = !1;
    $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes = $465a5c9a36208e91$var$workInProgressDeferredLane = $465a5c9a36208e91$var$workInProgressRootPingedLanes = $465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes = $465a5c9a36208e91$var$workInProgressRootSkippedLanes = $465a5c9a36208e91$var$workInProgressRootExitStatus = 0;
    $465a5c9a36208e91$var$workInProgressRootRecoverableErrors = $465a5c9a36208e91$var$workInProgressRootConcurrentErrors = null;
    $465a5c9a36208e91$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $465a5c9a36208e91$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $465a5c9a36208e91$var$entangledRenderLanes = lanes;
    $465a5c9a36208e91$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $465a5c9a36208e91$var$handleThrow(root, thrownValue) {
    $465a5c9a36208e91$var$currentlyRenderingFiber = null;
    $465a5c9a36208e91$var$ReactSharedInternals.H = $465a5c9a36208e91$var$ContextOnlyDispatcher;
    thrownValue === $465a5c9a36208e91$var$SuspenseException || thrownValue === $465a5c9a36208e91$var$SuspenseActionException ? (thrownValue = $465a5c9a36208e91$var$getSuspendedThenable(), $465a5c9a36208e91$var$workInProgressSuspendedReason = 3) : thrownValue === $465a5c9a36208e91$var$SuspenseyCommitException ? (thrownValue = $465a5c9a36208e91$var$getSuspendedThenable(), $465a5c9a36208e91$var$workInProgressSuspendedReason = 4) : $465a5c9a36208e91$var$workInProgressSuspendedReason = thrownValue === $465a5c9a36208e91$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $465a5c9a36208e91$var$workInProgressThrownValue = thrownValue;
    null === $465a5c9a36208e91$var$workInProgress && ($465a5c9a36208e91$var$workInProgressRootExitStatus = 1, $465a5c9a36208e91$var$logUncaughtError(root, $465a5c9a36208e91$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $465a5c9a36208e91$var$shouldRemainOnPreviousScreen() {
    var handler = $465a5c9a36208e91$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 4194048) === $465a5c9a36208e91$var$workInProgressRootRenderLanes ? null === $465a5c9a36208e91$var$shellBoundary ? !0 : !1 : ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 62914560) === $465a5c9a36208e91$var$workInProgressRootRenderLanes || 0 !== ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 536870912) ? handler === $465a5c9a36208e91$var$shellBoundary : !1;
}
function $465a5c9a36208e91$var$pushDispatcher() {
    var prevDispatcher = $465a5c9a36208e91$var$ReactSharedInternals.H;
    $465a5c9a36208e91$var$ReactSharedInternals.H = $465a5c9a36208e91$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $465a5c9a36208e91$var$ContextOnlyDispatcher : prevDispatcher;
}
function $465a5c9a36208e91$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $465a5c9a36208e91$var$ReactSharedInternals.A;
    $465a5c9a36208e91$var$ReactSharedInternals.A = $465a5c9a36208e91$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $465a5c9a36208e91$var$renderDidSuspendDelayIfPossible() {
    $465a5c9a36208e91$var$workInProgressRootExitStatus = 4;
    $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings || ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 4194048) !== $465a5c9a36208e91$var$workInProgressRootRenderLanes && null !== $465a5c9a36208e91$var$suspenseHandlerStackCursor.current || ($465a5c9a36208e91$var$workInProgressRootIsPrerendering = !0);
    0 === ($465a5c9a36208e91$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($465a5c9a36208e91$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $465a5c9a36208e91$var$workInProgressRoot || $465a5c9a36208e91$var$markRootSuspended($465a5c9a36208e91$var$workInProgressRoot, $465a5c9a36208e91$var$workInProgressRootRenderLanes, $465a5c9a36208e91$var$workInProgressDeferredLane, !1);
}
function $465a5c9a36208e91$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $465a5c9a36208e91$var$executionContext;
    $465a5c9a36208e91$var$executionContext |= 2;
    var prevDispatcher = $465a5c9a36208e91$var$pushDispatcher(), prevAsyncDispatcher = $465a5c9a36208e91$var$pushAsyncDispatcher();
    if ($465a5c9a36208e91$var$workInProgressRoot !== root || $465a5c9a36208e91$var$workInProgressRootRenderLanes !== lanes) $465a5c9a36208e91$var$workInProgressTransitions = null, $465a5c9a36208e91$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $465a5c9a36208e91$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $465a5c9a36208e91$var$workInProgressSuspendedReason && null !== $465a5c9a36208e91$var$workInProgress) {
            var unitOfWork = $465a5c9a36208e91$var$workInProgress, thrownValue = $465a5c9a36208e91$var$workInProgressThrownValue;
            switch($465a5c9a36208e91$var$workInProgressSuspendedReason){
                case 8:
                    $465a5c9a36208e91$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $465a5c9a36208e91$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $465a5c9a36208e91$var$workInProgressSuspendedReason;
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                    $465a5c9a36208e91$var$workInProgressThrownValue = null;
                    $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $465a5c9a36208e91$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $465a5c9a36208e91$var$workInProgressSuspendedReason, $465a5c9a36208e91$var$workInProgressSuspendedReason = 0, $465a5c9a36208e91$var$workInProgressThrownValue = null, $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $465a5c9a36208e91$var$workLoopSync();
        exitStatus = $465a5c9a36208e91$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $465a5c9a36208e91$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $465a5c9a36208e91$var$lastContextDependency = $465a5c9a36208e91$var$currentlyRenderingFiber$1 = null;
    $465a5c9a36208e91$var$executionContext = prevExecutionContext;
    $465a5c9a36208e91$var$ReactSharedInternals.H = prevDispatcher;
    $465a5c9a36208e91$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $465a5c9a36208e91$var$workInProgress && ($465a5c9a36208e91$var$workInProgressRoot = null, $465a5c9a36208e91$var$workInProgressRootRenderLanes = 0, $465a5c9a36208e91$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $465a5c9a36208e91$var$workLoopSync() {
    for(; null !== $465a5c9a36208e91$var$workInProgress;)$465a5c9a36208e91$var$performUnitOfWork($465a5c9a36208e91$var$workInProgress);
}
function $465a5c9a36208e91$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $465a5c9a36208e91$var$executionContext;
    $465a5c9a36208e91$var$executionContext |= 2;
    var prevDispatcher = $465a5c9a36208e91$var$pushDispatcher(), prevAsyncDispatcher = $465a5c9a36208e91$var$pushAsyncDispatcher();
    $465a5c9a36208e91$var$workInProgressRoot !== root || $465a5c9a36208e91$var$workInProgressRootRenderLanes !== lanes ? ($465a5c9a36208e91$var$workInProgressTransitions = null, $465a5c9a36208e91$var$workInProgressRootRenderTargetTime = $465a5c9a36208e91$var$now() + 500, $465a5c9a36208e91$var$prepareFreshStack(root, lanes)) : $465a5c9a36208e91$var$workInProgressRootIsPrerendering = $465a5c9a36208e91$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $465a5c9a36208e91$var$workInProgressSuspendedReason && null !== $465a5c9a36208e91$var$workInProgress) {
            lanes = $465a5c9a36208e91$var$workInProgress;
            var thrownValue = $465a5c9a36208e91$var$workInProgressThrownValue;
            b: switch($465a5c9a36208e91$var$workInProgressSuspendedReason){
                case 1:
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                    $465a5c9a36208e91$var$workInProgressThrownValue = null;
                    $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($465a5c9a36208e91$var$isThenableResolved(thrownValue)) {
                        $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                        $465a5c9a36208e91$var$workInProgressThrownValue = null;
                        $465a5c9a36208e91$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $465a5c9a36208e91$var$workInProgressSuspendedReason && 9 !== $465a5c9a36208e91$var$workInProgressSuspendedReason || $465a5c9a36208e91$var$workInProgressRoot !== root || ($465a5c9a36208e91$var$workInProgressSuspendedReason = 7);
                        $465a5c9a36208e91$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $465a5c9a36208e91$var$isThenableResolved(thrownValue) ? ($465a5c9a36208e91$var$workInProgressSuspendedReason = 0, $465a5c9a36208e91$var$workInProgressThrownValue = null, $465a5c9a36208e91$var$replaySuspendedUnitOfWork(lanes)) : ($465a5c9a36208e91$var$workInProgressSuspendedReason = 0, $465a5c9a36208e91$var$workInProgressThrownValue = null, $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($465a5c9a36208e91$var$workInProgress.tag){
                        case 26:
                            resource = $465a5c9a36208e91$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $465a5c9a36208e91$var$workInProgress;
                            if (resource ? $465a5c9a36208e91$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                                $465a5c9a36208e91$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $465a5c9a36208e91$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($465a5c9a36208e91$var$workInProgress = returnFiber, $465a5c9a36208e91$var$completeUnitOfWork(returnFiber)) : $465a5c9a36208e91$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                    $465a5c9a36208e91$var$workInProgressThrownValue = null;
                    $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $465a5c9a36208e91$var$workInProgressSuspendedReason = 0;
                    $465a5c9a36208e91$var$workInProgressThrownValue = null;
                    $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $465a5c9a36208e91$var$resetWorkInProgressStack();
                    $465a5c9a36208e91$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(462));
            }
        }
        $465a5c9a36208e91$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $465a5c9a36208e91$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $465a5c9a36208e91$var$lastContextDependency = $465a5c9a36208e91$var$currentlyRenderingFiber$1 = null;
    $465a5c9a36208e91$var$ReactSharedInternals.H = prevDispatcher;
    $465a5c9a36208e91$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $465a5c9a36208e91$var$executionContext = prevExecutionContext;
    if (null !== $465a5c9a36208e91$var$workInProgress) return 0;
    $465a5c9a36208e91$var$workInProgressRoot = null;
    $465a5c9a36208e91$var$workInProgressRootRenderLanes = 0;
    $465a5c9a36208e91$var$finishQueueingConcurrentUpdates();
    return $465a5c9a36208e91$var$workInProgressRootExitStatus;
}
function $465a5c9a36208e91$var$workLoopConcurrentByScheduler() {
    for(; null !== $465a5c9a36208e91$var$workInProgress && !$465a5c9a36208e91$var$shouldYield();)$465a5c9a36208e91$var$performUnitOfWork($465a5c9a36208e91$var$workInProgress);
}
function $465a5c9a36208e91$var$performUnitOfWork(unitOfWork) {
    var next = $465a5c9a36208e91$var$beginWork(unitOfWork.alternate, unitOfWork, $465a5c9a36208e91$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $465a5c9a36208e91$var$completeUnitOfWork(unitOfWork) : $465a5c9a36208e91$var$workInProgress = next;
}
function $465a5c9a36208e91$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $465a5c9a36208e91$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $465a5c9a36208e91$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $465a5c9a36208e91$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $465a5c9a36208e91$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $465a5c9a36208e91$var$resetHooksOnUnwind(next);
        default:
            $465a5c9a36208e91$var$unwindInterruptedWork(current, next), next = $465a5c9a36208e91$var$workInProgress = $465a5c9a36208e91$var$resetWorkInProgress(next, $465a5c9a36208e91$var$entangledRenderLanes), next = $465a5c9a36208e91$var$beginWork(current, next, $465a5c9a36208e91$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $465a5c9a36208e91$var$completeUnitOfWork(unitOfWork) : $465a5c9a36208e91$var$workInProgress = next;
}
function $465a5c9a36208e91$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $465a5c9a36208e91$var$lastContextDependency = $465a5c9a36208e91$var$currentlyRenderingFiber$1 = null;
    $465a5c9a36208e91$var$resetHooksOnUnwind(unitOfWork);
    $465a5c9a36208e91$var$thenableState$1 = null;
    $465a5c9a36208e91$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($465a5c9a36208e91$var$throwException(root, returnFiber, unitOfWork, thrownValue, $465a5c9a36208e91$var$workInProgressRootRenderLanes)) {
            $465a5c9a36208e91$var$workInProgressRootExitStatus = 1;
            $465a5c9a36208e91$var$logUncaughtError(root, $465a5c9a36208e91$var$createCapturedValueAtFiber(thrownValue, root.current));
            $465a5c9a36208e91$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $465a5c9a36208e91$var$workInProgress = returnFiber, error;
        $465a5c9a36208e91$var$workInProgressRootExitStatus = 1;
        $465a5c9a36208e91$var$logUncaughtError(root, $465a5c9a36208e91$var$createCapturedValueAtFiber(thrownValue, root.current));
        $465a5c9a36208e91$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($465a5c9a36208e91$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($465a5c9a36208e91$var$workInProgressRootIsPrerendering || 0 !== ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $465a5c9a36208e91$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $465a5c9a36208e91$var$unwindUnitOfWork(unitOfWork, root);
    } else $465a5c9a36208e91$var$completeUnitOfWork(unitOfWork);
}
function $465a5c9a36208e91$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $465a5c9a36208e91$var$unwindUnitOfWork(completedWork, $465a5c9a36208e91$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $465a5c9a36208e91$var$completeWork(completedWork.alternate, completedWork, $465a5c9a36208e91$var$entangledRenderLanes);
        if (null !== next) {
            $465a5c9a36208e91$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $465a5c9a36208e91$var$workInProgress = completedWork;
            return;
        }
        $465a5c9a36208e91$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $465a5c9a36208e91$var$workInProgressRootExitStatus && ($465a5c9a36208e91$var$workInProgressRootExitStatus = 5);
}
function $465a5c9a36208e91$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $465a5c9a36208e91$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $465a5c9a36208e91$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $465a5c9a36208e91$var$workInProgress = unitOfWork;
            return;
        }
        $465a5c9a36208e91$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $465a5c9a36208e91$var$workInProgressRootExitStatus = 6;
    $465a5c9a36208e91$var$workInProgress = null;
}
function $465a5c9a36208e91$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $465a5c9a36208e91$var$flushPendingEffects();
    while (0 !== $465a5c9a36208e91$var$pendingEffectsStatus);
    if (0 !== ($465a5c9a36208e91$var$executionContext & 6)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $465a5c9a36208e91$var$concurrentlyUpdatedLanes;
        $465a5c9a36208e91$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $465a5c9a36208e91$var$workInProgressRoot && ($465a5c9a36208e91$var$workInProgress = $465a5c9a36208e91$var$workInProgressRoot = null, $465a5c9a36208e91$var$workInProgressRootRenderLanes = 0);
        $465a5c9a36208e91$var$pendingFinishedWork = finishedWork;
        $465a5c9a36208e91$var$pendingEffectsRoot = root;
        $465a5c9a36208e91$var$pendingEffectsLanes = lanes;
        $465a5c9a36208e91$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $465a5c9a36208e91$var$pendingPassiveTransitions = transitions;
        $465a5c9a36208e91$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $465a5c9a36208e91$var$scheduleCallback$1($465a5c9a36208e91$var$NormalPriority$1, function() {
            $465a5c9a36208e91$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $465a5c9a36208e91$var$ReactSharedInternals.T;
            $465a5c9a36208e91$var$ReactSharedInternals.T = null;
            transitions = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
            $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $465a5c9a36208e91$var$executionContext;
            $465a5c9a36208e91$var$executionContext |= 4;
            try {
                $465a5c9a36208e91$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $465a5c9a36208e91$var$executionContext = spawnedLane, $465a5c9a36208e91$var$ReactDOMSharedInternals.p = transitions, $465a5c9a36208e91$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $465a5c9a36208e91$var$pendingEffectsStatus = 1;
        $465a5c9a36208e91$var$flushMutationEffects();
        $465a5c9a36208e91$var$flushLayoutEffects();
        $465a5c9a36208e91$var$flushSpawnedWork();
    }
}
function $465a5c9a36208e91$var$flushMutationEffects() {
    if (1 === $465a5c9a36208e91$var$pendingEffectsStatus) {
        $465a5c9a36208e91$var$pendingEffectsStatus = 0;
        var root = $465a5c9a36208e91$var$pendingEffectsRoot, finishedWork = $465a5c9a36208e91$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $465a5c9a36208e91$var$ReactSharedInternals.T;
            $465a5c9a36208e91$var$ReactSharedInternals.T = null;
            var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
            $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $465a5c9a36208e91$var$executionContext;
            $465a5c9a36208e91$var$executionContext |= 4;
            try {
                $465a5c9a36208e91$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $465a5c9a36208e91$var$selectionInformation, curFocusedElem = $465a5c9a36208e91$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $465a5c9a36208e91$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $465a5c9a36208e91$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $465a5c9a36208e91$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $465a5c9a36208e91$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $465a5c9a36208e91$var$_enabled = !!$465a5c9a36208e91$var$eventsEnabled;
                $465a5c9a36208e91$var$selectionInformation = $465a5c9a36208e91$var$eventsEnabled = null;
            } finally{
                $465a5c9a36208e91$var$executionContext = prevExecutionContext, $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, $465a5c9a36208e91$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $465a5c9a36208e91$var$pendingEffectsStatus = 2;
    }
}
function $465a5c9a36208e91$var$flushLayoutEffects() {
    if (2 === $465a5c9a36208e91$var$pendingEffectsStatus) {
        $465a5c9a36208e91$var$pendingEffectsStatus = 0;
        var root = $465a5c9a36208e91$var$pendingEffectsRoot, finishedWork = $465a5c9a36208e91$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $465a5c9a36208e91$var$ReactSharedInternals.T;
            $465a5c9a36208e91$var$ReactSharedInternals.T = null;
            var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
            $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $465a5c9a36208e91$var$executionContext;
            $465a5c9a36208e91$var$executionContext |= 4;
            try {
                $465a5c9a36208e91$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $465a5c9a36208e91$var$executionContext = prevExecutionContext, $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, $465a5c9a36208e91$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $465a5c9a36208e91$var$pendingEffectsStatus = 3;
    }
}
function $465a5c9a36208e91$var$flushSpawnedWork() {
    if (4 === $465a5c9a36208e91$var$pendingEffectsStatus || 3 === $465a5c9a36208e91$var$pendingEffectsStatus) {
        $465a5c9a36208e91$var$pendingEffectsStatus = 0;
        $465a5c9a36208e91$var$requestPaint();
        var root = $465a5c9a36208e91$var$pendingEffectsRoot, finishedWork = $465a5c9a36208e91$var$pendingFinishedWork, lanes = $465a5c9a36208e91$var$pendingEffectsLanes, recoverableErrors = $465a5c9a36208e91$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $465a5c9a36208e91$var$pendingEffectsStatus = 5 : ($465a5c9a36208e91$var$pendingEffectsStatus = 0, $465a5c9a36208e91$var$pendingFinishedWork = $465a5c9a36208e91$var$pendingEffectsRoot = null, $465a5c9a36208e91$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $465a5c9a36208e91$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($465a5c9a36208e91$var$injectedHook && "function" === typeof $465a5c9a36208e91$var$injectedHook.onCommitFiberRoot) try {
            $465a5c9a36208e91$var$injectedHook.onCommitFiberRoot($465a5c9a36208e91$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $465a5c9a36208e91$var$ReactSharedInternals.T;
            remainingLanes = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
            $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 2;
            $465a5c9a36208e91$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $465a5c9a36208e91$var$ReactSharedInternals.T = finishedWork, $465a5c9a36208e91$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($465a5c9a36208e91$var$pendingEffectsLanes & 3) && $465a5c9a36208e91$var$flushPendingEffects();
        $465a5c9a36208e91$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $465a5c9a36208e91$var$rootWithNestedUpdates ? $465a5c9a36208e91$var$nestedUpdateCount++ : ($465a5c9a36208e91$var$nestedUpdateCount = 0, $465a5c9a36208e91$var$rootWithNestedUpdates = root) : $465a5c9a36208e91$var$nestedUpdateCount = 0;
        $465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $465a5c9a36208e91$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $465a5c9a36208e91$var$releaseCache(remainingLanes)));
}
function $465a5c9a36208e91$var$flushPendingEffects() {
    $465a5c9a36208e91$var$flushMutationEffects();
    $465a5c9a36208e91$var$flushLayoutEffects();
    $465a5c9a36208e91$var$flushSpawnedWork();
    return $465a5c9a36208e91$var$flushPassiveEffects();
}
function $465a5c9a36208e91$var$flushPassiveEffects() {
    if (5 !== $465a5c9a36208e91$var$pendingEffectsStatus) return !1;
    var root = $465a5c9a36208e91$var$pendingEffectsRoot, remainingLanes = $465a5c9a36208e91$var$pendingEffectsRemainingLanes;
    $465a5c9a36208e91$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $465a5c9a36208e91$var$lanesToEventPriority($465a5c9a36208e91$var$pendingEffectsLanes), prevTransition = $465a5c9a36208e91$var$ReactSharedInternals.T, previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    try {
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $465a5c9a36208e91$var$ReactSharedInternals.T = null;
        renderPriority = $465a5c9a36208e91$var$pendingPassiveTransitions;
        $465a5c9a36208e91$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $465a5c9a36208e91$var$pendingEffectsRoot, lanes = $465a5c9a36208e91$var$pendingEffectsLanes;
        $465a5c9a36208e91$var$pendingEffectsStatus = 0;
        $465a5c9a36208e91$var$pendingFinishedWork = $465a5c9a36208e91$var$pendingEffectsRoot = null;
        $465a5c9a36208e91$var$pendingEffectsLanes = 0;
        if (0 !== ($465a5c9a36208e91$var$executionContext & 6)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(331));
        var prevExecutionContext = $465a5c9a36208e91$var$executionContext;
        $465a5c9a36208e91$var$executionContext |= 4;
        $465a5c9a36208e91$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $465a5c9a36208e91$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $465a5c9a36208e91$var$executionContext = prevExecutionContext;
        $465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($465a5c9a36208e91$var$injectedHook && "function" === typeof $465a5c9a36208e91$var$injectedHook.onPostCommitFiberRoot) try {
            $465a5c9a36208e91$var$injectedHook.onPostCommitFiberRoot($465a5c9a36208e91$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, $465a5c9a36208e91$var$ReactSharedInternals.T = prevTransition, $465a5c9a36208e91$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $465a5c9a36208e91$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $465a5c9a36208e91$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $465a5c9a36208e91$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $465a5c9a36208e91$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($465a5c9a36208e91$var$markRootUpdated$1(rootFiber, 2), $465a5c9a36208e91$var$ensureRootIsScheduled(rootFiber));
}
function $465a5c9a36208e91$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $465a5c9a36208e91$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $465a5c9a36208e91$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed || !$465a5c9a36208e91$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $465a5c9a36208e91$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $465a5c9a36208e91$var$createClassErrorUpdate(2);
                instance = $465a5c9a36208e91$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($465a5c9a36208e91$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $465a5c9a36208e91$var$markRootUpdated$1(instance, 2), $465a5c9a36208e91$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $465a5c9a36208e91$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $465a5c9a36208e91$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($465a5c9a36208e91$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $465a5c9a36208e91$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $465a5c9a36208e91$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $465a5c9a36208e91$var$workInProgressRoot === root && ($465a5c9a36208e91$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $465a5c9a36208e91$var$workInProgressRootExitStatus || 3 === $465a5c9a36208e91$var$workInProgressRootExitStatus && ($465a5c9a36208e91$var$workInProgressRootRenderLanes & 62914560) === $465a5c9a36208e91$var$workInProgressRootRenderLanes && 300 > $465a5c9a36208e91$var$now() - $465a5c9a36208e91$var$globalMostRecentFallbackTime ? 0 === ($465a5c9a36208e91$var$executionContext & 2) && $465a5c9a36208e91$var$prepareFreshStack(root, 0) : $465a5c9a36208e91$var$workInProgressRootPingedLanes |= pingedLanes, $465a5c9a36208e91$var$workInProgressSuspendedRetryLanes === $465a5c9a36208e91$var$workInProgressRootRenderLanes && ($465a5c9a36208e91$var$workInProgressSuspendedRetryLanes = 0));
    $465a5c9a36208e91$var$ensureRootIsScheduled(root);
}
function $465a5c9a36208e91$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $465a5c9a36208e91$var$claimNextRetryLane());
    boundaryFiber = $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($465a5c9a36208e91$var$markRootUpdated$1(boundaryFiber, retryLane), $465a5c9a36208e91$var$ensureRootIsScheduled(boundaryFiber));
}
function $465a5c9a36208e91$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $465a5c9a36208e91$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $465a5c9a36208e91$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $465a5c9a36208e91$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $465a5c9a36208e91$var$scheduleCallback$1(priorityLevel, callback) {
    return $465a5c9a36208e91$var$scheduleCallback$3(priorityLevel, callback);
}
var $465a5c9a36208e91$var$firstScheduledRoot = null, $465a5c9a36208e91$var$lastScheduledRoot = null, $465a5c9a36208e91$var$didScheduleMicrotask = !1, $465a5c9a36208e91$var$mightHavePendingSyncWork = !1, $465a5c9a36208e91$var$isFlushingWork = !1, $465a5c9a36208e91$var$currentEventTransitionLane = 0;
function $465a5c9a36208e91$var$ensureRootIsScheduled(root) {
    root !== $465a5c9a36208e91$var$lastScheduledRoot && null === root.next && (null === $465a5c9a36208e91$var$lastScheduledRoot ? $465a5c9a36208e91$var$firstScheduledRoot = $465a5c9a36208e91$var$lastScheduledRoot = root : $465a5c9a36208e91$var$lastScheduledRoot = $465a5c9a36208e91$var$lastScheduledRoot.next = root);
    $465a5c9a36208e91$var$mightHavePendingSyncWork = !0;
    $465a5c9a36208e91$var$didScheduleMicrotask || ($465a5c9a36208e91$var$didScheduleMicrotask = !0, $465a5c9a36208e91$var$scheduleImmediateRootScheduleTask());
}
function $465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$465a5c9a36208e91$var$isFlushingWork && $465a5c9a36208e91$var$mightHavePendingSyncWork) {
        $465a5c9a36208e91$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $465a5c9a36208e91$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $465a5c9a36208e91$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $465a5c9a36208e91$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $465a5c9a36208e91$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $465a5c9a36208e91$var$getNextLanes(root$170, root$170 === $465a5c9a36208e91$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $465a5c9a36208e91$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $465a5c9a36208e91$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $465a5c9a36208e91$var$isFlushingWork = !1;
    }
}
function $465a5c9a36208e91$var$processRootScheduleInImmediateTask() {
    $465a5c9a36208e91$var$processRootScheduleInMicrotask();
}
function $465a5c9a36208e91$var$processRootScheduleInMicrotask() {
    $465a5c9a36208e91$var$mightHavePendingSyncWork = $465a5c9a36208e91$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $465a5c9a36208e91$var$currentEventTransitionLane && $465a5c9a36208e91$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $465a5c9a36208e91$var$currentEventTransitionLane);
    for(var currentTime = $465a5c9a36208e91$var$now(), prev = null, root = $465a5c9a36208e91$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $465a5c9a36208e91$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $465a5c9a36208e91$var$firstScheduledRoot = next : prev.next = next, null === next && ($465a5c9a36208e91$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $465a5c9a36208e91$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $465a5c9a36208e91$var$pendingEffectsStatus && 5 !== $465a5c9a36208e91$var$pendingEffectsStatus || $465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $465a5c9a36208e91$var$currentEventTransitionLane && ($465a5c9a36208e91$var$currentEventTransitionLane = 0);
}
function $465a5c9a36208e91$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $465a5c9a36208e91$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $465a5c9a36208e91$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $465a5c9a36208e91$var$workInProgressRoot;
    suspendedLanes = $465a5c9a36208e91$var$workInProgressRootRenderLanes;
    suspendedLanes = $465a5c9a36208e91$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $465a5c9a36208e91$var$workInProgressSuspendedReason || 9 === $465a5c9a36208e91$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $465a5c9a36208e91$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $465a5c9a36208e91$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $465a5c9a36208e91$var$cancelCallback$1(pingedLanes);
        switch($465a5c9a36208e91$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $465a5c9a36208e91$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $465a5c9a36208e91$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $465a5c9a36208e91$var$IdlePriority;
                break;
            default:
                suspendedLanes = $465a5c9a36208e91$var$NormalPriority$1;
        }
        pingedLanes = $465a5c9a36208e91$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $465a5c9a36208e91$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $465a5c9a36208e91$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $465a5c9a36208e91$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $465a5c9a36208e91$var$pendingEffectsStatus && 5 !== $465a5c9a36208e91$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($465a5c9a36208e91$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $465a5c9a36208e91$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $465a5c9a36208e91$var$getNextLanes(root, root === $465a5c9a36208e91$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $465a5c9a36208e91$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $465a5c9a36208e91$var$scheduleTaskForRootDuringMicrotask(root, $465a5c9a36208e91$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $465a5c9a36208e91$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $465a5c9a36208e91$var$performSyncWorkOnRoot(root, lanes) {
    if ($465a5c9a36208e91$var$flushPendingEffects()) return null;
    $465a5c9a36208e91$var$performWorkOnRoot(root, lanes, !0);
}
function $465a5c9a36208e91$var$scheduleImmediateRootScheduleTask() {
    $465a5c9a36208e91$var$scheduleMicrotask(function() {
        0 !== ($465a5c9a36208e91$var$executionContext & 6) ? $465a5c9a36208e91$var$scheduleCallback$3($465a5c9a36208e91$var$ImmediatePriority, $465a5c9a36208e91$var$processRootScheduleInImmediateTask) : $465a5c9a36208e91$var$processRootScheduleInMicrotask();
    });
}
function $465a5c9a36208e91$var$requestTransitionLane() {
    if (0 === $465a5c9a36208e91$var$currentEventTransitionLane) {
        var actionScopeLane = $465a5c9a36208e91$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $465a5c9a36208e91$var$nextTransitionUpdateLane, $465a5c9a36208e91$var$nextTransitionUpdateLane <<= 1, 0 === ($465a5c9a36208e91$var$nextTransitionUpdateLane & 261888) && ($465a5c9a36208e91$var$nextTransitionUpdateLane = 256));
        $465a5c9a36208e91$var$currentEventTransitionLane = actionScopeLane;
    }
    return $465a5c9a36208e91$var$currentEventTransitionLane;
}
function $465a5c9a36208e91$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $465a5c9a36208e91$var$sanitizeURL("" + actionProp);
}
function $465a5c9a36208e91$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $465a5c9a36208e91$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $465a5c9a36208e91$var$coerceFormActionProp((nativeEventTarget[$465a5c9a36208e91$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$465a5c9a36208e91$var$internalPropsKey] || null) ? $465a5c9a36208e91$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $465a5c9a36208e91$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $465a5c9a36208e91$var$currentEventTransitionLane) {
                                var formData = submitter ? $465a5c9a36208e91$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $465a5c9a36208e91$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $465a5c9a36208e91$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $465a5c9a36208e91$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $465a5c9a36208e91$var$i$jscomp$inline_1577 = 0; $465a5c9a36208e91$var$i$jscomp$inline_1577 < $465a5c9a36208e91$var$simpleEventPluginEvents.length; $465a5c9a36208e91$var$i$jscomp$inline_1577++){
    var $465a5c9a36208e91$var$eventName$jscomp$inline_1578 = $465a5c9a36208e91$var$simpleEventPluginEvents[$465a5c9a36208e91$var$i$jscomp$inline_1577], $465a5c9a36208e91$var$domEventName$jscomp$inline_1579 = $465a5c9a36208e91$var$eventName$jscomp$inline_1578.toLowerCase(), $465a5c9a36208e91$var$capitalizedEvent$jscomp$inline_1580 = $465a5c9a36208e91$var$eventName$jscomp$inline_1578[0].toUpperCase() + $465a5c9a36208e91$var$eventName$jscomp$inline_1578.slice(1);
    $465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$domEventName$jscomp$inline_1579, "on" + $465a5c9a36208e91$var$capitalizedEvent$jscomp$inline_1580);
}
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$ANIMATION_END, "onAnimationEnd");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$ANIMATION_ITERATION, "onAnimationIteration");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$ANIMATION_START, "onAnimationStart");
$465a5c9a36208e91$var$registerSimpleEvent("dblclick", "onDoubleClick");
$465a5c9a36208e91$var$registerSimpleEvent("focusin", "onFocus");
$465a5c9a36208e91$var$registerSimpleEvent("focusout", "onBlur");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$TRANSITION_RUN, "onTransitionRun");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$TRANSITION_START, "onTransitionStart");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$TRANSITION_CANCEL, "onTransitionCancel");
$465a5c9a36208e91$var$registerSimpleEvent($465a5c9a36208e91$var$TRANSITION_END, "onTransitionEnd");
$465a5c9a36208e91$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$465a5c9a36208e91$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$465a5c9a36208e91$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$465a5c9a36208e91$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$465a5c9a36208e91$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$465a5c9a36208e91$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$465a5c9a36208e91$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$465a5c9a36208e91$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$465a5c9a36208e91$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$465a5c9a36208e91$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $465a5c9a36208e91$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $465a5c9a36208e91$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($465a5c9a36208e91$var$mediaEventTypes));
function $465a5c9a36208e91$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $465a5c9a36208e91$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $465a5c9a36208e91$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $465a5c9a36208e91$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$465a5c9a36208e91$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$465a5c9a36208e91$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($465a5c9a36208e91$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $465a5c9a36208e91$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $465a5c9a36208e91$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $465a5c9a36208e91$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $465a5c9a36208e91$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$465a5c9a36208e91$var$listeningMarker]) {
        rootContainerElement[$465a5c9a36208e91$var$listeningMarker] = !0;
        $465a5c9a36208e91$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($465a5c9a36208e91$var$nonDelegatedEvents.has(domEventName) || $465a5c9a36208e91$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $465a5c9a36208e91$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$465a5c9a36208e91$var$listeningMarker] || (ownerDocument[$465a5c9a36208e91$var$listeningMarker] = !0, $465a5c9a36208e91$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $465a5c9a36208e91$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($465a5c9a36208e91$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $465a5c9a36208e91$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $465a5c9a36208e91$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $465a5c9a36208e91$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$465a5c9a36208e91$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $465a5c9a36208e91$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $465a5c9a36208e91$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $465a5c9a36208e91$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $465a5c9a36208e91$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $465a5c9a36208e91$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $465a5c9a36208e91$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticTouchEvent;
                        break;
                    case $465a5c9a36208e91$var$ANIMATION_END:
                    case $465a5c9a36208e91$var$ANIMATION_ITERATION:
                    case $465a5c9a36208e91$var$ANIMATION_START:
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticAnimationEvent;
                        break;
                    case $465a5c9a36208e91$var$TRANSITION_END:
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $465a5c9a36208e91$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $465a5c9a36208e91$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($465a5c9a36208e91$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $465a5c9a36208e91$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($465a5c9a36208e91$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$465a5c9a36208e91$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $465a5c9a36208e91$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $465a5c9a36208e91$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $465a5c9a36208e91$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $465a5c9a36208e91$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $465a5c9a36208e91$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $465a5c9a36208e91$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $465a5c9a36208e91$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $465a5c9a36208e91$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $465a5c9a36208e91$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $465a5c9a36208e91$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $465a5c9a36208e91$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $465a5c9a36208e91$var$getTargetInstForChangeEvent;
                else if ($465a5c9a36208e91$var$isTextInputElement(reactName)) {
                    if ($465a5c9a36208e91$var$isInputEventSupported) getTargetInstFunc = $465a5c9a36208e91$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $465a5c9a36208e91$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $465a5c9a36208e91$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $465a5c9a36208e91$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $465a5c9a36208e91$var$getTargetInstForChangeEvent) : getTargetInstFunc = $465a5c9a36208e91$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $465a5c9a36208e91$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $465a5c9a36208e91$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $465a5c9a36208e91$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($465a5c9a36208e91$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $465a5c9a36208e91$var$activeElement = handleEventFunc, $465a5c9a36208e91$var$activeElementInst = targetInst, $465a5c9a36208e91$var$lastSelection = null;
                    break;
                case "focusout":
                    $465a5c9a36208e91$var$lastSelection = $465a5c9a36208e91$var$activeElementInst = $465a5c9a36208e91$var$activeElement = null;
                    break;
                case "mousedown":
                    $465a5c9a36208e91$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $465a5c9a36208e91$var$mouseDown = !1;
                    $465a5c9a36208e91$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($465a5c9a36208e91$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $465a5c9a36208e91$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($465a5c9a36208e91$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $465a5c9a36208e91$var$isComposing ? $465a5c9a36208e91$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($465a5c9a36208e91$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($465a5c9a36208e91$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $465a5c9a36208e91$var$isComposing && (fallbackData = $465a5c9a36208e91$var$getData()) : ($465a5c9a36208e91$var$root = nativeEventTarget, $465a5c9a36208e91$var$startText = "value" in $465a5c9a36208e91$var$root ? $465a5c9a36208e91$var$root.value : $465a5c9a36208e91$var$root.textContent, $465a5c9a36208e91$var$isComposing = !0)), handleEventFunc = $465a5c9a36208e91$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $465a5c9a36208e91$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $465a5c9a36208e91$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $465a5c9a36208e91$var$canUseTextInputEvent ? $465a5c9a36208e91$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $465a5c9a36208e91$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $465a5c9a36208e91$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $465a5c9a36208e91$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $465a5c9a36208e91$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $465a5c9a36208e91$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $465a5c9a36208e91$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $465a5c9a36208e91$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $465a5c9a36208e91$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($465a5c9a36208e91$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $465a5c9a36208e91$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($465a5c9a36208e91$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $465a5c9a36208e91$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $465a5c9a36208e91$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $465a5c9a36208e91$var$getListener(target, registrationName), null != stateNode && listeners.unshift($465a5c9a36208e91$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $465a5c9a36208e91$var$getListener(target, registrationName), null != stateNode && listeners.push($465a5c9a36208e91$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $465a5c9a36208e91$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $465a5c9a36208e91$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $465a5c9a36208e91$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($465a5c9a36208e91$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($465a5c9a36208e91$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $465a5c9a36208e91$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $465a5c9a36208e91$var$normalizeMarkupForTextOrAttribute(clientText);
    return $465a5c9a36208e91$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $465a5c9a36208e91$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $465a5c9a36208e91$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $465a5c9a36208e91$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $465a5c9a36208e91$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $465a5c9a36208e91$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $465a5c9a36208e91$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $465a5c9a36208e91$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $465a5c9a36208e91$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $465a5c9a36208e91$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $465a5c9a36208e91$var$setProp(domElement, tag, "name", props.name, props, null), $465a5c9a36208e91$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $465a5c9a36208e91$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $465a5c9a36208e91$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($465a5c9a36208e91$var$setProp(domElement, tag, "encType", props.encType, props, null), $465a5c9a36208e91$var$setProp(domElement, tag, "method", props.method, props, null), $465a5c9a36208e91$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $465a5c9a36208e91$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $465a5c9a36208e91$var$noop$1);
            break;
        case "onScroll":
            null != value && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $465a5c9a36208e91$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("toggle", domElement);
            $465a5c9a36208e91$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $465a5c9a36208e91$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $465a5c9a36208e91$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $465a5c9a36208e91$var$aliases.get(key) || key, $465a5c9a36208e91$var$setValueForAttribute(domElement, key, value);
    }
}
function $465a5c9a36208e91$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $465a5c9a36208e91$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $465a5c9a36208e91$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $465a5c9a36208e91$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $465a5c9a36208e91$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $465a5c9a36208e91$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$465a5c9a36208e91$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$465a5c9a36208e91$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $465a5c9a36208e91$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $465a5c9a36208e91$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("error", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($465a5c9a36208e91$var$formatProdErrorMessage(137, tag));
                    default:
                        $465a5c9a36208e91$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $465a5c9a36208e91$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $465a5c9a36208e91$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $465a5c9a36208e91$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $465a5c9a36208e91$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $465a5c9a36208e91$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $465a5c9a36208e91$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(91));
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $465a5c9a36208e91$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("toggle", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("cancel", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $465a5c9a36208e91$var$mediaEventTypes.length; hasSrc++)$465a5c9a36208e91$var$listenToNonDelegatedEvent($465a5c9a36208e91$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("error", domElement);
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $465a5c9a36208e91$var$listenToNonDelegatedEvent("error", domElement), $465a5c9a36208e91$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($465a5c9a36208e91$var$formatProdErrorMessage(137, tag));
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($465a5c9a36208e91$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $465a5c9a36208e91$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $465a5c9a36208e91$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $465a5c9a36208e91$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $465a5c9a36208e91$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $465a5c9a36208e91$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $465a5c9a36208e91$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $465a5c9a36208e91$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $465a5c9a36208e91$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $465a5c9a36208e91$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $465a5c9a36208e91$var$updateOptions(domElement, !!lastProps, tag, !0) : $465a5c9a36208e91$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $465a5c9a36208e91$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $465a5c9a36208e91$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $465a5c9a36208e91$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $465a5c9a36208e91$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($465a5c9a36208e91$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $465a5c9a36208e91$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $465a5c9a36208e91$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $465a5c9a36208e91$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $465a5c9a36208e91$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $465a5c9a36208e91$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $465a5c9a36208e91$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $465a5c9a36208e91$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $465a5c9a36208e91$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $465a5c9a36208e91$var$eventsEnabled = null, $465a5c9a36208e91$var$selectionInformation = null;
function $465a5c9a36208e91$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $465a5c9a36208e91$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $465a5c9a36208e91$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $465a5c9a36208e91$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $465a5c9a36208e91$var$currentPopstateTransitionEvent = null;
function $465a5c9a36208e91$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $465a5c9a36208e91$var$currentPopstateTransitionEvent) return !1;
        $465a5c9a36208e91$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $465a5c9a36208e91$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $465a5c9a36208e91$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $465a5c9a36208e91$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $465a5c9a36208e91$var$localPromise = "function" === typeof Promise ? Promise : void 0, $465a5c9a36208e91$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $465a5c9a36208e91$var$localPromise ? function(callback) {
    return $465a5c9a36208e91$var$localPromise.resolve(null).then(callback).catch($465a5c9a36208e91$var$handleErrorInNextTick);
} : $465a5c9a36208e91$var$scheduleTimeout;
function $465a5c9a36208e91$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $465a5c9a36208e91$var$isSingletonScope(type) {
    return "head" === type;
}
function $465a5c9a36208e91$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $465a5c9a36208e91$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $465a5c9a36208e91$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $465a5c9a36208e91$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$465a5c9a36208e91$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $465a5c9a36208e91$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $465a5c9a36208e91$var$retryIfBlockedOn(hydrationInstance);
}
function $465a5c9a36208e91$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $465a5c9a36208e91$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $465a5c9a36208e91$var$clearContainerSparingly(node);
                $465a5c9a36208e91$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $465a5c9a36208e91$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$465a5c9a36208e91$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $465a5c9a36208e91$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $465a5c9a36208e91$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $465a5c9a36208e91$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $465a5c9a36208e91$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $465a5c9a36208e91$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $465a5c9a36208e91$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $465a5c9a36208e91$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $465a5c9a36208e91$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $465a5c9a36208e91$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $465a5c9a36208e91$var$previousHydratableOnEnteringScopedSingleton = null;
function $465a5c9a36208e91$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $465a5c9a36208e91$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $465a5c9a36208e91$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $465a5c9a36208e91$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $465a5c9a36208e91$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(451));
    }
}
function $465a5c9a36208e91$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $465a5c9a36208e91$var$detachDeletedInstance(instance);
}
var $465a5c9a36208e91$var$preloadPropsMap = new Map(), $465a5c9a36208e91$var$preconnectsSet = new Set();
function $465a5c9a36208e91$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $465a5c9a36208e91$var$previousDispatcher = $465a5c9a36208e91$var$ReactDOMSharedInternals.d;
$465a5c9a36208e91$var$ReactDOMSharedInternals.d = {
    f: $465a5c9a36208e91$var$flushSyncWork,
    r: $465a5c9a36208e91$var$requestFormReset,
    D: $465a5c9a36208e91$var$prefetchDNS,
    C: $465a5c9a36208e91$var$preconnect,
    L: $465a5c9a36208e91$var$preload,
    m: $465a5c9a36208e91$var$preloadModule,
    X: $465a5c9a36208e91$var$preinitScript,
    S: $465a5c9a36208e91$var$preinitStyle,
    M: $465a5c9a36208e91$var$preinitModuleScript
};
function $465a5c9a36208e91$var$flushSyncWork() {
    var previousWasRendering = $465a5c9a36208e91$var$previousDispatcher.f(), wasRendering = $465a5c9a36208e91$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $465a5c9a36208e91$var$requestFormReset(form) {
    var formInst = $465a5c9a36208e91$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $465a5c9a36208e91$var$requestFormReset$1(formInst) : $465a5c9a36208e91$var$previousDispatcher.r(form);
}
var $465a5c9a36208e91$var$globalDocument = "undefined" === typeof document ? null : document;
function $465a5c9a36208e91$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $465a5c9a36208e91$var$preconnectsSet.has(limitedEscapedHref) || ($465a5c9a36208e91$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $465a5c9a36208e91$var$setInitialProperties(href, "link", rel), $465a5c9a36208e91$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $465a5c9a36208e91$var$prefetchDNS(href) {
    $465a5c9a36208e91$var$previousDispatcher.D(href);
    $465a5c9a36208e91$var$preconnectAs("dns-prefetch", href, null);
}
function $465a5c9a36208e91$var$preconnect(href, crossOrigin) {
    $465a5c9a36208e91$var$previousDispatcher.C(href, crossOrigin);
    $465a5c9a36208e91$var$preconnectAs("preconnect", href, crossOrigin);
}
function $465a5c9a36208e91$var$preload(href, as, options) {
    $465a5c9a36208e91$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $465a5c9a36208e91$var$getStyleKey(href);
                break;
            case "script":
                key = $465a5c9a36208e91$var$getScriptKey(href);
        }
        $465a5c9a36208e91$var$preloadPropsMap.has(key) || (href = $465a5c9a36208e91$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $465a5c9a36208e91$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($465a5c9a36208e91$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($465a5c9a36208e91$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $465a5c9a36208e91$var$setInitialProperties(as, "link", href), $465a5c9a36208e91$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $465a5c9a36208e91$var$preloadModule(href, options) {
    $465a5c9a36208e91$var$previousDispatcher.m(href, options);
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $465a5c9a36208e91$var$getScriptKey(href);
        }
        if (!$465a5c9a36208e91$var$preloadPropsMap.has(key) && (href = $465a5c9a36208e91$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $465a5c9a36208e91$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($465a5c9a36208e91$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $465a5c9a36208e91$var$setInitialProperties(as, "link", href);
            $465a5c9a36208e91$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $465a5c9a36208e91$var$preinitStyle(href, precedence, options) {
    $465a5c9a36208e91$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $465a5c9a36208e91$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $465a5c9a36208e91$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($465a5c9a36208e91$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $465a5c9a36208e91$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $465a5c9a36208e91$var$preloadPropsMap.get(key)) && $465a5c9a36208e91$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $465a5c9a36208e91$var$markNodeAsHoistable(link);
                $465a5c9a36208e91$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $465a5c9a36208e91$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $465a5c9a36208e91$var$preinitScript(src, options) {
    $465a5c9a36208e91$var$previousDispatcher.X(src, options);
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $465a5c9a36208e91$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $465a5c9a36208e91$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($465a5c9a36208e91$var$getScriptSelectorFromKey(key)), resource || (src = $465a5c9a36208e91$var$assign({
            src: src,
            async: !0
        }, options), (options = $465a5c9a36208e91$var$preloadPropsMap.get(key)) && $465a5c9a36208e91$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $465a5c9a36208e91$var$markNodeAsHoistable(resource), $465a5c9a36208e91$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $465a5c9a36208e91$var$preinitModuleScript(src, options) {
    $465a5c9a36208e91$var$previousDispatcher.M(src, options);
    var ownerDocument = $465a5c9a36208e91$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $465a5c9a36208e91$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $465a5c9a36208e91$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($465a5c9a36208e91$var$getScriptSelectorFromKey(key)), resource || (src = $465a5c9a36208e91$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $465a5c9a36208e91$var$preloadPropsMap.get(key)) && $465a5c9a36208e91$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $465a5c9a36208e91$var$markNodeAsHoistable(resource), $465a5c9a36208e91$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $465a5c9a36208e91$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $465a5c9a36208e91$var$rootInstanceStackCursor.current) ? $465a5c9a36208e91$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $465a5c9a36208e91$var$getStyleKey(pendingProps.href), pendingProps = $465a5c9a36208e91$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $465a5c9a36208e91$var$getStyleKey(pendingProps.href);
                var styles$243 = $465a5c9a36208e91$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($465a5c9a36208e91$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $465a5c9a36208e91$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $465a5c9a36208e91$var$preloadPropsMap.set(type, pendingProps), styles$243 || $465a5c9a36208e91$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $465a5c9a36208e91$var$getScriptKey(pendingProps), pendingProps = $465a5c9a36208e91$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(444, type));
    }
}
function $465a5c9a36208e91$var$getStyleKey(href) {
    return 'href="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $465a5c9a36208e91$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $465a5c9a36208e91$var$stylesheetPropsFromRawProps(rawProps) {
    return $465a5c9a36208e91$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $465a5c9a36208e91$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $465a5c9a36208e91$var$setInitialProperties(key, "link", preloadProps), $465a5c9a36208e91$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $465a5c9a36208e91$var$getScriptKey(src) {
    return '[src="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $465a5c9a36208e91$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $465a5c9a36208e91$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $465a5c9a36208e91$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $465a5c9a36208e91$var$markNodeAsHoistable(instance), instance;
            var styleProps = $465a5c9a36208e91$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $465a5c9a36208e91$var$markNodeAsHoistable(instance);
            $465a5c9a36208e91$var$setInitialProperties(instance, "style", styleProps);
            $465a5c9a36208e91$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $465a5c9a36208e91$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($465a5c9a36208e91$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $465a5c9a36208e91$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $465a5c9a36208e91$var$stylesheetPropsFromRawProps(props);
            (styleProps = $465a5c9a36208e91$var$preloadPropsMap.get(styleProps)) && $465a5c9a36208e91$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $465a5c9a36208e91$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $465a5c9a36208e91$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $465a5c9a36208e91$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $465a5c9a36208e91$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($465a5c9a36208e91$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $465a5c9a36208e91$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $465a5c9a36208e91$var$preloadPropsMap.get(instance$249)) instance = $465a5c9a36208e91$var$assign({}, props), $465a5c9a36208e91$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $465a5c9a36208e91$var$markNodeAsHoistable(styleProps);
            $465a5c9a36208e91$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($465a5c9a36208e91$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $465a5c9a36208e91$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $465a5c9a36208e91$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $465a5c9a36208e91$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $465a5c9a36208e91$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $465a5c9a36208e91$var$tagCaches = null;
function $465a5c9a36208e91$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $465a5c9a36208e91$var$tagCaches) {
        var cache = new Map();
        var caches = $465a5c9a36208e91$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $465a5c9a36208e91$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$465a5c9a36208e91$var$internalHoistableMarker] || node[$465a5c9a36208e91$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $465a5c9a36208e91$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $465a5c9a36208e91$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $465a5c9a36208e91$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $465a5c9a36208e91$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $465a5c9a36208e91$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($465a5c9a36208e91$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $465a5c9a36208e91$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $465a5c9a36208e91$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $465a5c9a36208e91$var$stylesheetPropsFromRawProps(props);
            (key = $465a5c9a36208e91$var$preloadPropsMap.get(key)) && $465a5c9a36208e91$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $465a5c9a36208e91$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $465a5c9a36208e91$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $465a5c9a36208e91$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $465a5c9a36208e91$var$estimatedBytesWithinLimit = 0;
function $465a5c9a36208e91$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $465a5c9a36208e91$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $465a5c9a36208e91$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $465a5c9a36208e91$var$estimatedBytesWithinLimit && ($465a5c9a36208e91$var$estimatedBytesWithinLimit = 62500 * $465a5c9a36208e91$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $465a5c9a36208e91$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $465a5c9a36208e91$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $465a5c9a36208e91$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $465a5c9a36208e91$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $465a5c9a36208e91$var$precedencesByRoot = null;
function $465a5c9a36208e91$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $465a5c9a36208e91$var$precedencesByRoot = new Map(), resources.forEach($465a5c9a36208e91$var$insertStylesheetIntoRoot, state), $465a5c9a36208e91$var$precedencesByRoot = null, $465a5c9a36208e91$var$onUnsuspend.call(state));
}
function $465a5c9a36208e91$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $465a5c9a36208e91$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $465a5c9a36208e91$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $465a5c9a36208e91$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $465a5c9a36208e91$var$HostTransitionContext = {
    $$typeof: $465a5c9a36208e91$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $465a5c9a36208e91$var$sharedNotPendingObject,
    _currentValue2: $465a5c9a36208e91$var$sharedNotPendingObject,
    _threadCount: 0
};
function $465a5c9a36208e91$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $465a5c9a36208e91$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $465a5c9a36208e91$var$createLaneMap(0);
    this.hiddenUpdates = $465a5c9a36208e91$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $465a5c9a36208e91$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $465a5c9a36208e91$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $465a5c9a36208e91$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $465a5c9a36208e91$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $465a5c9a36208e91$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $465a5c9a36208e91$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $465a5c9a36208e91$var$emptyContextObject;
    parentComponent = $465a5c9a36208e91$var$emptyContextObject;
    return parentComponent;
}
function $465a5c9a36208e91$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $465a5c9a36208e91$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $465a5c9a36208e91$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $465a5c9a36208e91$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($465a5c9a36208e91$var$scheduleUpdateOnFiber(element, rootFiber, lane), $465a5c9a36208e91$var$entangleTransitions(element, rootFiber, lane));
}
function $465a5c9a36208e91$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $465a5c9a36208e91$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $465a5c9a36208e91$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $465a5c9a36208e91$var$markRetryLaneImpl(fiber, retryLane);
}
function $465a5c9a36208e91$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $465a5c9a36208e91$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $465a5c9a36208e91$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $465a5c9a36208e91$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $465a5c9a36208e91$var$requestUpdateLane();
        lane = $465a5c9a36208e91$var$getBumpedLaneForHydrationByLane(lane);
        var root = $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $465a5c9a36208e91$var$scheduleUpdateOnFiber(root, fiber, lane);
        $465a5c9a36208e91$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $465a5c9a36208e91$var$_enabled = !0;
function $465a5c9a36208e91$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $465a5c9a36208e91$var$ReactSharedInternals.T;
    $465a5c9a36208e91$var$ReactSharedInternals.T = null;
    var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    try {
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 2, $465a5c9a36208e91$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, $465a5c9a36208e91$var$ReactSharedInternals.T = prevTransition;
    }
}
function $465a5c9a36208e91$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $465a5c9a36208e91$var$ReactSharedInternals.T;
    $465a5c9a36208e91$var$ReactSharedInternals.T = null;
    var previousPriority = $465a5c9a36208e91$var$ReactDOMSharedInternals.p;
    try {
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = 8, $465a5c9a36208e91$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $465a5c9a36208e91$var$ReactDOMSharedInternals.p = previousPriority, $465a5c9a36208e91$var$ReactSharedInternals.T = prevTransition;
    }
}
function $465a5c9a36208e91$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($465a5c9a36208e91$var$_enabled) {
        var blockedOn = $465a5c9a36208e91$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $465a5c9a36208e91$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $465a5c9a36208e91$var$return_targetInst, targetContainer), $465a5c9a36208e91$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($465a5c9a36208e91$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($465a5c9a36208e91$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $465a5c9a36208e91$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $465a5c9a36208e91$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $465a5c9a36208e91$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $465a5c9a36208e91$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $465a5c9a36208e91$var$ensureRootIsScheduled(fiber);
                                0 === ($465a5c9a36208e91$var$executionContext & 6) && ($465a5c9a36208e91$var$workInProgressRootRenderTargetTime = $465a5c9a36208e91$var$now() + 500, $465a5c9a36208e91$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $465a5c9a36208e91$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $465a5c9a36208e91$var$scheduleUpdateOnFiber(root, fiber, 2), $465a5c9a36208e91$var$flushSyncWork$1(), $465a5c9a36208e91$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $465a5c9a36208e91$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $465a5c9a36208e91$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $465a5c9a36208e91$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $465a5c9a36208e91$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $465a5c9a36208e91$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $465a5c9a36208e91$var$getEventTarget(nativeEvent);
    return $465a5c9a36208e91$var$findInstanceBlockingTarget(nativeEvent);
}
var $465a5c9a36208e91$var$return_targetInst = null;
function $465a5c9a36208e91$var$findInstanceBlockingTarget(targetNode) {
    $465a5c9a36208e91$var$return_targetInst = null;
    targetNode = $465a5c9a36208e91$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $465a5c9a36208e91$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $465a5c9a36208e91$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $465a5c9a36208e91$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $465a5c9a36208e91$var$return_targetInst = targetNode;
    return null;
}
function $465a5c9a36208e91$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($465a5c9a36208e91$var$getCurrentPriorityLevel()){
                case $465a5c9a36208e91$var$ImmediatePriority:
                    return 2;
                case $465a5c9a36208e91$var$UserBlockingPriority:
                    return 8;
                case $465a5c9a36208e91$var$NormalPriority$1:
                case $465a5c9a36208e91$var$LowPriority:
                    return 32;
                case $465a5c9a36208e91$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $465a5c9a36208e91$var$hasScheduledReplayAttempt = !1, $465a5c9a36208e91$var$queuedFocus = null, $465a5c9a36208e91$var$queuedDrag = null, $465a5c9a36208e91$var$queuedMouse = null, $465a5c9a36208e91$var$queuedPointers = new Map(), $465a5c9a36208e91$var$queuedPointerCaptures = new Map(), $465a5c9a36208e91$var$queuedExplicitHydrationTargets = [], $465a5c9a36208e91$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $465a5c9a36208e91$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $465a5c9a36208e91$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $465a5c9a36208e91$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $465a5c9a36208e91$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $465a5c9a36208e91$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $465a5c9a36208e91$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $465a5c9a36208e91$var$getInstanceFromNode(blockedOn), null !== blockedOn && $465a5c9a36208e91$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $465a5c9a36208e91$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $465a5c9a36208e91$var$queuedFocus = $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent($465a5c9a36208e91$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $465a5c9a36208e91$var$queuedDrag = $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent($465a5c9a36208e91$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $465a5c9a36208e91$var$queuedMouse = $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent($465a5c9a36208e91$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $465a5c9a36208e91$var$queuedPointers.set(pointerId, $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent($465a5c9a36208e91$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $465a5c9a36208e91$var$queuedPointerCaptures.set(pointerId, $465a5c9a36208e91$var$accumulateOrCreateContinuousQueuedReplayableEvent($465a5c9a36208e91$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $465a5c9a36208e91$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $465a5c9a36208e91$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $465a5c9a36208e91$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $465a5c9a36208e91$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $465a5c9a36208e91$var$runWithPriority(queuedTarget.priority, function() {
                        $465a5c9a36208e91$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $465a5c9a36208e91$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $465a5c9a36208e91$var$runWithPriority(queuedTarget.priority, function() {
                        $465a5c9a36208e91$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $465a5c9a36208e91$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $465a5c9a36208e91$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $465a5c9a36208e91$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $465a5c9a36208e91$var$currentReplayingEvent = null;
        } else return targetContainers = $465a5c9a36208e91$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $465a5c9a36208e91$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $465a5c9a36208e91$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $465a5c9a36208e91$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $465a5c9a36208e91$var$replayUnblockedEvents() {
    $465a5c9a36208e91$var$hasScheduledReplayAttempt = !1;
    null !== $465a5c9a36208e91$var$queuedFocus && $465a5c9a36208e91$var$attemptReplayContinuousQueuedEvent($465a5c9a36208e91$var$queuedFocus) && ($465a5c9a36208e91$var$queuedFocus = null);
    null !== $465a5c9a36208e91$var$queuedDrag && $465a5c9a36208e91$var$attemptReplayContinuousQueuedEvent($465a5c9a36208e91$var$queuedDrag) && ($465a5c9a36208e91$var$queuedDrag = null);
    null !== $465a5c9a36208e91$var$queuedMouse && $465a5c9a36208e91$var$attemptReplayContinuousQueuedEvent($465a5c9a36208e91$var$queuedMouse) && ($465a5c9a36208e91$var$queuedMouse = null);
    $465a5c9a36208e91$var$queuedPointers.forEach($465a5c9a36208e91$var$attemptReplayContinuousQueuedEventInMap);
    $465a5c9a36208e91$var$queuedPointerCaptures.forEach($465a5c9a36208e91$var$attemptReplayContinuousQueuedEventInMap);
}
function $465a5c9a36208e91$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $465a5c9a36208e91$var$hasScheduledReplayAttempt || ($465a5c9a36208e91$var$hasScheduledReplayAttempt = !0, $1oHYN.unstable_scheduleCallback($1oHYN.unstable_NormalPriority, $465a5c9a36208e91$var$replayUnblockedEvents)));
}
var $465a5c9a36208e91$var$lastScheduledReplayQueue = null;
function $465a5c9a36208e91$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $465a5c9a36208e91$var$lastScheduledReplayQueue !== formReplayingQueue && ($465a5c9a36208e91$var$lastScheduledReplayQueue = formReplayingQueue, $1oHYN.unstable_scheduleCallback($1oHYN.unstable_NormalPriority, function() {
        $465a5c9a36208e91$var$lastScheduledReplayQueue === formReplayingQueue && ($465a5c9a36208e91$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $465a5c9a36208e91$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $465a5c9a36208e91$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $465a5c9a36208e91$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $465a5c9a36208e91$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $465a5c9a36208e91$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $465a5c9a36208e91$var$queuedFocus && $465a5c9a36208e91$var$scheduleCallbackIfUnblocked($465a5c9a36208e91$var$queuedFocus, unblocked);
    null !== $465a5c9a36208e91$var$queuedDrag && $465a5c9a36208e91$var$scheduleCallbackIfUnblocked($465a5c9a36208e91$var$queuedDrag, unblocked);
    null !== $465a5c9a36208e91$var$queuedMouse && $465a5c9a36208e91$var$scheduleCallbackIfUnblocked($465a5c9a36208e91$var$queuedMouse, unblocked);
    $465a5c9a36208e91$var$queuedPointers.forEach(unblock);
    $465a5c9a36208e91$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $465a5c9a36208e91$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $465a5c9a36208e91$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $465a5c9a36208e91$var$queuedExplicitHydrationTargets.length && (i = $465a5c9a36208e91$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$465a5c9a36208e91$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $465a5c9a36208e91$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$465a5c9a36208e91$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $465a5c9a36208e91$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$465a5c9a36208e91$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $465a5c9a36208e91$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $465a5c9a36208e91$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $465a5c9a36208e91$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $465a5c9a36208e91$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$465a5c9a36208e91$var$ReactDOMHydrationRoot.prototype.render = $465a5c9a36208e91$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(409));
    var current = root.current, lane = $465a5c9a36208e91$var$requestUpdateLane();
    $465a5c9a36208e91$var$updateContainerImpl(current, lane, children, root, null, null);
};
$465a5c9a36208e91$var$ReactDOMHydrationRoot.prototype.unmount = $465a5c9a36208e91$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $465a5c9a36208e91$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $465a5c9a36208e91$var$flushSyncWork$1();
        container[$465a5c9a36208e91$var$internalContainerInstanceKey] = null;
    }
};
function $465a5c9a36208e91$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$465a5c9a36208e91$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $465a5c9a36208e91$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $465a5c9a36208e91$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $465a5c9a36208e91$var$queuedExplicitHydrationTargets[i].priority; i++);
        $465a5c9a36208e91$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $465a5c9a36208e91$var$attemptExplicitHydrationTarget(target);
    }
};
var $465a5c9a36208e91$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $fgmOP.version;
if ("19.2.7" !== $465a5c9a36208e91$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(527, $465a5c9a36208e91$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$465a5c9a36208e91$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($465a5c9a36208e91$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $465a5c9a36208e91$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $465a5c9a36208e91$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $465a5c9a36208e91$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $465a5c9a36208e91$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $465a5c9a36208e91$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$465a5c9a36208e91$var$hook$jscomp$inline_2348.isDisabled && $465a5c9a36208e91$var$hook$jscomp$inline_2348.supportsFiber) try {
        $465a5c9a36208e91$var$rendererID = $465a5c9a36208e91$var$hook$jscomp$inline_2348.inject($465a5c9a36208e91$var$internals$jscomp$inline_2347), $465a5c9a36208e91$var$injectedHook = $465a5c9a36208e91$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$465a5c9a36208e91$export$882461b6382ed46c = function(container, options) {
    if (!$465a5c9a36208e91$var$isValidContainer(container)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $465a5c9a36208e91$var$defaultOnUncaughtError, onCaughtError = $465a5c9a36208e91$var$defaultOnCaughtError, onRecoverableError = $465a5c9a36208e91$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $465a5c9a36208e91$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $465a5c9a36208e91$var$defaultOnDefaultTransitionIndicator);
    container[$465a5c9a36208e91$var$internalContainerInstanceKey] = options.current;
    $465a5c9a36208e91$var$listenToAllSupportedEvents(container);
    return new $465a5c9a36208e91$var$ReactDOMRoot(options);
};
$465a5c9a36208e91$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$465a5c9a36208e91$var$isValidContainer(container)) throw Error($465a5c9a36208e91$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $465a5c9a36208e91$var$defaultOnUncaughtError, onCaughtError = $465a5c9a36208e91$var$defaultOnCaughtError, onRecoverableError = $465a5c9a36208e91$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $465a5c9a36208e91$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $465a5c9a36208e91$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $465a5c9a36208e91$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $465a5c9a36208e91$var$requestUpdateLane();
    isStrictMode = $465a5c9a36208e91$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $465a5c9a36208e91$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $465a5c9a36208e91$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $465a5c9a36208e91$var$markRootUpdated$1(initialChildren, options);
    $465a5c9a36208e91$var$ensureRootIsScheduled(initialChildren);
    container[$465a5c9a36208e91$var$internalContainerInstanceKey] = initialChildren.current;
    $465a5c9a36208e91$var$listenToAllSupportedEvents(container);
    return new $465a5c9a36208e91$var$ReactDOMHydrationRoot(initialChildren);
};
$465a5c9a36208e91$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("1oHYN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8vAfe"));

});
parcelRegister("8vAfe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $631d5570f98e8c04$export$c4744153514ff05d; }, function (v) { return $631d5570f98e8c04$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $631d5570f98e8c04$export$3e506c1ccc9cc1a7; }, function (v) { return $631d5570f98e8c04$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $631d5570f98e8c04$export$e26fe2ed2fa76875; }, function (v) { return $631d5570f98e8c04$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $631d5570f98e8c04$export$502329bbf4b505b1; }, function (v) { return $631d5570f98e8c04$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $631d5570f98e8c04$export$6e3807111c4874c4; }, function (v) { return $631d5570f98e8c04$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $631d5570f98e8c04$export$c27134553091fb3a; }, function (v) { return $631d5570f98e8c04$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $631d5570f98e8c04$export$33ee1acdc04fd2a2; }, function (v) { return $631d5570f98e8c04$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $631d5570f98e8c04$export$b00a404bbd5edef2; }, function (v) { return $631d5570f98e8c04$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $631d5570f98e8c04$export$d66a1c1c77bd778b; }, function (v) { return $631d5570f98e8c04$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $631d5570f98e8c04$export$d3dfb8e4810cb555; }, function (v) { return $631d5570f98e8c04$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $631d5570f98e8c04$export$72fdf0e06517287b; }, function (v) { return $631d5570f98e8c04$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $631d5570f98e8c04$export$816d2913ae6b83b1; }, function (v) { return $631d5570f98e8c04$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $631d5570f98e8c04$export$61bcfe829111a1d0; }, function (v) { return $631d5570f98e8c04$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $631d5570f98e8c04$export$7ee8c9beb337bc3f; }, function (v) { return $631d5570f98e8c04$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $631d5570f98e8c04$export$b5836b71941fa3ed; }, function (v) { return $631d5570f98e8c04$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $631d5570f98e8c04$export$cf845f2c119da08a; }, function (v) { return $631d5570f98e8c04$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $631d5570f98e8c04$export$c4744153514ff05d;
var $631d5570f98e8c04$export$3e506c1ccc9cc1a7;
var $631d5570f98e8c04$export$e26fe2ed2fa76875;
var $631d5570f98e8c04$export$502329bbf4b505b1;
var $631d5570f98e8c04$export$6e3807111c4874c4;
var $631d5570f98e8c04$export$c27134553091fb3a;
var $631d5570f98e8c04$export$33ee1acdc04fd2a2;
var $631d5570f98e8c04$export$b00a404bbd5edef2;
var $631d5570f98e8c04$export$d66a1c1c77bd778b;
var $631d5570f98e8c04$export$d3dfb8e4810cb555;
var $631d5570f98e8c04$export$72fdf0e06517287b;
var $631d5570f98e8c04$export$816d2913ae6b83b1;
var $631d5570f98e8c04$export$61bcfe829111a1d0;
var $631d5570f98e8c04$export$7ee8c9beb337bc3f;
var $631d5570f98e8c04$export$b5836b71941fa3ed;
var $631d5570f98e8c04$export$cf845f2c119da08a;
"use strict";
function $631d5570f98e8c04$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $631d5570f98e8c04$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $631d5570f98e8c04$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $631d5570f98e8c04$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $631d5570f98e8c04$var$compare(left, last)) rightIndex < length && 0 > $631d5570f98e8c04$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $631d5570f98e8c04$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $631d5570f98e8c04$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$631d5570f98e8c04$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $631d5570f98e8c04$var$localPerformance = performance;
    $631d5570f98e8c04$export$c4744153514ff05d = function() {
        return $631d5570f98e8c04$var$localPerformance.now();
    };
} else {
    var $631d5570f98e8c04$var$localDate = Date, $631d5570f98e8c04$var$initialTime = $631d5570f98e8c04$var$localDate.now();
    $631d5570f98e8c04$export$c4744153514ff05d = function() {
        return $631d5570f98e8c04$var$localDate.now() - $631d5570f98e8c04$var$initialTime;
    };
}
var $631d5570f98e8c04$var$taskQueue = [], $631d5570f98e8c04$var$timerQueue = [], $631d5570f98e8c04$var$taskIdCounter = 1, $631d5570f98e8c04$var$currentTask = null, $631d5570f98e8c04$var$currentPriorityLevel = 3, $631d5570f98e8c04$var$isPerformingWork = !1, $631d5570f98e8c04$var$isHostCallbackScheduled = !1, $631d5570f98e8c04$var$isHostTimeoutScheduled = !1, $631d5570f98e8c04$var$needsPaint = !1, $631d5570f98e8c04$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $631d5570f98e8c04$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $631d5570f98e8c04$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $631d5570f98e8c04$var$advanceTimers(currentTime) {
    for(var timer = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$timerQueue); null !== timer;){
        if (null === timer.callback) $631d5570f98e8c04$var$pop($631d5570f98e8c04$var$timerQueue);
        else if (timer.startTime <= currentTime) $631d5570f98e8c04$var$pop($631d5570f98e8c04$var$timerQueue), timer.sortIndex = timer.expirationTime, $631d5570f98e8c04$var$push($631d5570f98e8c04$var$taskQueue, timer);
        else break;
        timer = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$timerQueue);
    }
}
function $631d5570f98e8c04$var$handleTimeout(currentTime) {
    $631d5570f98e8c04$var$isHostTimeoutScheduled = !1;
    $631d5570f98e8c04$var$advanceTimers(currentTime);
    if (!$631d5570f98e8c04$var$isHostCallbackScheduled) {
        if (null !== $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$taskQueue)) $631d5570f98e8c04$var$isHostCallbackScheduled = !0, $631d5570f98e8c04$var$isMessageLoopRunning || ($631d5570f98e8c04$var$isMessageLoopRunning = !0, $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$timerQueue);
            null !== firstTimer && $631d5570f98e8c04$var$requestHostTimeout($631d5570f98e8c04$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $631d5570f98e8c04$var$isMessageLoopRunning = !1, $631d5570f98e8c04$var$taskTimeoutID = -1, $631d5570f98e8c04$var$frameInterval = 5, $631d5570f98e8c04$var$startTime = -1;
function $631d5570f98e8c04$var$shouldYieldToHost() {
    return $631d5570f98e8c04$var$needsPaint ? !0 : $631d5570f98e8c04$export$c4744153514ff05d() - $631d5570f98e8c04$var$startTime < $631d5570f98e8c04$var$frameInterval ? !1 : !0;
}
function $631d5570f98e8c04$var$performWorkUntilDeadline() {
    $631d5570f98e8c04$var$needsPaint = !1;
    if ($631d5570f98e8c04$var$isMessageLoopRunning) {
        var currentTime = $631d5570f98e8c04$export$c4744153514ff05d();
        $631d5570f98e8c04$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $631d5570f98e8c04$var$isHostCallbackScheduled = !1;
                $631d5570f98e8c04$var$isHostTimeoutScheduled && ($631d5570f98e8c04$var$isHostTimeoutScheduled = !1, $631d5570f98e8c04$var$localClearTimeout($631d5570f98e8c04$var$taskTimeoutID), $631d5570f98e8c04$var$taskTimeoutID = -1);
                $631d5570f98e8c04$var$isPerformingWork = !0;
                var previousPriorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
                try {
                    b: {
                        $631d5570f98e8c04$var$advanceTimers(currentTime);
                        for($631d5570f98e8c04$var$currentTask = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$taskQueue); null !== $631d5570f98e8c04$var$currentTask && !($631d5570f98e8c04$var$currentTask.expirationTime > currentTime && $631d5570f98e8c04$var$shouldYieldToHost());){
                            var callback = $631d5570f98e8c04$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $631d5570f98e8c04$var$currentTask.callback = null;
                                $631d5570f98e8c04$var$currentPriorityLevel = $631d5570f98e8c04$var$currentTask.priorityLevel;
                                var continuationCallback = callback($631d5570f98e8c04$var$currentTask.expirationTime <= currentTime);
                                currentTime = $631d5570f98e8c04$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $631d5570f98e8c04$var$currentTask.callback = continuationCallback;
                                    $631d5570f98e8c04$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $631d5570f98e8c04$var$currentTask === $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$taskQueue) && $631d5570f98e8c04$var$pop($631d5570f98e8c04$var$taskQueue);
                                $631d5570f98e8c04$var$advanceTimers(currentTime);
                            } else $631d5570f98e8c04$var$pop($631d5570f98e8c04$var$taskQueue);
                            $631d5570f98e8c04$var$currentTask = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$taskQueue);
                        }
                        if (null !== $631d5570f98e8c04$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$timerQueue);
                            null !== firstTimer && $631d5570f98e8c04$var$requestHostTimeout($631d5570f98e8c04$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $631d5570f98e8c04$var$currentTask = null, $631d5570f98e8c04$var$currentPriorityLevel = previousPriorityLevel, $631d5570f98e8c04$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline() : $631d5570f98e8c04$var$isMessageLoopRunning = !1;
        }
    }
}
var $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $631d5570f98e8c04$var$localSetImmediate) $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline = function() {
    $631d5570f98e8c04$var$localSetImmediate($631d5570f98e8c04$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $631d5570f98e8c04$var$channel = new MessageChannel(), $631d5570f98e8c04$var$port = $631d5570f98e8c04$var$channel.port2;
    $631d5570f98e8c04$var$channel.port1.onmessage = $631d5570f98e8c04$var$performWorkUntilDeadline;
    $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline = function() {
        $631d5570f98e8c04$var$port.postMessage(null);
    };
} else $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline = function() {
    $631d5570f98e8c04$var$localSetTimeout($631d5570f98e8c04$var$performWorkUntilDeadline, 0);
};
function $631d5570f98e8c04$var$requestHostTimeout(callback, ms) {
    $631d5570f98e8c04$var$taskTimeoutID = $631d5570f98e8c04$var$localSetTimeout(function() {
        callback($631d5570f98e8c04$export$c4744153514ff05d());
    }, ms);
}
$631d5570f98e8c04$export$3e506c1ccc9cc1a7 = 5;
$631d5570f98e8c04$export$e26fe2ed2fa76875 = 1;
$631d5570f98e8c04$export$502329bbf4b505b1 = 4;
$631d5570f98e8c04$export$6e3807111c4874c4 = 3;
$631d5570f98e8c04$export$c27134553091fb3a = null;
$631d5570f98e8c04$export$33ee1acdc04fd2a2 = 2;
$631d5570f98e8c04$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$631d5570f98e8c04$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $631d5570f98e8c04$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$631d5570f98e8c04$export$d3dfb8e4810cb555 = function() {
    return $631d5570f98e8c04$var$currentPriorityLevel;
};
$631d5570f98e8c04$export$72fdf0e06517287b = function(eventHandler) {
    switch($631d5570f98e8c04$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
    $631d5570f98e8c04$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $631d5570f98e8c04$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$631d5570f98e8c04$export$816d2913ae6b83b1 = function() {
    $631d5570f98e8c04$var$needsPaint = !0;
};
$631d5570f98e8c04$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
    $631d5570f98e8c04$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $631d5570f98e8c04$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$631d5570f98e8c04$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $631d5570f98e8c04$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $631d5570f98e8c04$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $631d5570f98e8c04$var$push($631d5570f98e8c04$var$timerQueue, priorityLevel), null === $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$taskQueue) && priorityLevel === $631d5570f98e8c04$var$peek($631d5570f98e8c04$var$timerQueue) && ($631d5570f98e8c04$var$isHostTimeoutScheduled ? ($631d5570f98e8c04$var$localClearTimeout($631d5570f98e8c04$var$taskTimeoutID), $631d5570f98e8c04$var$taskTimeoutID = -1) : $631d5570f98e8c04$var$isHostTimeoutScheduled = !0, $631d5570f98e8c04$var$requestHostTimeout($631d5570f98e8c04$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $631d5570f98e8c04$var$push($631d5570f98e8c04$var$taskQueue, priorityLevel), $631d5570f98e8c04$var$isHostCallbackScheduled || $631d5570f98e8c04$var$isPerformingWork || ($631d5570f98e8c04$var$isHostCallbackScheduled = !0, $631d5570f98e8c04$var$isMessageLoopRunning || ($631d5570f98e8c04$var$isMessageLoopRunning = !0, $631d5570f98e8c04$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$631d5570f98e8c04$export$b5836b71941fa3ed = $631d5570f98e8c04$var$shouldYieldToHost;
$631d5570f98e8c04$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $631d5570f98e8c04$var$currentPriorityLevel;
        $631d5570f98e8c04$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $631d5570f98e8c04$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("fgmOP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1VYQJ"));

});

parcelRegister("cwk7h", function(module, exports) {
'use strict';
function $91d813eb41c8c85f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($91d813eb41c8c85f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$91d813eb41c8c85f$var$checkDCE();

module.exports = (parcelRequire("23h92"));

});
parcelRegister("23h92", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $17e9292b77a713ae$export$69ce8ef3fe5cead0; }, function (v) { return $17e9292b77a713ae$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $17e9292b77a713ae$export$d39a5bbd09211389; }, function (v) { return $17e9292b77a713ae$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $17e9292b77a713ae$export$cd75ccfd720a3cd4; }, function (v) { return $17e9292b77a713ae$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $17e9292b77a713ae$export$a0816fa17a9e79be; }, function (v) { return $17e9292b77a713ae$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $17e9292b77a713ae$export$7292efcadded39f3; }, function (v) { return $17e9292b77a713ae$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $17e9292b77a713ae$export$da407abadb9b8f86; }, function (v) { return $17e9292b77a713ae$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $17e9292b77a713ae$export$314cfea32580671c; }, function (v) { return $17e9292b77a713ae$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $17e9292b77a713ae$export$513ccb98c53b8039; }, function (v) { return $17e9292b77a713ae$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $17e9292b77a713ae$export$dbca993bc2d264a; }, function (v) { return $17e9292b77a713ae$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $17e9292b77a713ae$export$4797a8006f0655d0; }, function (v) { return $17e9292b77a713ae$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $17e9292b77a713ae$export$c78a37762a8d58e1; }, function (v) { return $17e9292b77a713ae$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $17e9292b77a713ae$export$606f11b2eb45ecc6; }, function (v) { return $17e9292b77a713ae$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $17e9292b77a713ae$export$f7e8a0bf92324b1e; }, function (v) { return $17e9292b77a713ae$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $17e9292b77a713ae$export$83d89fbfd8236492; }, function (v) { return $17e9292b77a713ae$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $17e9292b77a713ae$export$69ce8ef3fe5cead0;
var $17e9292b77a713ae$export$d39a5bbd09211389;
var $17e9292b77a713ae$export$cd75ccfd720a3cd4;
var $17e9292b77a713ae$export$a0816fa17a9e79be;
var $17e9292b77a713ae$export$7292efcadded39f3;
var $17e9292b77a713ae$export$da407abadb9b8f86;
var $17e9292b77a713ae$export$314cfea32580671c;
var $17e9292b77a713ae$export$513ccb98c53b8039;
var $17e9292b77a713ae$export$dbca993bc2d264a;
var $17e9292b77a713ae$export$4797a8006f0655d0;
var $17e9292b77a713ae$export$c78a37762a8d58e1;
var $17e9292b77a713ae$export$606f11b2eb45ecc6;
var $17e9292b77a713ae$export$f7e8a0bf92324b1e;
var $17e9292b77a713ae$export$83d89fbfd8236492;
"use strict";

var $fgmOP = parcelRequire("fgmOP");
function $17e9292b77a713ae$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $17e9292b77a713ae$var$noop() {}
var $17e9292b77a713ae$var$Internals = {
    d: {
        f: $17e9292b77a713ae$var$noop,
        r: function() {
            throw Error($17e9292b77a713ae$var$formatProdErrorMessage(522));
        },
        D: $17e9292b77a713ae$var$noop,
        C: $17e9292b77a713ae$var$noop,
        L: $17e9292b77a713ae$var$noop,
        m: $17e9292b77a713ae$var$noop,
        X: $17e9292b77a713ae$var$noop,
        S: $17e9292b77a713ae$var$noop,
        M: $17e9292b77a713ae$var$noop
    },
    p: 0,
    findDOMNode: null
}, $17e9292b77a713ae$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $17e9292b77a713ae$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17e9292b77a713ae$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $17e9292b77a713ae$var$ReactSharedInternals = $fgmOP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $17e9292b77a713ae$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$17e9292b77a713ae$export$69ce8ef3fe5cead0 = $17e9292b77a713ae$var$Internals;
$17e9292b77a713ae$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($17e9292b77a713ae$var$formatProdErrorMessage(299));
    return $17e9292b77a713ae$var$createPortal$1(children, container, null, key);
};
$17e9292b77a713ae$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $17e9292b77a713ae$var$ReactSharedInternals.T, previousUpdatePriority = $17e9292b77a713ae$var$Internals.p;
    try {
        if ($17e9292b77a713ae$var$ReactSharedInternals.T = null, $17e9292b77a713ae$var$Internals.p = 2, fn) return fn();
    } finally{
        $17e9292b77a713ae$var$ReactSharedInternals.T = previousTransition, $17e9292b77a713ae$var$Internals.p = previousUpdatePriority, $17e9292b77a713ae$var$Internals.d.f();
    }
};
$17e9292b77a713ae$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $17e9292b77a713ae$var$Internals.d.C(href, options));
};
$17e9292b77a713ae$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $17e9292b77a713ae$var$Internals.d.D(href);
};
$17e9292b77a713ae$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $17e9292b77a713ae$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $17e9292b77a713ae$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $17e9292b77a713ae$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$17e9292b77a713ae$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $17e9292b77a713ae$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $17e9292b77a713ae$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $17e9292b77a713ae$var$Internals.d.M(href);
    }
};
$17e9292b77a713ae$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $17e9292b77a713ae$var$getCrossOriginStringAs(as, options.crossOrigin);
        $17e9292b77a713ae$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$17e9292b77a713ae$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $17e9292b77a713ae$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $17e9292b77a713ae$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $17e9292b77a713ae$var$Internals.d.m(href);
    }
};
$17e9292b77a713ae$export$4797a8006f0655d0 = function(form) {
    $17e9292b77a713ae$var$Internals.d.r(form);
};
$17e9292b77a713ae$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$17e9292b77a713ae$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $17e9292b77a713ae$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$17e9292b77a713ae$export$f7e8a0bf92324b1e = function() {
    return $17e9292b77a713ae$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$17e9292b77a713ae$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("a2Cdw", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $74f7bc6bc3b3efed$export$bf730a2d8bf68b42; }, function (v) { return $74f7bc6bc3b3efed$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74f7bc6bc3b3efed$export$bf730a2d8bf68b42;
"use strict";

var $fgmOP = parcelRequire("fgmOP");
function $74f7bc6bc3b3efed$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $74f7bc6bc3b3efed$var$objectIs = "function" === typeof Object.is ? Object.is : $74f7bc6bc3b3efed$var$is, $74f7bc6bc3b3efed$var$useSyncExternalStore = $fgmOP.useSyncExternalStore, $74f7bc6bc3b3efed$var$useRef = $fgmOP.useRef, $74f7bc6bc3b3efed$var$useEffect = $fgmOP.useEffect, $74f7bc6bc3b3efed$var$useMemo = $fgmOP.useMemo, $74f7bc6bc3b3efed$var$useDebugValue = $fgmOP.useDebugValue;
$74f7bc6bc3b3efed$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $74f7bc6bc3b3efed$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $74f7bc6bc3b3efed$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($74f7bc6bc3b3efed$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $74f7bc6bc3b3efed$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $74f7bc6bc3b3efed$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $74f7bc6bc3b3efed$var$useDebugValue(value);
    return value;
};

});

var $ba93bb4fdbad5ba0$exports = {};
'use strict';

$ba93bb4fdbad5ba0$exports = (parcelRequire("ciB2Z"));


parcelRequire("fgmOP");
var $5fdae19e1117f068$exports = {};
'use strict';
function $5fdae19e1117f068$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5fdae19e1117f068$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5fdae19e1117f068$var$checkDCE();

$5fdae19e1117f068$exports = (parcelRequire("62ucW"));



var $fgmOP = parcelRequire("fgmOP");
var $d14fc6b02f0b440e$exports = {};
'use strict';

$d14fc6b02f0b440e$exports = (parcelRequire("a2Cdw"));


var $08c3108423076a6d$var$__defProp = Object.defineProperty;
var $08c3108423076a6d$var$__defProps = Object.defineProperties;
var $08c3108423076a6d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $08c3108423076a6d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $08c3108423076a6d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $08c3108423076a6d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $08c3108423076a6d$var$__defNormalProp = (obj, key, value)=>key in obj ? $08c3108423076a6d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $08c3108423076a6d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($08c3108423076a6d$var$__hasOwnProp.call(b, prop)) $08c3108423076a6d$var$__defNormalProp(a, prop, b[prop]);
    if ($08c3108423076a6d$var$__getOwnPropSymbols) {
        for (var prop of $08c3108423076a6d$var$__getOwnPropSymbols(b))if ($08c3108423076a6d$var$__propIsEnum.call(b, prop)) $08c3108423076a6d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $08c3108423076a6d$var$__spreadProps = (a, b)=>$08c3108423076a6d$var$__defProps(a, $08c3108423076a6d$var$__getOwnPropDescs(b));
var $08c3108423076a6d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($08c3108423076a6d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $08c3108423076a6d$var$__getOwnPropSymbols) {
        for (var prop of $08c3108423076a6d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $08c3108423076a6d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $08c3108423076a6d$var$IS_REACT_19 = /* @__PURE__ */ $fgmOP.version.startsWith("19");
var $08c3108423076a6d$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($08c3108423076a6d$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $08c3108423076a6d$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $08c3108423076a6d$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $08c3108423076a6d$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $08c3108423076a6d$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $08c3108423076a6d$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $08c3108423076a6d$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $08c3108423076a6d$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $08c3108423076a6d$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $08c3108423076a6d$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $08c3108423076a6d$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $08c3108423076a6d$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $08c3108423076a6d$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $08c3108423076a6d$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $08c3108423076a6d$var$ForwardRef = $08c3108423076a6d$var$REACT_FORWARD_REF_TYPE;
var $08c3108423076a6d$var$Memo = $08c3108423076a6d$var$REACT_MEMO_TYPE;
function $08c3108423076a6d$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $08c3108423076a6d$var$REACT_FRAGMENT_TYPE || type === $08c3108423076a6d$var$REACT_PROFILER_TYPE || type === $08c3108423076a6d$var$REACT_STRICT_MODE_TYPE || type === $08c3108423076a6d$var$REACT_SUSPENSE_TYPE || type === $08c3108423076a6d$var$REACT_SUSPENSE_LIST_TYPE || type === $08c3108423076a6d$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $08c3108423076a6d$var$REACT_LAZY_TYPE || type.$$typeof === $08c3108423076a6d$var$REACT_MEMO_TYPE || type.$$typeof === $08c3108423076a6d$var$REACT_CONTEXT_TYPE || type.$$typeof === $08c3108423076a6d$var$REACT_CONSUMER_TYPE || type.$$typeof === $08c3108423076a6d$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $08c3108423076a6d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $08c3108423076a6d$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $08c3108423076a6d$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $08c3108423076a6d$var$REACT_FRAGMENT_TYPE:
                    case $08c3108423076a6d$var$REACT_PROFILER_TYPE:
                    case $08c3108423076a6d$var$REACT_STRICT_MODE_TYPE:
                    case $08c3108423076a6d$var$REACT_SUSPENSE_TYPE:
                    case $08c3108423076a6d$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $08c3108423076a6d$var$REACT_CONTEXT_TYPE:
                            case $08c3108423076a6d$var$REACT_FORWARD_REF_TYPE:
                            case $08c3108423076a6d$var$REACT_LAZY_TYPE:
                            case $08c3108423076a6d$var$REACT_MEMO_TYPE:
                                return object;
                            case $08c3108423076a6d$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $08c3108423076a6d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $08c3108423076a6d$var$isContextConsumer(object) {
    return $08c3108423076a6d$var$IS_REACT_19 ? $08c3108423076a6d$var$typeOf(object) === $08c3108423076a6d$var$REACT_CONSUMER_TYPE : $08c3108423076a6d$var$typeOf(object) === $08c3108423076a6d$var$REACT_CONTEXT_TYPE;
}
function $08c3108423076a6d$var$isMemo(object) {
    return $08c3108423076a6d$var$typeOf(object) === $08c3108423076a6d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $08c3108423076a6d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $08c3108423076a6d$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $08c3108423076a6d$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $08c3108423076a6d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $08c3108423076a6d$var$verify(mapStateToProps, "mapStateToProps");
    $08c3108423076a6d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $08c3108423076a6d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $08c3108423076a6d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $08c3108423076a6d$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $08c3108423076a6d$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $08c3108423076a6d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $08c3108423076a6d$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $08c3108423076a6d$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $08c3108423076a6d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$08c3108423076a6d$var$isPlainObject(value)) $08c3108423076a6d$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $08c3108423076a6d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $08c3108423076a6d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $08c3108423076a6d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $08c3108423076a6d$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $08c3108423076a6d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $08c3108423076a6d$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $08c3108423076a6d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $08c3108423076a6d$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $08c3108423076a6d$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $08c3108423076a6d$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $08c3108423076a6d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $08c3108423076a6d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $08c3108423076a6d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $08c3108423076a6d$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $08c3108423076a6d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $08c3108423076a6d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $08c3108423076a6d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $08c3108423076a6d$var$__spreadValues($08c3108423076a6d$var$__spreadValues($08c3108423076a6d$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $08c3108423076a6d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $08c3108423076a6d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$08c3108423076a6d$var$defaultMergeProps : typeof mergeProps === "function" ? $08c3108423076a6d$var$wrapMergePropsFunc(mergeProps) : $08c3108423076a6d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $08c3108423076a6d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $08c3108423076a6d$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $08c3108423076a6d$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $08c3108423076a6d$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $08c3108423076a6d$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $08c3108423076a6d$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $08c3108423076a6d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $08c3108423076a6d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $08c3108423076a6d$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $08c3108423076a6d$var$isDOM = /* @__PURE__ */ $08c3108423076a6d$var$canUseDOM();
var $08c3108423076a6d$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $08c3108423076a6d$var$isReactNative = /* @__PURE__ */ $08c3108423076a6d$var$isRunningInReactNative();
var $08c3108423076a6d$var$getUseIsomorphicLayoutEffect = ()=>$08c3108423076a6d$var$isDOM || $08c3108423076a6d$var$isReactNative ? $fgmOP.useLayoutEffect : $fgmOP.useEffect;
var $08c3108423076a6d$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $08c3108423076a6d$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $08c3108423076a6d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $08c3108423076a6d$export$d36bdfa510afb180(objA, objB) {
    if ($08c3108423076a6d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$08c3108423076a6d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $08c3108423076a6d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $08c3108423076a6d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $08c3108423076a6d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $08c3108423076a6d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $08c3108423076a6d$var$TYPE_STATICS = {
    [$08c3108423076a6d$var$ForwardRef]: $08c3108423076a6d$var$FORWARD_REF_STATICS,
    [$08c3108423076a6d$var$Memo]: $08c3108423076a6d$var$MEMO_STATICS
};
function $08c3108423076a6d$var$getStatics(component) {
    if ($08c3108423076a6d$var$isMemo(component)) return $08c3108423076a6d$var$MEMO_STATICS;
    return $08c3108423076a6d$var$TYPE_STATICS[component["$$typeof"]] || $08c3108423076a6d$var$REACT_STATICS;
}
var $08c3108423076a6d$var$defineProperty = Object.defineProperty;
var $08c3108423076a6d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $08c3108423076a6d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $08c3108423076a6d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $08c3108423076a6d$var$getPrototypeOf = Object.getPrototypeOf;
var $08c3108423076a6d$var$objectPrototype = Object.prototype;
function $08c3108423076a6d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($08c3108423076a6d$var$objectPrototype) {
            const inheritedComponent = $08c3108423076a6d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $08c3108423076a6d$var$objectPrototype) $08c3108423076a6d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $08c3108423076a6d$var$getOwnPropertyNames(sourceComponent);
        if ($08c3108423076a6d$var$getOwnPropertySymbols) keys = keys.concat($08c3108423076a6d$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $08c3108423076a6d$var$getStatics(targetComponent);
        const sourceStatics = $08c3108423076a6d$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$08c3108423076a6d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $08c3108423076a6d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $08c3108423076a6d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $08c3108423076a6d$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $08c3108423076a6d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $08c3108423076a6d$var$getContext() {
    var _a;
    if (!$fgmOP.createContext) return {};
    const contextMap = (_a = $08c3108423076a6d$var$gT[$08c3108423076a6d$var$ContextKey]) != null ? _a : $08c3108423076a6d$var$gT[$08c3108423076a6d$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($fgmOP.createContext);
    if (!realContext) {
        realContext = $fgmOP.createContext(null);
        contextMap.set($fgmOP.createContext, realContext);
    }
    return realContext;
}
var $08c3108423076a6d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $08c3108423076a6d$var$getContext();
// src/components/connect.tsx
var $08c3108423076a6d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $08c3108423076a6d$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $08c3108423076a6d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $08c3108423076a6d$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $08c3108423076a6d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $08c3108423076a6d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $08c3108423076a6d$var$strictEqual(a, b) {
    return a === b;
}
var $08c3108423076a6d$var$hasWarnedAboutDeprecatedPureOption = false;
function $08c3108423076a6d$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $08c3108423076a6d$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $08c3108423076a6d$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $08c3108423076a6d$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $08c3108423076a6d$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $08c3108423076a6d$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $08c3108423076a6d$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $08c3108423076a6d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $08c3108423076a6d$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $fgmOP.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $08c3108423076a6d$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $fgmOP.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $fgmOP.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $fgmOP.useMemo(()=>{
                return $08c3108423076a6d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $fgmOP.useMemo(()=>{
                if (!shouldHandleStateChanges) return $08c3108423076a6d$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $08c3108423076a6d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $fgmOP.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $08c3108423076a6d$var$__spreadProps($08c3108423076a6d$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $fgmOP.useRef(void 0);
            const lastWrapperProps = $fgmOP.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $fgmOP.useRef(void 0);
            const renderIsScheduled = $fgmOP.useRef(false);
            const isMounted = $fgmOP.useRef(false);
            const latestSubscriptionCallbackError = $fgmOP.useRef(void 0);
            $08c3108423076a6d$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $fgmOP.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $fgmOP.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $08c3108423076a6d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $08c3108423076a6d$var$useIsomorphicLayoutEffectWithArgs($08c3108423076a6d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $fgmOP.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $08c3108423076a6d$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $fgmOP.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $fgmOP.createElement(WrappedComponent, $08c3108423076a6d$var$__spreadProps($08c3108423076a6d$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $fgmOP.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $fgmOP.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $fgmOP.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $fgmOP.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $fgmOP.createElement(Connect, $08c3108423076a6d$var$__spreadProps($08c3108423076a6d$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $08c3108423076a6d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $08c3108423076a6d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $08c3108423076a6d$export$64605811ab45167f = $08c3108423076a6d$var$_connect;
var $08c3108423076a6d$export$8807b5ba46f9d0b7 = $08c3108423076a6d$var$_connect;
// src/components/Provider.tsx
function $08c3108423076a6d$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $fgmOP.useMemo(()=>{
        const subscription = $08c3108423076a6d$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $fgmOP.useMemo(()=>store.getState(), [
        store
    ]);
    $08c3108423076a6d$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $08c3108423076a6d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $fgmOP.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $08c3108423076a6d$export$2881499e37b75b9a = $08c3108423076a6d$var$Provider;
// src/hooks/useReduxContext.ts
function $08c3108423076a6d$var$createReduxContextHook(context = $08c3108423076a6d$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $fgmOP.useContext(context);
        return contextValue;
    };
}
var $08c3108423076a6d$var$useReduxContext = /* @__PURE__ */ $08c3108423076a6d$var$createReduxContextHook();
// src/hooks/useStore.ts
function $08c3108423076a6d$export$671dba69185d0304(context = $08c3108423076a6d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $08c3108423076a6d$export$cc80c08dc91f1c00 ? $08c3108423076a6d$var$useReduxContext : // @ts-ignore
    $08c3108423076a6d$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $08c3108423076a6d$export$6ccbb43953eebf8 = /* @__PURE__ */ $08c3108423076a6d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $08c3108423076a6d$export$bc9b55530897c558(context = $08c3108423076a6d$export$cc80c08dc91f1c00) {
    const useStore2 = context === $08c3108423076a6d$export$cc80c08dc91f1c00 ? $08c3108423076a6d$export$6ccbb43953eebf8 : $08c3108423076a6d$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $08c3108423076a6d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $08c3108423076a6d$export$bc9b55530897c558();
var $08c3108423076a6d$var$refEquality = (a, b)=>a === b;
function $08c3108423076a6d$export$2b53f90d2bd1cbfb(context = $08c3108423076a6d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $08c3108423076a6d$export$cc80c08dc91f1c00 ? $08c3108423076a6d$var$useReduxContext : $08c3108423076a6d$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $08c3108423076a6d$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $fgmOP.useRef(true);
        const wrappedSelector = $fgmOP.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $d14fc6b02f0b440e$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $fgmOP.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $08c3108423076a6d$export$2105062e25df4afe = /* @__PURE__ */ $08c3108423076a6d$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $08c3108423076a6d$export$712ea50be43a7858 = $08c3108423076a6d$var$defaultNoopBatch;


// src/utils/formatProdErrorMessage.ts
function $2ec75f37e98b0842$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $2ec75f37e98b0842$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $2ec75f37e98b0842$var$symbol_observable_default = $2ec75f37e98b0842$var$$$observable;
// src/utils/actionTypes.ts
var $2ec75f37e98b0842$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $2ec75f37e98b0842$var$ActionTypes = {
    INIT: `@@redux/INIT${$2ec75f37e98b0842$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$2ec75f37e98b0842$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$2ec75f37e98b0842$var$randomString()}`
};
var $2ec75f37e98b0842$export$4219e499db7ca678 = $2ec75f37e98b0842$var$ActionTypes;
// src/utils/isPlainObject.ts
function $2ec75f37e98b0842$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $2ec75f37e98b0842$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($2ec75f37e98b0842$var$isDate(val)) return "date";
    if ($2ec75f37e98b0842$var$isError(val)) return "error";
    const constructorName = $2ec75f37e98b0842$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $2ec75f37e98b0842$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $2ec75f37e98b0842$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $2ec75f37e98b0842$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $2ec75f37e98b0842$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $2ec75f37e98b0842$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(1));
        return enhancer($2ec75f37e98b0842$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$2ec75f37e98b0842$export$53b83ca8eaab0383(action)) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $2ec75f37e98b0842$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$2ec75f37e98b0842$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $2ec75f37e98b0842$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$2ec75f37e98b0842$var$symbol_observable_default]: observable
    };
    return store;
}
function $2ec75f37e98b0842$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $2ec75f37e98b0842$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $2ec75f37e98b0842$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $2ec75f37e98b0842$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $2ec75f37e98b0842$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$2ec75f37e98b0842$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$2ec75f37e98b0842$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $2ec75f37e98b0842$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $2ec75f37e98b0842$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $2ec75f37e98b0842$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $2ec75f37e98b0842$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(13));
    });
}
function $2ec75f37e98b0842$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $2ec75f37e98b0842$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $2ec75f37e98b0842$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $2ec75f37e98b0842$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $2ec75f37e98b0842$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $2ec75f37e98b0842$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $2ec75f37e98b0842$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $2ec75f37e98b0842$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($2ec75f37e98b0842$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $2ec75f37e98b0842$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $2ec75f37e98b0842$export$b956e38827fca970(action) {
    return $2ec75f37e98b0842$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $c2e7e3ea96d4df80$var$__defProp = Object.defineProperty;
var $c2e7e3ea96d4df80$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c2e7e3ea96d4df80$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c2e7e3ea96d4df80$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c2e7e3ea96d4df80$var$__defNormalProp = (obj, key, value)=>key in obj ? $c2e7e3ea96d4df80$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c2e7e3ea96d4df80$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c2e7e3ea96d4df80$var$__hasOwnProp.call(b, prop)) $c2e7e3ea96d4df80$var$__defNormalProp(a, prop, b[prop]);
    if ($c2e7e3ea96d4df80$var$__getOwnPropSymbols) {
        for (var prop of $c2e7e3ea96d4df80$var$__getOwnPropSymbols(b))if ($c2e7e3ea96d4df80$var$__propIsEnum.call(b, prop)) $c2e7e3ea96d4df80$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $c2e7e3ea96d4df80$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $c2e7e3ea96d4df80$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $c2e7e3ea96d4df80$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $c2e7e3ea96d4df80$var$errors = [];
function $c2e7e3ea96d4df80$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $c2e7e3ea96d4df80$var$O = Object;
var $c2e7e3ea96d4df80$var$getPrototypeOf = $c2e7e3ea96d4df80$var$O.getPrototypeOf;
var $c2e7e3ea96d4df80$var$CONSTRUCTOR = "constructor";
var $c2e7e3ea96d4df80$var$PROTOTYPE = "prototype";
var $c2e7e3ea96d4df80$var$CONFIGURABLE = "configurable";
var $c2e7e3ea96d4df80$var$ENUMERABLE = "enumerable";
var $c2e7e3ea96d4df80$var$WRITABLE = "writable";
var $c2e7e3ea96d4df80$var$VALUE = "value";
var $c2e7e3ea96d4df80$export$541ac630993a4c84 = (value)=>!!value && !!value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
function $c2e7e3ea96d4df80$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $c2e7e3ea96d4df80$var$isPlainObject(value) || $c2e7e3ea96d4df80$var$isArray(value) || !!value[$c2e7e3ea96d4df80$export$6ee2082928bcb0ee] || !!((_a = value[$c2e7e3ea96d4df80$var$CONSTRUCTOR]) == null ? void 0 : _a[$c2e7e3ea96d4df80$export$6ee2082928bcb0ee]) || $c2e7e3ea96d4df80$var$isMap(value) || $c2e7e3ea96d4df80$var$isSet(value);
}
var $c2e7e3ea96d4df80$var$objectCtorString = $c2e7e3ea96d4df80$var$O[$c2e7e3ea96d4df80$var$PROTOTYPE][$c2e7e3ea96d4df80$var$CONSTRUCTOR].toString();
var $c2e7e3ea96d4df80$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $c2e7e3ea96d4df80$var$isPlainObject(value) {
    if (!value || !$c2e7e3ea96d4df80$var$isObjectish(value)) return false;
    const proto = $c2e7e3ea96d4df80$var$getPrototypeOf(value);
    if (proto === null || proto === $c2e7e3ea96d4df80$var$O[$c2e7e3ea96d4df80$var$PROTOTYPE]) return true;
    const Ctor = $c2e7e3ea96d4df80$var$O.hasOwnProperty.call(proto, $c2e7e3ea96d4df80$var$CONSTRUCTOR) && proto[$c2e7e3ea96d4df80$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$c2e7e3ea96d4df80$var$isFunction(Ctor)) return false;
    let ctorString = $c2e7e3ea96d4df80$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $c2e7e3ea96d4df80$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $c2e7e3ea96d4df80$var$objectCtorString;
}
function $c2e7e3ea96d4df80$export$22e8af3f75a010e3(value) {
    if (!$c2e7e3ea96d4df80$export$541ac630993a4c84(value)) $c2e7e3ea96d4df80$var$die(15, value);
    return value[$c2e7e3ea96d4df80$var$DRAFT_STATE].base_;
}
function $c2e7e3ea96d4df80$var$each(obj, iter, strict = true) {
    if ($c2e7e3ea96d4df80$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $c2e7e3ea96d4df80$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $c2e7e3ea96d4df80$var$getArchtype(thing) {
    const state = thing[$c2e7e3ea96d4df80$var$DRAFT_STATE];
    return state ? state.type_ : $c2e7e3ea96d4df80$var$isArray(thing) ? 1 /* Array */  : $c2e7e3ea96d4df80$var$isMap(thing) ? 2 /* Map */  : $c2e7e3ea96d4df80$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $c2e7e3ea96d4df80$var$has = (thing, prop, type = $c2e7e3ea96d4df80$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $c2e7e3ea96d4df80$var$O[$c2e7e3ea96d4df80$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $c2e7e3ea96d4df80$var$get = (thing, prop, type = $c2e7e3ea96d4df80$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $c2e7e3ea96d4df80$var$set = (thing, propOrOldValue, value, type = $c2e7e3ea96d4df80$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $c2e7e3ea96d4df80$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $c2e7e3ea96d4df80$var$isArray = Array.isArray;
var $c2e7e3ea96d4df80$var$isMap = (target)=>target instanceof Map;
var $c2e7e3ea96d4df80$var$isSet = (target)=>target instanceof Set;
var $c2e7e3ea96d4df80$var$isObjectish = (target)=>typeof target === "object";
var $c2e7e3ea96d4df80$var$isFunction = (target)=>typeof target === "function";
var $c2e7e3ea96d4df80$var$isBoolean = (target)=>typeof target === "boolean";
function $c2e7e3ea96d4df80$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $c2e7e3ea96d4df80$var$getProxyDraft = (value)=>{
    if (!$c2e7e3ea96d4df80$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
};
var $c2e7e3ea96d4df80$var$latest = (state)=>state.copy_ || state.base_;
var $c2e7e3ea96d4df80$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $c2e7e3ea96d4df80$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $c2e7e3ea96d4df80$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $c2e7e3ea96d4df80$var$shallowCopy(base, strict) {
    if ($c2e7e3ea96d4df80$var$isMap(base)) return new Map(base);
    if ($c2e7e3ea96d4df80$var$isSet(base)) return new Set(base);
    if ($c2e7e3ea96d4df80$var$isArray(base)) return Array[$c2e7e3ea96d4df80$var$PROTOTYPE].slice.call(base);
    const isPlain = $c2e7e3ea96d4df80$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $c2e7e3ea96d4df80$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$c2e7e3ea96d4df80$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$c2e7e3ea96d4df80$var$WRITABLE] === false) {
                desc[$c2e7e3ea96d4df80$var$WRITABLE] = true;
                desc[$c2e7e3ea96d4df80$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$c2e7e3ea96d4df80$var$CONFIGURABLE]: true,
                [$c2e7e3ea96d4df80$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$c2e7e3ea96d4df80$var$ENUMERABLE]: desc[$c2e7e3ea96d4df80$var$ENUMERABLE],
                [$c2e7e3ea96d4df80$var$VALUE]: base[key]
            };
        }
        return $c2e7e3ea96d4df80$var$O.create($c2e7e3ea96d4df80$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $c2e7e3ea96d4df80$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $c2e7e3ea96d4df80$var$__spreadValues({}, base);
        const obj = $c2e7e3ea96d4df80$var$O.create(proto);
        return $c2e7e3ea96d4df80$var$O.assign(obj, base);
    }
}
function $c2e7e3ea96d4df80$export$792f3d81ea979f55(obj, deep = false) {
    if ($c2e7e3ea96d4df80$var$isFrozen(obj) || $c2e7e3ea96d4df80$export$541ac630993a4c84(obj) || !$c2e7e3ea96d4df80$export$16e3aed3edb85946(obj)) return obj;
    if ($c2e7e3ea96d4df80$var$getArchtype(obj) > 1) $c2e7e3ea96d4df80$var$O.defineProperties(obj, {
        set: $c2e7e3ea96d4df80$var$dontMutateMethodOverride,
        add: $c2e7e3ea96d4df80$var$dontMutateMethodOverride,
        clear: $c2e7e3ea96d4df80$var$dontMutateMethodOverride,
        delete: $c2e7e3ea96d4df80$var$dontMutateMethodOverride
    });
    $c2e7e3ea96d4df80$var$O.freeze(obj);
    if (deep) $c2e7e3ea96d4df80$var$each(obj, (_key, value)=>{
        $c2e7e3ea96d4df80$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $c2e7e3ea96d4df80$var$dontMutateFrozenCollections() {
    $c2e7e3ea96d4df80$var$die(2);
}
var $c2e7e3ea96d4df80$var$dontMutateMethodOverride = {
    [$c2e7e3ea96d4df80$var$VALUE]: $c2e7e3ea96d4df80$var$dontMutateFrozenCollections
};
function $c2e7e3ea96d4df80$var$isFrozen(obj) {
    if (obj === null || !$c2e7e3ea96d4df80$var$isObjectish(obj)) return true;
    return $c2e7e3ea96d4df80$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $c2e7e3ea96d4df80$var$PluginMapSet = "MapSet";
var $c2e7e3ea96d4df80$var$PluginPatches = "Patches";
var $c2e7e3ea96d4df80$var$PluginArrayMethods = "ArrayMethods";
var $c2e7e3ea96d4df80$var$plugins = {};
function $c2e7e3ea96d4df80$var$getPlugin(pluginKey) {
    const plugin = $c2e7e3ea96d4df80$var$plugins[pluginKey];
    if (!plugin) $c2e7e3ea96d4df80$var$die(0, pluginKey);
    return plugin;
}
var $c2e7e3ea96d4df80$var$isPluginLoaded = (pluginKey)=>!!$c2e7e3ea96d4df80$var$plugins[pluginKey];
function $c2e7e3ea96d4df80$var$loadPlugin(pluginKey, implementation) {
    if (!$c2e7e3ea96d4df80$var$plugins[pluginKey]) $c2e7e3ea96d4df80$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $c2e7e3ea96d4df80$var$currentScope;
var $c2e7e3ea96d4df80$var$getCurrentScope = ()=>$c2e7e3ea96d4df80$var$currentScope;
var $c2e7e3ea96d4df80$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $c2e7e3ea96d4df80$var$isPluginLoaded($c2e7e3ea96d4df80$var$PluginMapSet) ? $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $c2e7e3ea96d4df80$var$isPluginLoaded($c2e7e3ea96d4df80$var$PluginArrayMethods) ? $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginArrayMethods) : void 0
    });
function $c2e7e3ea96d4df80$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $c2e7e3ea96d4df80$var$revokeScope(scope) {
    $c2e7e3ea96d4df80$var$leaveScope(scope);
    scope.drafts_.forEach($c2e7e3ea96d4df80$var$revokeDraft);
    scope.drafts_ = null;
}
function $c2e7e3ea96d4df80$var$leaveScope(scope) {
    if (scope === $c2e7e3ea96d4df80$var$currentScope) $c2e7e3ea96d4df80$var$currentScope = scope.parent_;
}
var $c2e7e3ea96d4df80$var$enterScope = (immer2)=>$c2e7e3ea96d4df80$var$currentScope = $c2e7e3ea96d4df80$var$createScope($c2e7e3ea96d4df80$var$currentScope, immer2);
function $c2e7e3ea96d4df80$var$revokeDraft(draft) {
    const state = draft[$c2e7e3ea96d4df80$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $c2e7e3ea96d4df80$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$c2e7e3ea96d4df80$var$DRAFT_STATE].modified_) {
            $c2e7e3ea96d4df80$var$revokeScope(scope);
            $c2e7e3ea96d4df80$var$die(4);
        }
        if ($c2e7e3ea96d4df80$export$16e3aed3edb85946(result)) result = $c2e7e3ea96d4df80$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$c2e7e3ea96d4df80$var$DRAFT_STATE].base_, result, scope);
    } else result = $c2e7e3ea96d4df80$var$finalize(scope, baseDraft);
    $c2e7e3ea96d4df80$var$maybeFreeze(scope, result, true);
    $c2e7e3ea96d4df80$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $c2e7e3ea96d4df80$export$45b790e32b2810ee ? result : void 0;
}
function $c2e7e3ea96d4df80$var$finalize(rootScope, value) {
    if ($c2e7e3ea96d4df80$var$isFrozen(value)) return value;
    const state = value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $c2e7e3ea96d4df80$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$c2e7e3ea96d4df80$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $c2e7e3ea96d4df80$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $c2e7e3ea96d4df80$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $c2e7e3ea96d4df80$export$792f3d81ea979f55(value, deep);
}
function $c2e7e3ea96d4df80$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $c2e7e3ea96d4df80$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $c2e7e3ea96d4df80$var$EMPTY_LOCATIONS_RESULT = [];
function $c2e7e3ea96d4df80$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $c2e7e3ea96d4df80$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $c2e7e3ea96d4df80$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $c2e7e3ea96d4df80$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $c2e7e3ea96d4df80$var$each(parentCopy, (key, value)=>{
            if ($c2e7e3ea96d4df80$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $c2e7e3ea96d4df80$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$c2e7e3ea96d4df80$var$set(parentCopy, location, finalizedValue, parentType);
}
function $c2e7e3ea96d4df80$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$c2e7e3ea96d4df80$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $c2e7e3ea96d4df80$var$getFinalValue(state);
        $c2e7e3ea96d4df80$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $c2e7e3ea96d4df80$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $c2e7e3ea96d4df80$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $c2e7e3ea96d4df80$var$markStateFinalized(state);
    }
}
function $c2e7e3ea96d4df80$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($c2e7e3ea96d4df80$export$541ac630993a4c84(value)) {
        const state = value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
        if ($c2e7e3ea96d4df80$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $c2e7e3ea96d4df80$var$prepareCopy(target);
            const finalizedValue = $c2e7e3ea96d4df80$var$getFinalValue(state);
            $c2e7e3ea96d4df80$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($c2e7e3ea96d4df80$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $c2e7e3ea96d4df80$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $c2e7e3ea96d4df80$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($c2e7e3ea96d4df80$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $c2e7e3ea96d4df80$var$handleValue($c2e7e3ea96d4df80$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $c2e7e3ea96d4df80$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($c2e7e3ea96d4df80$export$541ac630993a4c84(target) || handledSet.has(target) || !$c2e7e3ea96d4df80$export$16e3aed3edb85946(target) || $c2e7e3ea96d4df80$var$isFrozen(target)) return target;
    handledSet.add(target);
    $c2e7e3ea96d4df80$var$each(target, (key, value)=>{
        if ($c2e7e3ea96d4df80$export$541ac630993a4c84(value)) {
            const state = value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            if ($c2e7e3ea96d4df80$var$isSameScope(state, rootScope)) {
                const updatedValue = $c2e7e3ea96d4df80$var$getFinalValue(state);
                $c2e7e3ea96d4df80$var$set(target, key, updatedValue, target.type_);
                $c2e7e3ea96d4df80$var$markStateFinalized(state);
            }
        } else if ($c2e7e3ea96d4df80$export$16e3aed3edb85946(value)) $c2e7e3ea96d4df80$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $c2e7e3ea96d4df80$var$createProxyProxy(base, parent) {
    const baseIsArray = $c2e7e3ea96d4df80$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $c2e7e3ea96d4df80$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $c2e7e3ea96d4df80$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $c2e7e3ea96d4df80$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $c2e7e3ea96d4df80$var$objectTraps = {
    get (state, prop) {
        if (prop === $c2e7e3ea96d4df80$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $c2e7e3ea96d4df80$var$latest(state);
        if (!$c2e7e3ea96d4df80$var$has(source, prop, state.type_)) return $c2e7e3ea96d4df80$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$c2e7e3ea96d4df80$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $c2e7e3ea96d4df80$var$isArrayIndex(prop)) return value;
        if (value === $c2e7e3ea96d4df80$var$peek(state.base_, prop)) {
            $c2e7e3ea96d4df80$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $c2e7e3ea96d4df80$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $c2e7e3ea96d4df80$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($c2e7e3ea96d4df80$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $c2e7e3ea96d4df80$var$getDescriptorFromProto($c2e7e3ea96d4df80$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $c2e7e3ea96d4df80$var$peek($c2e7e3ea96d4df80$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($c2e7e3ea96d4df80$var$is(value, current2) && (value !== void 0 || $c2e7e3ea96d4df80$var$has(state.base_, prop, state.type_))) return true;
            $c2e7e3ea96d4df80$var$prepareCopy(state);
            $c2e7e3ea96d4df80$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $c2e7e3ea96d4df80$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $c2e7e3ea96d4df80$var$prepareCopy(state);
        if ($c2e7e3ea96d4df80$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $c2e7e3ea96d4df80$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $c2e7e3ea96d4df80$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$c2e7e3ea96d4df80$var$WRITABLE]: true,
            [$c2e7e3ea96d4df80$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$c2e7e3ea96d4df80$var$ENUMERABLE]: desc[$c2e7e3ea96d4df80$var$ENUMERABLE],
            [$c2e7e3ea96d4df80$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $c2e7e3ea96d4df80$var$die(11);
    },
    getPrototypeOf (state) {
        return $c2e7e3ea96d4df80$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $c2e7e3ea96d4df80$var$die(12);
    }
};
var $c2e7e3ea96d4df80$var$arrayTraps = {};
for(let key in $c2e7e3ea96d4df80$var$objectTraps){
    let fn = $c2e7e3ea96d4df80$var$objectTraps[key];
    $c2e7e3ea96d4df80$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$c2e7e3ea96d4df80$var$arrayTraps.deleteProperty = function(state, prop) {
    return $c2e7e3ea96d4df80$var$arrayTraps.set.call(this, state, prop, void 0);
};
$c2e7e3ea96d4df80$var$arrayTraps.set = function(state, prop, value) {
    return $c2e7e3ea96d4df80$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $c2e7e3ea96d4df80$var$peek(draft, prop) {
    const state = draft[$c2e7e3ea96d4df80$var$DRAFT_STATE];
    const source = state ? $c2e7e3ea96d4df80$var$latest(state) : draft;
    return source[prop];
}
function $c2e7e3ea96d4df80$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $c2e7e3ea96d4df80$var$getDescriptorFromProto(source, prop);
    return desc ? $c2e7e3ea96d4df80$var$VALUE in desc ? desc[$c2e7e3ea96d4df80$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $c2e7e3ea96d4df80$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $c2e7e3ea96d4df80$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $c2e7e3ea96d4df80$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $c2e7e3ea96d4df80$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $c2e7e3ea96d4df80$var$markChanged(state.parent_);
    }
}
function $c2e7e3ea96d4df80$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $c2e7e3ea96d4df80$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $c2e7e3ea96d4df80$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($c2e7e3ea96d4df80$var$isFunction(base) && !$c2e7e3ea96d4df80$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$c2e7e3ea96d4df80$var$isFunction(recipe)) $c2e7e3ea96d4df80$var$die(6);
            if (patchListener !== void 0 && !$c2e7e3ea96d4df80$var$isFunction(patchListener)) $c2e7e3ea96d4df80$var$die(7);
            let result;
            if ($c2e7e3ea96d4df80$export$16e3aed3edb85946(base)) {
                const scope = $c2e7e3ea96d4df80$var$enterScope(this);
                const proxy = $c2e7e3ea96d4df80$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $c2e7e3ea96d4df80$var$revokeScope(scope);
                    else $c2e7e3ea96d4df80$var$leaveScope(scope);
                }
                $c2e7e3ea96d4df80$var$usePatchesInScope(scope, patchListener);
                return $c2e7e3ea96d4df80$var$processResult(result, scope);
            } else if (!base || !$c2e7e3ea96d4df80$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $c2e7e3ea96d4df80$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $c2e7e3ea96d4df80$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $c2e7e3ea96d4df80$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($c2e7e3ea96d4df80$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($c2e7e3ea96d4df80$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($c2e7e3ea96d4df80$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($c2e7e3ea96d4df80$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$c2e7e3ea96d4df80$export$16e3aed3edb85946(base)) $c2e7e3ea96d4df80$var$die(8);
        if ($c2e7e3ea96d4df80$export$541ac630993a4c84(base)) base = $c2e7e3ea96d4df80$export$97aac956da55dae9(base);
        const scope = $c2e7e3ea96d4df80$var$enterScope(this);
        const proxy = $c2e7e3ea96d4df80$var$createProxy(scope, base, void 0);
        proxy[$c2e7e3ea96d4df80$var$DRAFT_STATE].isManual_ = true;
        $c2e7e3ea96d4df80$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$c2e7e3ea96d4df80$var$DRAFT_STATE];
        if (!state || !state.isManual_) $c2e7e3ea96d4df80$var$die(9);
        const { scope_: scope } = state;
        $c2e7e3ea96d4df80$var$usePatchesInScope(scope, patchListener);
        return $c2e7e3ea96d4df80$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginPatches).applyPatches_;
        if ($c2e7e3ea96d4df80$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $c2e7e3ea96d4df80$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $c2e7e3ea96d4df80$var$isMap(value) ? $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginMapSet).proxyMap_(value, parent) : $c2e7e3ea96d4df80$var$isSet(value) ? $c2e7e3ea96d4df80$var$getPlugin($c2e7e3ea96d4df80$var$PluginMapSet).proxySet_(value, parent) : $c2e7e3ea96d4df80$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $c2e7e3ea96d4df80$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $c2e7e3ea96d4df80$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $c2e7e3ea96d4df80$export$97aac956da55dae9(value) {
    if (!$c2e7e3ea96d4df80$export$541ac630993a4c84(value)) $c2e7e3ea96d4df80$var$die(10, value);
    return $c2e7e3ea96d4df80$var$currentImpl(value);
}
function $c2e7e3ea96d4df80$var$currentImpl(value) {
    if (!$c2e7e3ea96d4df80$export$16e3aed3edb85946(value) || $c2e7e3ea96d4df80$var$isFrozen(value)) return value;
    const state = value[$c2e7e3ea96d4df80$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $c2e7e3ea96d4df80$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $c2e7e3ea96d4df80$var$shallowCopy(value, true);
    $c2e7e3ea96d4df80$var$each(copy, (key, childValue)=>{
        $c2e7e3ea96d4df80$var$set(copy, key, $c2e7e3ea96d4df80$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $c2e7e3ea96d4df80$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $c2e7e3ea96d4df80$var$getProxyDraft($c2e7e3ea96d4df80$var$get(parentCopy, state.key_));
            const valueAtKey = $c2e7e3ea96d4df80$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $c2e7e3ea96d4df80$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $c2e7e3ea96d4df80$var$get(current2, key);
            if (!$c2e7e3ea96d4df80$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$c2e7e3ea96d4df80$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $c2e7e3ea96d4df80$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $c2e7e3ea96d4df80$var$get(base_, key, type_);
            const value = $c2e7e3ea96d4df80$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $c2e7e3ea96d4df80$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $c2e7e3ea96d4df80$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $c2e7e3ea96d4df80$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $c2e7e3ea96d4df80$var$CONSTRUCTOR)) $c2e7e3ea96d4df80$var$die(errorOffset + 3);
                if ($c2e7e3ea96d4df80$var$isFunction(base) && p === $c2e7e3ea96d4df80$var$PROTOTYPE) $c2e7e3ea96d4df80$var$die(errorOffset + 3);
                base = $c2e7e3ea96d4df80$var$get(base, p);
                if (!$c2e7e3ea96d4df80$var$isObjectish(base)) $c2e7e3ea96d4df80$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $c2e7e3ea96d4df80$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $c2e7e3ea96d4df80$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $c2e7e3ea96d4df80$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$c2e7e3ea96d4df80$export$16e3aed3edb85946(obj)) return obj;
        if ($c2e7e3ea96d4df80$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($c2e7e3ea96d4df80$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($c2e7e3ea96d4df80$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($c2e7e3ea96d4df80$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($c2e7e3ea96d4df80$var$has(obj, $c2e7e3ea96d4df80$export$6ee2082928bcb0ee)) cloned[$c2e7e3ea96d4df80$export$6ee2082928bcb0ee] = obj[$c2e7e3ea96d4df80$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($c2e7e3ea96d4df80$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $c2e7e3ea96d4df80$var$loadPlugin($c2e7e3ea96d4df80$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $c2e7e3ea96d4df80$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$c2e7e3ea96d4df80$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $c2e7e3ea96d4df80$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $c2e7e3ea96d4df80$var$latest(this[$c2e7e3ea96d4df80$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $c2e7e3ea96d4df80$var$latest(this[$c2e7e3ea96d4df80$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$c2e7e3ea96d4df80$var$latest(state).has(key) || $c2e7e3ea96d4df80$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $c2e7e3ea96d4df80$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $c2e7e3ea96d4df80$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $c2e7e3ea96d4df80$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($c2e7e3ea96d4df80$var$latest(state).size) {
                prepareMapCopy(state);
                $c2e7e3ea96d4df80$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $c2e7e3ea96d4df80$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            $c2e7e3ea96d4df80$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $c2e7e3ea96d4df80$var$latest(state).get(key);
            if (state.finalized_ || !$c2e7e3ea96d4df80$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $c2e7e3ea96d4df80$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $c2e7e3ea96d4df80$var$latest(this[$c2e7e3ea96d4df80$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($c2e7e3ea96d4df80$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$c2e7e3ea96d4df80$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$c2e7e3ea96d4df80$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $c2e7e3ea96d4df80$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $c2e7e3ea96d4df80$var$latest(this[$c2e7e3ea96d4df80$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $c2e7e3ea96d4df80$var$markChanged(state);
                state.copy_.add(value);
                $c2e7e3ea96d4df80$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $c2e7e3ea96d4df80$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($c2e7e3ea96d4df80$var$latest(state).size) {
                prepareSetCopy(state);
                $c2e7e3ea96d4df80$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$c2e7e3ea96d4df80$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($c2e7e3ea96d4df80$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$c2e7e3ea96d4df80$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($c2e7e3ea96d4df80$export$16e3aed3edb85946(value)) {
                    const draft = $c2e7e3ea96d4df80$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $c2e7e3ea96d4df80$var$die(3, JSON.stringify($c2e7e3ea96d4df80$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($c2e7e3ea96d4df80$var$getValue(value));
            });
        }
    }
    $c2e7e3ea96d4df80$var$loadPlugin($c2e7e3ea96d4df80$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $c2e7e3ea96d4df80$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $c2e7e3ea96d4df80$var$prepareCopy(state);
        const result = operation();
        $c2e7e3ea96d4df80$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $c2e7e3ea96d4df80$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $c2e7e3ea96d4df80$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $c2e7e3ea96d4df80$var$loadPlugin($c2e7e3ea96d4df80$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $c2e7e3ea96d4df80$var$immer = new $c2e7e3ea96d4df80$export$aaadc6ff0f822719();
var $c2e7e3ea96d4df80$export$b46cabe22e78bc00 = $c2e7e3ea96d4df80$var$immer.produce;
var $c2e7e3ea96d4df80$export$4da66d41c9492c78 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.produceWithPatches.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$573f26f60825c493 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.setAutoFreeze.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$333ce65961cbe047 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.setUseStrictShallowCopy.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$1045b3be3904c489 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.setUseStrictIteration.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.applyPatches.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$3c3214997190395f = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.createDraft.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$c60f5e69c521b528 = /* @__PURE__ */ $c2e7e3ea96d4df80$var$immer.finishDraft.bind($c2e7e3ea96d4df80$var$immer);
var $c2e7e3ea96d4df80$export$c05b21e3257751e5 = (value)=>value;
var $c2e7e3ea96d4df80$export$20f911b3f8cf0b74 = (value)=>value;


var $a278501282086c74$var$__defProp = Object.defineProperty;
var $a278501282086c74$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a278501282086c74$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a278501282086c74$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a278501282086c74$var$__defNormalProp = (obj, key, value)=>key in obj ? $a278501282086c74$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a278501282086c74$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a278501282086c74$var$__hasOwnProp.call(b, prop)) $a278501282086c74$var$__defNormalProp(a, prop, b[prop]);
    if ($a278501282086c74$var$__getOwnPropSymbols) {
        for (var prop of $a278501282086c74$var$__getOwnPropSymbols(b))if ($a278501282086c74$var$__propIsEnum.call(b, prop)) $a278501282086c74$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a278501282086c74$var$__publicField = (obj, key, value)=>$a278501282086c74$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/devModeChecks/identityFunctionCheck.ts
var $a278501282086c74$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $a278501282086c74$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $a278501282086c74$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $a278501282086c74$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($a278501282086c74$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $a278501282086c74$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $a278501282086c74$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $a278501282086c74$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $a278501282086c74$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $a278501282086c74$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $a278501282086c74$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $a278501282086c74$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $a278501282086c74$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $a278501282086c74$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $a278501282086c74$var$__spreadValues($a278501282086c74$var$__spreadValues({}, $a278501282086c74$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $a278501282086c74$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $a278501282086c74$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $a278501282086c74$var$$REVISION = 0;
var $a278501282086c74$var$CURRENT_TRACKER = null;
var $a278501282086c74$var$Cell = class {
    constructor(initialValue, isEqual = $a278501282086c74$var$tripleEq){
        $a278501282086c74$var$__publicField(this, "revision", $a278501282086c74$var$$REVISION);
        $a278501282086c74$var$__publicField(this, "_value");
        $a278501282086c74$var$__publicField(this, "_lastValue");
        $a278501282086c74$var$__publicField(this, "_isEqual", $a278501282086c74$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $a278501282086c74$var$CURRENT_TRACKER == null || $a278501282086c74$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$a278501282086c74$var$$REVISION;
    }
};
function $a278501282086c74$var$tripleEq(a, b) {
    return a === b;
}
var $a278501282086c74$var$TrackingCache = class {
    constructor(fn){
        $a278501282086c74$var$__publicField(this, "_cachedValue");
        $a278501282086c74$var$__publicField(this, "_cachedRevision", -1);
        $a278501282086c74$var$__publicField(this, "_deps", []);
        $a278501282086c74$var$__publicField(this, "hits", 0);
        $a278501282086c74$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $a278501282086c74$var$CURRENT_TRACKER;
            $a278501282086c74$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $a278501282086c74$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $a278501282086c74$var$CURRENT_TRACKER == null || $a278501282086c74$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $a278501282086c74$var$getValue(cell) {
    if (!(cell instanceof $a278501282086c74$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $a278501282086c74$var$setValue(storage, value) {
    if (!(storage instanceof $a278501282086c74$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $a278501282086c74$var$createCell(initialValue, isEqual = $a278501282086c74$var$tripleEq) {
    return new $a278501282086c74$var$Cell(initialValue, isEqual);
}
function $a278501282086c74$var$createCache(fn) {
    $a278501282086c74$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $a278501282086c74$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $a278501282086c74$var$neverEq = (a, b)=>false;
function $a278501282086c74$var$createTag() {
    return $a278501282086c74$var$createCell(null, $a278501282086c74$var$neverEq);
}
function $a278501282086c74$var$dirtyTag(tag, value) {
    $a278501282086c74$var$setValue(tag, value);
}
var $a278501282086c74$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $a278501282086c74$var$createTag();
    $a278501282086c74$var$getValue(tag);
};
var $a278501282086c74$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $a278501282086c74$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $a278501282086c74$var$nextId = 0;
var $a278501282086c74$var$proto = /* @__PURE__ */ Object.getPrototypeOf({});
var $a278501282086c74$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $a278501282086c74$var$__publicField(this, "proxy", new Proxy(this, $a278501282086c74$var$objectProxyHandler));
        $a278501282086c74$var$__publicField(this, "tag", $a278501282086c74$var$createTag());
        $a278501282086c74$var$__publicField(this, "tags", {});
        $a278501282086c74$var$__publicField(this, "children", {});
        $a278501282086c74$var$__publicField(this, "collectionTag", null);
        $a278501282086c74$var$__publicField(this, "id", $a278501282086c74$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $a278501282086c74$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $a278501282086c74$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $a278501282086c74$var$createNode(childValue);
                if (childNode.tag) $a278501282086c74$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $a278501282086c74$var$createTag();
                    tag.value = childValue;
                }
                $a278501282086c74$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $a278501282086c74$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $a278501282086c74$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $a278501282086c74$var$__publicField(this, "proxy", new Proxy([
            this
        ], $a278501282086c74$var$arrayProxyHandler));
        $a278501282086c74$var$__publicField(this, "tag", $a278501282086c74$var$createTag());
        $a278501282086c74$var$__publicField(this, "tags", {});
        $a278501282086c74$var$__publicField(this, "children", {});
        $a278501282086c74$var$__publicField(this, "collectionTag", null);
        $a278501282086c74$var$__publicField(this, "id", $a278501282086c74$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $a278501282086c74$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $a278501282086c74$var$consumeCollection(node);
        return $a278501282086c74$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $a278501282086c74$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $a278501282086c74$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $a278501282086c74$var$objectProxyHandler.has(node, prop);
    }
};
function $a278501282086c74$var$createNode(value) {
    if (Array.isArray(value)) return new $a278501282086c74$var$ArrayTreeNode(value);
    return new $a278501282086c74$var$ObjectTreeNode(value);
}
function $a278501282086c74$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $a278501282086c74$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $a278501282086c74$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $a278501282086c74$var$dirtyCollection(node);
            $a278501282086c74$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $a278501282086c74$var$updateNode(childNode, newChildValue);
        else {
            $a278501282086c74$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $a278501282086c74$var$deleteNode(node) {
    if (node.tag) $a278501282086c74$var$dirtyTag(node.tag, null);
    $a278501282086c74$var$dirtyCollection(node);
    for(const key in node.tags)$a278501282086c74$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$a278501282086c74$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $a278501282086c74$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $a278501282086c74$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $a278501282086c74$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $a278501282086c74$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $a278501282086c74$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $a278501282086c74$export$3f025202a230c6dd = (a, b)=>a === b;
function $a278501282086c74$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $a278501282086c74$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $a278501282086c74$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $a278501282086c74$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $a278501282086c74$var$createSingletonCache(comparator) : $a278501282086c74$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $a278501282086c74$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $a278501282086c74$export$c8f9cf88d9fdee55(func) {
    const node = $a278501282086c74$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $a278501282086c74$var$createCacheKeyComparator($a278501282086c74$export$3f025202a230c6dd);
    const cache = $a278501282086c74$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $a278501282086c74$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $a278501282086c74$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $a278501282086c74$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $a278501282086c74$var$StrongRef : WeakRef;
var $a278501282086c74$var$Ref = /* @__PURE__ */ $a278501282086c74$var$getWeakRef();
var $a278501282086c74$var$UNTERMINATED = 0;
var $a278501282086c74$var$TERMINATED = 1;
function $a278501282086c74$var$createCacheNode() {
    return {
        s: $a278501282086c74$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $a278501282086c74$var$maybeDeref(r) {
    if (r instanceof $a278501282086c74$var$Ref) return r.deref();
    return r;
}
function $a278501282086c74$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $a278501282086c74$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $a278501282086c74$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $a278501282086c74$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $a278501282086c74$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = $a278501282086c74$var$maybeDeref(lastResult);
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? /* @__PURE__ */ new $a278501282086c74$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $a278501282086c74$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $a278501282086c74$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $a278501282086c74$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $a278501282086c74$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $a278501282086c74$var$__spreadValues($a278501282086c74$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $a278501282086c74$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $a278501282086c74$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $a278501282086c74$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $a278501282086c74$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $a278501282086c74$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $a278501282086c74$export$595d22ed68ca2841 = /* @__PURE__ */ $a278501282086c74$export$5943f4447f6ef248($a278501282086c74$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $a278501282086c74$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $a278501282086c74$export$595d22ed68ca2841)=>{
    $a278501282086c74$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$a278501282086c74$export$75979cfcd91bf38f
});


// src/index.ts
function $85e6811302879f9e$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $85e6811302879f9e$export$dd164f5517779f15 = $85e6811302879f9e$var$createThunkMiddleware();
var $85e6811302879f9e$export$16d06542a1949d9e = $85e6811302879f9e$var$createThunkMiddleware;


var $470573b2591428b2$var$__defProp = Object.defineProperty;
var $470573b2591428b2$var$__defProps = Object.defineProperties;
var $470573b2591428b2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $470573b2591428b2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $470573b2591428b2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $470573b2591428b2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $470573b2591428b2$var$__defNormalProp = (obj, key, value)=>key in obj ? $470573b2591428b2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $470573b2591428b2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($470573b2591428b2$var$__hasOwnProp.call(b, prop)) $470573b2591428b2$var$__defNormalProp(a, prop, b[prop]);
    if ($470573b2591428b2$var$__getOwnPropSymbols) {
        for (var prop of $470573b2591428b2$var$__getOwnPropSymbols(b))if ($470573b2591428b2$var$__propIsEnum.call(b, prop)) $470573b2591428b2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $470573b2591428b2$var$__spreadProps = (a, b)=>$470573b2591428b2$var$__defProps(a, $470573b2591428b2$var$__getOwnPropDescs(b));
var $470573b2591428b2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($470573b2591428b2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $470573b2591428b2$var$__getOwnPropSymbols) {
        for (var prop of $470573b2591428b2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $470573b2591428b2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $470573b2591428b2$var$__publicField = (obj, key, value)=>$470573b2591428b2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $470573b2591428b2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $a278501282086c74$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $c2e7e3ea96d4df80$export$541ac630993a4c84)(value) ? (0, $c2e7e3ea96d4df80$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $470573b2591428b2$export$a5d3c27355e35910 = /* @__PURE__ */ $470573b2591428b2$export$aab6de9e3dbb1473((0, $a278501282086c74$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $470573b2591428b2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $2ec75f37e98b0842$export$f672e0b6f7222cd7;
    return (0, $2ec75f37e98b0842$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $470573b2591428b2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $470573b2591428b2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $470573b2591428b2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($470573b2591428b2$export$378fa86b259c0280(0));
            return $470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $2ec75f37e98b0842$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $470573b2591428b2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $470573b2591428b2$var$hasMatchFunction(action);
}
function $470573b2591428b2$export$ebd532f9034651f3(action) {
    return (0, $2ec75f37e98b0842$export$b956e38827fca970)(action) && Object.keys(action).every($470573b2591428b2$var$isValidKey);
}
function $470573b2591428b2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $470573b2591428b2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $470573b2591428b2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $470573b2591428b2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $470573b2591428b2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $470573b2591428b2$var$freezeDraftable(val) {
    return (0, $c2e7e3ea96d4df80$export$16e3aed3edb85946)(val) ? (0, $c2e7e3ea96d4df80$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $470573b2591428b2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $470573b2591428b2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $470573b2591428b2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $470573b2591428b2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $470573b2591428b2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $470573b2591428b2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $470573b2591428b2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $470573b2591428b2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $470573b2591428b2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $470573b2591428b2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $470573b2591428b2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $2ec75f37e98b0842$export$53b83ca8eaab0383)(val);
}
function $470573b2591428b2$export$ada5dca0b571bc7(value, path = "", isSerializable = $470573b2591428b2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $470573b2591428b2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $470573b2591428b2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $470573b2591428b2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$470573b2591428b2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $470573b2591428b2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $470573b2591428b2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $470573b2591428b2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $470573b2591428b2$export$1908877435b1d5e9();
        if (thunk) {
            if ($470573b2591428b2$var$isBoolean(thunk)) middlewareArray.push((0, $85e6811302879f9e$export$dd164f5517779f15));
            else middlewareArray.push((0, $85e6811302879f9e$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $470573b2591428b2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $470573b2591428b2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$470573b2591428b2$export$8fb31c0f05df007b]: true
            }
        });
var $470573b2591428b2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $470573b2591428b2$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        const rafId = raf(callback);
        const timerId = setTimeout(callback, timeout);
    };
};
var $470573b2591428b2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? $470573b2591428b2$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $470573b2591428b2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $470573b2591428b2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$470573b2591428b2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $470573b2591428b2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $470573b2591428b2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($470573b2591428b2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $470573b2591428b2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $470573b2591428b2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $2ec75f37e98b0842$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $2ec75f37e98b0842$export$66e4520cdb265d18)(reducer);
    else throw new Error($470573b2591428b2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $2ec75f37e98b0842$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $470573b2591428b2$var$composeWithDevTools($470573b2591428b2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $2ec75f37e98b0842$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $470573b2591428b2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $2ec75f37e98b0842$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $470573b2591428b2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($470573b2591428b2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($470573b2591428b2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $470573b2591428b2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $470573b2591428b2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $470573b2591428b2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($470573b2591428b2$var$isStateFunction(initialState)) getInitialState = ()=>$470573b2591428b2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $470573b2591428b2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $c2e7e3ea96d4df80$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $c2e7e3ea96d4df80$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $c2e7e3ea96d4df80$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $470573b2591428b2$var$matches = (matcher, action)=>{
    if ($470573b2591428b2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $470573b2591428b2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$470573b2591428b2$var$matches(matcher, action));
    };
}
function $470573b2591428b2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$470573b2591428b2$var$matches(matcher, action));
    };
}
function $470573b2591428b2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $470573b2591428b2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $470573b2591428b2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$470573b2591428b2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$470573b2591428b2$var$isAsyncThunkArray(asyncThunks)) return $470573b2591428b2$export$872dec21e9a69476()(asyncThunks[0]);
    return $470573b2591428b2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $470573b2591428b2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$470573b2591428b2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$470573b2591428b2$var$isAsyncThunkArray(asyncThunks)) return $470573b2591428b2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $470573b2591428b2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $470573b2591428b2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $470573b2591428b2$export$9dd1fb32974da385($470573b2591428b2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$470573b2591428b2$var$isAsyncThunkArray(asyncThunks)) return $470573b2591428b2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $470573b2591428b2$export$9dd1fb32974da385($470573b2591428b2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $470573b2591428b2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$470573b2591428b2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$470573b2591428b2$var$isAsyncThunkArray(asyncThunks)) return $470573b2591428b2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $470573b2591428b2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $470573b2591428b2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$470573b2591428b2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$470573b2591428b2$var$isAsyncThunkArray(asyncThunks)) return $470573b2591428b2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $470573b2591428b2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $470573b2591428b2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $470573b2591428b2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $470573b2591428b2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $470573b2591428b2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $470573b2591428b2$var$RejectWithValue = class {
    constructor(payload, meta){
        $470573b2591428b2$var$__publicField(this, "payload", payload);
        $470573b2591428b2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $470573b2591428b2$var$__publicField(this, "_type");
    }
};
var $470573b2591428b2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        $470573b2591428b2$var$__publicField(this, "payload", payload);
        $470573b2591428b2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $470573b2591428b2$var$__publicField(this, "_type");
    }
};
var $470573b2591428b2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $470573b2591428b2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $470573b2591428b2$var$externalAbortMessage = "External signal was aborted";
var $470573b2591428b2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $470573b2591428b2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $470573b2591428b2$var$__spreadProps($470573b2591428b2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $470573b2591428b2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $470573b2591428b2$var$__spreadProps($470573b2591428b2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $470573b2591428b2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $470573b2591428b2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $470573b2591428b2$var$__spreadProps($470573b2591428b2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $470573b2591428b2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($470573b2591428b2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($470573b2591428b2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($470573b2591428b2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $470573b2591428b2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $470573b2591428b2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $470573b2591428b2$var$RejectWithValue) throw result;
                                if (result instanceof $470573b2591428b2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $470573b2591428b2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($470573b2591428b2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $470573b2591428b2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $470573b2591428b2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $470573b2591428b2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $470573b2591428b2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $470573b2591428b2$export$343355ed40c51c46 = {
    [$470573b2591428b2$var$asyncThunkSymbol]: $470573b2591428b2$export$6abd22dc03e5063f
};
var $470573b2591428b2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($470573b2591428b2$export$23a094319a4b586 || {});
function $470573b2591428b2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $470573b2591428b2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$470573b2591428b2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($470573b2591428b2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($470573b2591428b2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($470573b2591428b2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($470573b2591428b2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $470573b2591428b2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($470573b2591428b2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $470573b2591428b2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $470573b2591428b2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $470573b2591428b2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $470573b2591428b2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $470573b2591428b2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $470573b2591428b2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $470573b2591428b2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $470573b2591428b2$var$wrapSelector(selector, selectState, ()=>$470573b2591428b2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $470573b2591428b2$var$__spreadProps($470573b2591428b2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $470573b2591428b2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $470573b2591428b2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $470573b2591428b2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $470573b2591428b2$export$affdea4146de9cf5();
function $470573b2591428b2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $470573b2591428b2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $470573b2591428b2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$470573b2591428b2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($470573b2591428b2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $470573b2591428b2$export$309c7a02b0b0bc62(type, prepareCallback) : $470573b2591428b2$export$309c7a02b0b0bc62(type));
}
function $470573b2591428b2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $470573b2591428b2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $470573b2591428b2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($470573b2591428b2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $470573b2591428b2$var$noop,
        pending: pending || $470573b2591428b2$var$noop,
        rejected: rejected || $470573b2591428b2$var$noop,
        settled: settled || $470573b2591428b2$var$noop
    });
}
function $470573b2591428b2$var$noop() {}
// src/entities/entity_state.ts
function $470573b2591428b2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $470573b2591428b2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($470573b2591428b2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $470573b2591428b2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $470573b2591428b2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $470573b2591428b2$var$isDraftTyped = (0, $c2e7e3ea96d4df80$export$541ac630993a4c84);
function $470573b2591428b2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $470573b2591428b2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $470573b2591428b2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $470573b2591428b2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($470573b2591428b2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $c2e7e3ea96d4df80$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $470573b2591428b2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $470573b2591428b2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $470573b2591428b2$var$getCurrent(value) {
    return (0, $c2e7e3ea96d4df80$export$541ac630993a4c84)(value) ? (0, $c2e7e3ea96d4df80$export$97aac956da55dae9)(value) : value;
}
function $470573b2591428b2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $470573b2591428b2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $470573b2591428b2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $470573b2591428b2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $470573b2591428b2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $470573b2591428b2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $470573b2591428b2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$470573b2591428b2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $470573b2591428b2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $470573b2591428b2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $470573b2591428b2$var$createStateOperator(addOneMutably),
        addMany: $470573b2591428b2$var$createStateOperator(addManyMutably),
        setOne: $470573b2591428b2$var$createStateOperator(setOneMutably),
        setMany: $470573b2591428b2$var$createStateOperator(setManyMutably),
        setAll: $470573b2591428b2$var$createStateOperator(setAllMutably),
        updateOne: $470573b2591428b2$var$createStateOperator(updateOneMutably),
        updateMany: $470573b2591428b2$var$createStateOperator(updateManyMutably),
        upsertOne: $470573b2591428b2$var$createStateOperator(upsertOneMutably),
        upsertMany: $470573b2591428b2$var$createStateOperator(upsertManyMutably),
        removeOne: $470573b2591428b2$var$createStateOperator(removeOneMutably),
        removeMany: $470573b2591428b2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $470573b2591428b2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $470573b2591428b2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $470573b2591428b2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $470573b2591428b2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $470573b2591428b2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $470573b2591428b2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $470573b2591428b2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $470573b2591428b2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $470573b2591428b2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $470573b2591428b2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $470573b2591428b2$var$getCurrent(state.entities);
        const currentIds = $470573b2591428b2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $470573b2591428b2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $470573b2591428b2$var$createStateOperator(addOneMutably),
        updateOne: $470573b2591428b2$var$createStateOperator(updateOneMutably),
        upsertOne: $470573b2591428b2$var$createStateOperator(upsertOneMutably),
        setOne: $470573b2591428b2$var$createStateOperator(setOneMutably),
        setMany: $470573b2591428b2$var$createStateOperator(setManyMutably),
        setAll: $470573b2591428b2$var$createStateOperator(setAllMutably),
        addMany: $470573b2591428b2$var$createStateOperator(addManyMutably),
        updateMany: $470573b2591428b2$var$createStateOperator(updateManyMutably),
        upsertMany: $470573b2591428b2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $470573b2591428b2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $470573b2591428b2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $470573b2591428b2$var$createSortedStateAdapter(selectId, sortComparer) : $470573b2591428b2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $470573b2591428b2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $470573b2591428b2$var$createSelectorsFactory();
    return $470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues($470573b2591428b2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $470573b2591428b2$var$task = "task";
var $470573b2591428b2$var$listener = "listener";
var $470573b2591428b2$var$completed = "completed";
var $470573b2591428b2$var$cancelled = "cancelled";
var $470573b2591428b2$var$taskCancelled = `task-${$470573b2591428b2$var$cancelled}`;
var $470573b2591428b2$var$taskCompleted = `task-${$470573b2591428b2$var$completed}`;
var $470573b2591428b2$var$listenerCancelled = `${$470573b2591428b2$var$listener}-${$470573b2591428b2$var$cancelled}`;
var $470573b2591428b2$var$listenerCompleted = `${$470573b2591428b2$var$listener}-${$470573b2591428b2$var$completed}`;
var $470573b2591428b2$export$cb1bdac908fed7f = class {
    constructor(code){
        $470573b2591428b2$var$__publicField(this, "code", code);
        $470573b2591428b2$var$__publicField(this, "name", "TaskAbortError");
        $470573b2591428b2$var$__publicField(this, "message");
        this.message = `${$470573b2591428b2$var$task} ${$470573b2591428b2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $470573b2591428b2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($470573b2591428b2$export$378fa86b259c0280(32));
};
var $470573b2591428b2$var$noop2 = ()=>{};
var $470573b2591428b2$var$catchRejection = (promise, onError = $470573b2591428b2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $470573b2591428b2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $470573b2591428b2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $470573b2591428b2$export$cb1bdac908fed7f(signal.reason);
};
function $470573b2591428b2$var$raceWithSignal(signal, promise) {
    let cleanup = $470573b2591428b2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $470573b2591428b2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $470573b2591428b2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $470573b2591428b2$var$noop2;
    });
}
var $470573b2591428b2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $470573b2591428b2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $470573b2591428b2$var$createPause = (signal)=>{
    return (promise)=>{
        return $470573b2591428b2$var$catchRejection($470573b2591428b2$var$raceWithSignal(signal, promise).then((output)=>{
            $470573b2591428b2$var$validateActive(signal);
            return output;
        }));
    };
};
var $470573b2591428b2$var$createDelay = (signal)=>{
    const pause = $470573b2591428b2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $470573b2591428b2$var$assign } = Object;
var $470573b2591428b2$var$INTERNAL_NIL_TOKEN = {};
var $470573b2591428b2$var$alm = "listenerMiddleware";
var $470573b2591428b2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$470573b2591428b2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $470573b2591428b2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $470573b2591428b2$var$runTask(async ()=>{
            $470573b2591428b2$var$validateActive(parentAbortSignal);
            $470573b2591428b2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $470573b2591428b2$var$createPause(childAbortController.signal),
                delay: $470573b2591428b2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $470573b2591428b2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($470573b2591428b2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($470573b2591428b2$var$noop2));
        return {
            result: $470573b2591428b2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($470573b2591428b2$var$taskCancelled);
            }
        };
    };
};
var $470573b2591428b2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $470573b2591428b2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $470573b2591428b2$var$raceWithSignal(signal, Promise.race(promises));
            $470573b2591428b2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$470573b2591428b2$var$catchRejection(take(predicate, timeout));
};
var $470573b2591428b2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $470573b2591428b2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($470573b2591428b2$export$378fa86b259c0280(21));
    $470573b2591428b2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $470573b2591428b2$var$createListenerEntry = /* @__PURE__ */ $470573b2591428b2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $470573b2591428b2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $470573b2591428b2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($470573b2591428b2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$470573b2591428b2$var$createListenerEntry
});
var $470573b2591428b2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $470573b2591428b2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $470573b2591428b2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($470573b2591428b2$var$listenerCancelled);
    });
};
var $470573b2591428b2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$470573b2591428b2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $470573b2591428b2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $470573b2591428b2$export$f03a6b845d3fb58b = /* @__PURE__ */ $470573b2591428b2$var$assign(/* @__PURE__ */ $470573b2591428b2$export$309c7a02b0b0bc62(`${$470573b2591428b2$var$alm}/add`), {
    withTypes: ()=>$470573b2591428b2$export$f03a6b845d3fb58b
});
var $470573b2591428b2$export$b1b8022855fb2b71 = /* @__PURE__ */ $470573b2591428b2$export$309c7a02b0b0bc62(`${$470573b2591428b2$var$alm}/removeAll`);
var $470573b2591428b2$export$b03e9483f936dccb = /* @__PURE__ */ $470573b2591428b2$var$assign(/* @__PURE__ */ $470573b2591428b2$export$309c7a02b0b0bc62(`${$470573b2591428b2$var$alm}/remove`), {
    withTypes: ()=>$470573b2591428b2$export$b03e9483f936dccb
});
var $470573b2591428b2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$470573b2591428b2$var$alm}/error`, ...args);
};
var $470573b2591428b2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $470573b2591428b2$var$defaultErrorHandler } = middlewareOptions;
    $470573b2591428b2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $470573b2591428b2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $470573b2591428b2$var$findListenerEntry(listenerMap, options)) != null ? _a : $470573b2591428b2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $470573b2591428b2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $470573b2591428b2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $470573b2591428b2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $470573b2591428b2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $470573b2591428b2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $470573b2591428b2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $470573b2591428b2$var$createDelay(internalTaskController.signal),
                pause: $470573b2591428b2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $470573b2591428b2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($470573b2591428b2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($470573b2591428b2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $470573b2591428b2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $470573b2591428b2$export$cb1bdac908fed7f)) $470573b2591428b2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($470573b2591428b2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $470573b2591428b2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $2ec75f37e98b0842$export$b956e38827fca970)(action)) return next(action);
                if ($470573b2591428b2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($470573b2591428b2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($470573b2591428b2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $470573b2591428b2$var$INTERNAL_NIL_TOKEN) throw new Error($470573b2591428b2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $470573b2591428b2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $470573b2591428b2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $470573b2591428b2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $470573b2591428b2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $470573b2591428b2$export$4bb1606a79445586 = ()=>{
    const instanceId = $470573b2591428b2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($470573b2591428b2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $470573b2591428b2$var$getOrInsertComputed(middlewareMap, middleware2, $470573b2591428b2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$470573b2591428b2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $2ec75f37e98b0842$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $470573b2591428b2$export$9dd1fb32974da385(withMiddleware, $470573b2591428b2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $470573b2591428b2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $470573b2591428b2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$470573b2591428b2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $470573b2591428b2$var$ORIGINAL_STATE = /* @__PURE__ */ Symbol.for("rtk-state-proxy-original");
var $470573b2591428b2$var$isStateProxy = (value)=>!!value && !!value[$470573b2591428b2$var$ORIGINAL_STATE];
var $470573b2591428b2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $470573b2591428b2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$470573b2591428b2$var$getOrInsertComputed($470573b2591428b2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $470573b2591428b2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $470573b2591428b2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($470573b2591428b2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $470573b2591428b2$var$original = (state)=>{
    if (!$470573b2591428b2$var$isStateProxy(state)) throw new Error($470573b2591428b2$export$378fa86b259c0280(25));
    return state[$470573b2591428b2$var$ORIGINAL_STATE];
};
var $470573b2591428b2$var$emptyObject = {};
var $470573b2591428b2$var$noopReducer = (state = $470573b2591428b2$var$emptyObject)=>state;
function $470573b2591428b2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($470573b2591428b2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $2ec75f37e98b0842$export$66e4520cdb265d18)(reducerMap) : $470573b2591428b2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($470573b2591428b2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $470573b2591428b2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $470573b2591428b2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $aa7c241fb95a84fa$export$82ae485178b37419 = 1674997450;



function $855df7702650614f$export$64e94b4aa27e4ab6(data) {
    const dataAppVersion = parseInt(data.appVersion);
    if (dataAppVersion < 1601821226) return undefined;
    if (dataAppVersion < 1602446860) {
        console.info(`Migrating app data from version ${dataAppVersion} to 1602446860`);
        data = $855df7702650614f$var$apply1602446860(data);
    }
    if (dataAppVersion < 1674997450) {
        console.info(`Migrating app data from version ${dataAppVersion} to 1674997450`);
        data = $855df7702650614f$var$apply1674997450(data);
    }
    data.appVersion = (0, $aa7c241fb95a84fa$export$82ae485178b37419);
    return data;
}
function $855df7702650614f$var$apply1602446860(data) {
    data.locations.pool.forEach((location)=>location.itemsVisible = true);
    data.options.numberFormat = 'en-US';
    return data;
}
function $855df7702650614f$var$apply1674997450(data) {
    data.options.numberFormat = {
        locale: data.options.numberFormat,
        decimals: 2
    };
    data.options.minimumProfit = {
        type: 'percent',
        amount: 0
    };
    return data;
}


const $37519673773c73d0$var$VALID_TABS = [
    'ABOUT',
    'TRADING',
    'LOCATIONS',
    'ITEMS',
    'OPTIONS'
];
const $37519673773c73d0$var$VALID_MINIMUM_PROFIT_TYPES = [
    'percent',
    'value',
    'valueTotal'
];
function $37519673773c73d0$var$isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function $37519673773c73d0$var$isString(value) {
    return typeof value === 'string' && value.length > 0;
}
function $37519673773c73d0$var$isNumericValue(value) {
    if (typeof value === 'number') return Number.isFinite(value);
    if (typeof value === 'string') return value === '' || Number.isFinite(Number(value));
    return false;
}
function $37519673773c73d0$var$isLocationItem(item) {
    return $37519673773c73d0$var$isObject(item) && $37519673773c73d0$var$isString(item.ident) && $37519673773c73d0$var$isNumericValue(item.sellAmount) && $37519673773c73d0$var$isNumericValue(item.sellValue) && $37519673773c73d0$var$isNumericValue(item.buyAmount) && $37519673773c73d0$var$isNumericValue(item.buyValue);
}
function $37519673773c73d0$var$isLocation(location) {
    return $37519673773c73d0$var$isObject(location) && $37519673773c73d0$var$isString(location.ident) && $37519673773c73d0$var$isString(location.name) && typeof location.itemsVisible === 'boolean' && Array.isArray(location.items) && location.items.every($37519673773c73d0$var$isLocationItem);
}
function $37519673773c73d0$var$isItem(item) {
    return $37519673773c73d0$var$isObject(item) && $37519673773c73d0$var$isString(item.ident) && $37519673773c73d0$var$isString(item.name);
}
function $37519673773c73d0$var$areSelectedLocationsValid(selected, pool) {
    const poolIds = new Set(pool.map((location)=>location.ident));
    return selected.every((ident)=>poolIds.has(ident));
}
function $37519673773c73d0$var$isOptions(options) {
    return $37519673773c73d0$var$isObject(options) && $37519673773c73d0$var$VALID_TABS.includes(options.savedTab) && $37519673773c73d0$var$isObject(options.numberFormat) && $37519673773c73d0$var$isString(options.numberFormat.locale) && $37519673773c73d0$var$isNumericValue(options.numberFormat.decimals) && Number(options.numberFormat.decimals) >= 0 && Number(options.numberFormat.decimals) <= 10 && $37519673773c73d0$var$isObject(options.minimumProfit) && $37519673773c73d0$var$VALID_MINIMUM_PROFIT_TYPES.includes(options.minimumProfit.type) && $37519673773c73d0$var$isNumericValue(options.minimumProfit.amount) && Number(options.minimumProfit.amount) >= 0;
}
function $37519673773c73d0$export$6925991e7e736e7(state) {
    if (!$37519673773c73d0$var$isObject(state)) return {
        valid: false,
        message: 'Imported data must be a JSON object.'
    };
    if (!Number.isFinite(Number(state.appVersion))) return {
        valid: false,
        message: 'Imported data is missing a valid app version.'
    };
    if (!Array.isArray(state.items) || !state.items.every($37519673773c73d0$var$isItem)) return {
        valid: false,
        message: 'Imported data has invalid items.'
    };
    if (!$37519673773c73d0$var$isObject(state.locations) || !Array.isArray(state.locations.selected) || !state.locations.selected.every($37519673773c73d0$var$isString) || !Array.isArray(state.locations.pool) || !state.locations.pool.every($37519673773c73d0$var$isLocation) || !$37519673773c73d0$var$areSelectedLocationsValid(state.locations.selected, state.locations.pool)) return {
        valid: false,
        message: 'Imported data has invalid locations.'
    };
    if (!$37519673773c73d0$var$isOptions(state.options)) return {
        valid: false,
        message: 'Imported data has invalid options.'
    };
    return {
        valid: true,
        message: ''
    };
}


const $8c0f91bab1d0a112$export$9abf014fa110994 = (data)=>{
    if (!data || typeof data.appVersion === 'undefined') return undefined;
    const migratedData = (0, $aa7c241fb95a84fa$export$82ae485178b37419) > Number(data.appVersion) ? (0, $855df7702650614f$export$64e94b4aa27e4ab6)(data) : data;
    if (!migratedData || !(0, $37519673773c73d0$export$6925991e7e736e7)(migratedData).valid) return undefined;
    return migratedData;
};
const $8c0f91bab1d0a112$export$ea32cbdd559da174 = ()=>{
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState == null) return undefined;
        const data = JSON.parse(serializedState);
        return $8c0f91bab1d0a112$export$9abf014fa110994(data);
    } catch (err) {
        return undefined;
    }
};
const $8c0f91bab1d0a112$export$fb931cd598921492 = (state)=>{
    try {
        const stateToSave = {
            ...state,
            appVersion: (0, $aa7c241fb95a84fa$export$82ae485178b37419)
        };
        if (!(0, $37519673773c73d0$export$6925991e7e736e7)(stateToSave).valid) return false;
        const serializedState = JSON.stringify(stateToSave);
        localStorage.setItem('state', serializedState);
        return true;
    } catch (err) {
        console.error(err);
        return false;
    }
};




const $18a41a277371f899$export$763b62c58d0d054 = (0, $470573b2591428b2$export$4d8d9bd83c24ae8b)({
    name: 'items',
    initialState: [
        {
            ident: 'a538e52d-9c1f-4d94-b73b-653395e2dbed',
            name: 'Crafts'
        },
        {
            ident: '39bb874b-e292-49e1-81bf-4098ab1a4b27',
            name: 'Fish'
        },
        {
            ident: '0fe2db5a-2c94-42bb-8ba4-d88f282ea8a5',
            name: 'Fur'
        },
        {
            ident: 'b12167cb-8595-467c-ae41-aa00a151d158',
            name: 'Iron'
        },
        {
            ident: 'b9aae54c-c506-4101-af72-ad020993ca85',
            name: 'Meat'
        },
        {
            ident: '55c6a5e5-242f-40d1-9942-2c98715b7ffb',
            name: 'Wood'
        }
    ],
    reducers: {
        addItem: {
            reducer: (state, action)=>{
                const { ident: ident, name: name } = action.payload;
                const duplicateItems = state.filter((item)=>{
                    return item.name === name;
                });
                if (duplicateItems.length === 0) {
                    state.push({
                        ident: ident,
                        name: name
                    });
                    state.sort((a, b)=>{
                        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                    });
                }
            },
            prepare: (name)=>({
                    payload: {
                        ident: (0, $470573b2591428b2$export$ac4959f4f1338dfc)(),
                        name: name
                    }
                })
        },
        editItem: (state, action)=>{
            const editableItem = state.findIndex((item)=>{
                return item.ident === action.payload.ident;
            });
            if (editableItem === -1) return state;
            const duplicateItems = state.filter((item)=>{
                return item.name === action.payload.newName;
            });
            if (duplicateItems.length > 0) return state;
            state[editableItem].name = action.payload.newName;
        },
        deleteItem: (state, action)=>{
            const itemIndex = state.findIndex((item)=>item.ident === action.payload);
            if (itemIndex !== -1) state.splice(itemIndex, 1);
        },
        deleteAllItems: (state)=>{
            state.splice(0, state.length);
        }
    }
});
const { addItem: $18a41a277371f899$export$fb9705de59d96855, editItem: $18a41a277371f899$export$60832f4899fbf6a1, deleteItem: $18a41a277371f899$export$8d8542dbbc23fe1a, deleteAllItems: $18a41a277371f899$export$25c2a6760898c183 } = $18a41a277371f899$export$763b62c58d0d054.actions;
const $18a41a277371f899$export$d2f92acf417bbf5d = (state)=>state.items;
var $18a41a277371f899$export$2e2bcd8739ae039 = $18a41a277371f899$export$763b62c58d0d054.reducer;



function $7f0ad747d29c8911$var$addNewLocationToState(state, location) {
    if (state.pool.filter((item)=>item.name === location.name).length > 0) return null;
    const newLocation = {
        ident: location.ident,
        name: location.name,
        items: []
    };
    state.pool.push(newLocation);
    state.pool.sort((a, b)=>{
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    return newLocation;
}
const $7f0ad747d29c8911$export$85cb80c551038613 = (0, $470573b2591428b2$export$4d8d9bd83c24ae8b)({
    name: 'locations',
    initialState: {
        selected: [
            'd572c7f8-df50-46cf-bc0c-c2440981c740',
            '27761487-d952-4025-a0ca-edca4f934d9d'
        ],
        pool: [
            {
                ident: 'd572c7f8-df50-46cf-bc0c-c2440981c740',
                name: 'Berlin',
                items: [
                    {
                        ident: 'b12167cb-8595-467c-ae41-aa00a151d158',
                        buyAmount: 120,
                        buyValue: 740,
                        sellAmount: 0,
                        sellValue: 0
                    },
                    {
                        ident: '55c6a5e5-242f-40d1-9942-2c98715b7ffb',
                        buyAmount: 0,
                        buyValue: 0,
                        sellAmount: 290,
                        sellValue: 340
                    }
                ],
                itemsVisible: true
            },
            {
                ident: '27761487-d952-4025-a0ca-edca4f934d9d',
                name: 'London',
                items: [
                    {
                        ident: '39bb874b-e292-49e1-81bf-4098ab1a4b27',
                        buyAmount: 93,
                        buyValue: 515,
                        sellAmount: 0,
                        sellValue: 0
                    },
                    {
                        ident: 'b12167cb-8595-467c-ae41-aa00a151d158',
                        buyAmount: 0,
                        buyValue: 0,
                        sellAmount: 690,
                        sellValue: 210
                    },
                    {
                        ident: '55c6a5e5-242f-40d1-9942-2c98715b7ffb',
                        buyAmount: 450,
                        buyValue: 395,
                        sellAmount: 0,
                        sellValue: 0
                    }
                ],
                itemsVisible: true
            },
            {
                ident: '1c714a4e-1510-4055-b91b-daa358b5d2f0',
                name: 'New York',
                items: [],
                itemsVisible: true
            }
        ]
    },
    reducers: {
        addLocation: {
            reducer: (state, action)=>{
                $7f0ad747d29c8911$var$addNewLocationToState(state, action.payload);
            },
            prepare: (name)=>({
                    payload: {
                        ident: (0, $470573b2591428b2$export$ac4959f4f1338dfc)(),
                        name: name
                    }
                })
        },
        addAndSelectLocation: {
            reducer: (state, action)=>{
                const newLocation = $7f0ad747d29c8911$var$addNewLocationToState(state, action.payload);
                if (newLocation) state.selected.push(newLocation.ident);
            },
            prepare: (name)=>({
                    payload: {
                        ident: (0, $470573b2591428b2$export$ac4959f4f1338dfc)(),
                        name: name
                    }
                })
        },
        selectExistingLocation: (state, action)=>{
            const locationExists = state.pool.some((location)=>location.ident === action.payload);
            const locationSelected = state.selected.includes(action.payload);
            if (!locationExists || locationSelected) return state;
            state.selected.push(action.payload);
        },
        editLocation: (state, action)=>{
            const editableLocation = state.pool.findIndex((location)=>{
                return location.ident === action.payload.ident;
            });
            const duplicateLocations = state.pool.filter((location)=>{
                return location.name === action.payload.newName;
            });
            if (editableLocation === -1 || duplicateLocations.length > 0) return state;
            state.pool[editableLocation].name = action.payload.newName;
        },
        toggleLocationItemVisibility: (state, action)=>{
            const locationIndex = state.pool.findIndex((location)=>location.ident === action.payload);
            if (locationIndex === -1) return state;
            state.pool[locationIndex].itemsVisible = !state.pool[locationIndex].itemsVisible;
        },
        deselectLocation: (state, action)=>{
            // Delete location from selected locations
            const selectedIndex = state.selected.findIndex((location)=>location === action.payload);
            if (selectedIndex === -1) return state;
            state.selected.splice(selectedIndex, 1);
            // Remove all items from the location
            state.pool.forEach((location)=>{
                if (location.ident === action.payload) location.items = [];
            });
        },
        deleteLocation: (state, action)=>{
            // Delete location from selected locations
            const selectedIndex = state.selected.findIndex((location)=>location === action.payload);
            if (selectedIndex !== -1) state.selected.splice(selectedIndex, 1);
            // Delete location from location pool
            const poolIndex = state.pool.findIndex((poolItem)=>poolItem.ident === action.payload);
            if (poolIndex === -1) return state;
            state.pool.splice(poolIndex, 1);
        },
        deleteAllLocations: (state)=>{
            state.selected = [];
            state.pool = [];
        },
        addItemToLocation: (state, action)=>{
            state.pool.forEach((location)=>{
                if (location.ident !== action.payload.location) return;
                if (location.items.some((item)=>item.ident === action.payload.item)) return;
                location.items.push({
                    ident: action.payload.item,
                    sellAmount: 0,
                    sellValue: 0,
                    buyAmount: 0,
                    buyValue: 0
                });
            });
        },
        updateItemValue: (state, action)=>{
            state.pool.forEach((location)=>{
                if (location.ident !== action.payload.location) return;
                const itemIndex = location.items.findIndex((item)=>item.ident === action.payload.item.ident);
                if (itemIndex !== -1) location.items.splice(itemIndex, 1, action.payload.item);
            });
        },
        removeItemFromLocation: (state, action)=>{
            state.pool.forEach((location)=>{
                if (location.ident !== action.payload.location) return;
                const itemIndex = location.items.findIndex((item)=>item.ident === action.payload.item);
                if (itemIndex !== -1) location.items.splice(itemIndex, 1);
            });
        },
        removeItemFromAllLocations: (state, action)=>{
            state.pool.forEach((location)=>{
                const itemIndex = location.items.findIndex((item)=>item.ident === action.payload);
                if (itemIndex !== -1) location.items.splice(itemIndex, 1);
            });
        },
        toggleAllLocationItemVisibilities: (state, action)=>{
            state.pool = state.pool.map((location)=>{
                location.itemsVisible = action.payload;
                return location;
            });
        }
    }
});
const { addLocation: $7f0ad747d29c8911$export$f664da56b7f6aade, addAndSelectLocation: $7f0ad747d29c8911$export$43c4347663e5def6, selectExistingLocation: $7f0ad747d29c8911$export$e351c0c2c904809e, editLocation: $7f0ad747d29c8911$export$487137bcf5607d79, deselectLocation: $7f0ad747d29c8911$export$554dd94b68a2985a, toggleLocationItemVisibility: $7f0ad747d29c8911$export$df9a0b1efb3771bd, deleteLocation: $7f0ad747d29c8911$export$37d55cdde99fe3d6, deleteAllLocations: $7f0ad747d29c8911$export$5f506d78c27ad5d, addItemToLocation: $7f0ad747d29c8911$export$83c89a5c8795b284, updateItemValue: $7f0ad747d29c8911$export$d9447039c2332a76, removeItemFromLocation: $7f0ad747d29c8911$export$29061e42202a73cf, removeItemFromAllLocations: $7f0ad747d29c8911$export$658e4a4ec22c4ecc, toggleAllLocationItemVisibilities: $7f0ad747d29c8911$export$b20ad5d8d3a2f09b } = $7f0ad747d29c8911$export$85cb80c551038613.actions;
const $7f0ad747d29c8911$export$c07c686062478869 = (state)=>state.locations.pool;
const $7f0ad747d29c8911$export$54c0ead5958f48c = (state)=>state.locations.selected;
const $7f0ad747d29c8911$export$fdc19266b79822e = (state)=>{
    return state.locations.pool.filter((location)=>state.locations.selected.find((selected)=>selected === location.ident));
};
var $7f0ad747d29c8911$export$2e2bcd8739ae039 = $7f0ad747d29c8911$export$85cb80c551038613.reducer;



const $74fec6a0f0fbb7d8$export$f67464c0f98bf9b0 = (0, $470573b2591428b2$export$4d8d9bd83c24ae8b)({
    name: 'options',
    initialState: {
        savedTab: 'ABOUT',
        numberFormat: {
            locale: 'en-US',
            decimals: 2
        },
        minimumProfit: {
            type: 'percent',
            amount: 0
        }
    },
    reducers: {
        changeSavedTab: (state, action)=>{
            state.savedTab = action.payload;
        },
        changeNumberFormatLocale: (state, action)=>{
            state.numberFormat.locale = action.payload;
        },
        changeNumberFormatDecimals: (state, action)=>{
            state.numberFormat.decimals = action.payload;
        },
        changeMinimumProfitType: (state, action)=>{
            state.minimumProfit.type = action.payload;
        },
        changeMinimumProfitAmount: (state, action)=>{
            state.minimumProfit.amount = action.payload;
        }
    }
});
const { changeSavedTab: $74fec6a0f0fbb7d8$export$8a589571d67b4921, changeNumberFormatLocale: $74fec6a0f0fbb7d8$export$1f04b3405eb70a7, changeNumberFormatDecimals: $74fec6a0f0fbb7d8$export$557a79cc98d72ae0, changeMinimumProfitType: $74fec6a0f0fbb7d8$export$d40e5a47fbc08b32, changeMinimumProfitAmount: $74fec6a0f0fbb7d8$export$22dbdbba8c6ce0d1 } = $74fec6a0f0fbb7d8$export$f67464c0f98bf9b0.actions;
const $74fec6a0f0fbb7d8$export$d2312e68e1f5ad00 = (state)=>state.options;
const $74fec6a0f0fbb7d8$export$85965c60fa984327 = (state)=>state.options.savedTab;
var $74fec6a0f0fbb7d8$export$2e2bcd8739ae039 = $74fec6a0f0fbb7d8$export$f67464c0f98bf9b0.reducer;


const $99ad227a70ba4a26$var$persistedState = (0, $8c0f91bab1d0a112$export$ea32cbdd559da174)();
if ($99ad227a70ba4a26$var$persistedState) console.info('Loading state from your Browser...');
function $99ad227a70ba4a26$var$appVersionReducer(state) {
    if (typeof state === 'undefined') state = {
        appVersion: (0, $aa7c241fb95a84fa$export$82ae485178b37419)
    };
    return state;
}
var $99ad227a70ba4a26$export$2e2bcd8739ae039 = (0, $470573b2591428b2$export$7d8a5b498da695ac)({
    reducer: {
        items: (0, $18a41a277371f899$export$2e2bcd8739ae039),
        locations: (0, $7f0ad747d29c8911$export$2e2bcd8739ae039),
        appVersion: $99ad227a70ba4a26$var$appVersionReducer,
        options: (0, $74fec6a0f0fbb7d8$export$2e2bcd8739ae039)
    },
    preloadedState: $99ad227a70ba4a26$var$persistedState
});




parcelRequire("fgmOP");

parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");

var $cwk7h = parcelRequire("cwk7h");
function $759f317cd367f5b4$export$2b77a92f1a5ad772({ visible: visible, closeModal: closeModal, label: label, children: children }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useEffect(()=>{
        if (!visible) return undefined;
        function closeOnEscape(event) {
            if (event.key === 'Escape') closeModal();
        }
        document.addEventListener('keydown', closeOnEscape);
        return ()=>document.removeEventListener('keydown', closeOnEscape);
    }, [
        closeModal,
        visible
    ]);
    const modal = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: 'fixed z-10 inset-0 overflow-y-auto ' + (visible ? '' : 'hidden'),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            className: "flex items-center justify-center min-h-screen p-4 md:p-6",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: 'fixed inset-0 transition-opacity bg-black ease duration-300 opacity-0 cursor-zoom-out ' + (visible ? 'opacity-50' : ''),
                    onClick: ()=>closeModal()
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": label || 'Dialog',
                    className: "relative block flex-1 max-w-2xl p-6 bg-gray-800 rounded-xs overflow-hidden shadow-lg transform my-8",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>closeModal(),
                            title: "Close this overlay",
                            className: "absolute top-0 right-0 py-2 px-3 text-gray-500 hover:text-white",
                            children: "\xd7"
                        }),
                        children
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cwk7h))).createPortal(modal, document.getElementById('modal-container'));
}




var $fgmOP = parcelRequire("fgmOP");


function $aebcffe73214589d$export$88708191f7a2213e(importData) {
    let parsedData;
    try {
        parsedData = JSON.parse(importData);
    } catch (error) {
        return {
            valid: false,
            state: undefined,
            message: 'The import data is not valid JSON.'
        };
    }
    const preparedState = (0, $8c0f91bab1d0a112$export$9abf014fa110994)(parsedData);
    if (!preparedState) return {
        valid: false,
        state: undefined,
        message: (0, $37519673773c73d0$export$6925991e7e736e7)(parsedData).message || 'The import data is not a valid Tradefinder export.'
    };
    return {
        valid: true,
        state: preparedState,
        message: ''
    };
}



function $a7a957692d7d71ba$export$66e9bd133833526f() {
    const [importData, setImportData] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [importComplete, setImportComplete] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            const importResult = (0, $aebcffe73214589d$export$88708191f7a2213e)(importData);
            if (!importResult.valid) {
                setErrorMessage(importResult.message);
                return;
            }
            if (!(0, $8c0f91bab1d0a112$export$fb931cd598921492)(importResult.state)) {
                setErrorMessage('The import data could not be saved.');
                return;
            }
            setErrorMessage('');
            setImportComplete(true);
        }
    }
    function reloadApplication() {
        window.location.reload();
    }
    if (importComplete) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Import Complete"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                className: "text-sm text-gray-300",
                children: "Your imported data was saved. Reload the app to use it."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "button",
                className: "btn btn-primary mt-6",
                onClick: reloadApplication,
                children: "Reload App"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Import Data"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "import-content",
                children: "Data to import"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("textarea", {
                id: "import-content",
                value: importData,
                minLength: "1",
                autoFocus: true,
                required: true,
                "aria-describedby": errorMessage ? 'import-content-error' : undefined,
                onChange: (e)=>{
                    setImportData(e.target.value);
                    setErrorMessage('');
                },
                className: "w-full py-2 px-3 text-xs rounded-xs my-4 bg-gray-700 shadow-xs"
            }),
            errorMessage && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                id: "import-content-error",
                className: "mb-4 text-sm text-red-300",
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "submit",
                className: "btn btn-primary",
                children: "Start Import"
            })
        ]
    });
}


function $1427468d87f900ab$export$4185cd96ab7232d1() {
    const [modalContent, setModalContent] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [modalVisible, setModalVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    function saveManually() {
        console.info('Manually saving data to your browser...');
        (0, $8c0f91bab1d0a112$export$fb931cd598921492)((0, $99ad227a70ba4a26$export$2e2bcd8739ae039).getState());
    }
    function exportState() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                    className: "text-2xl mb-4",
                    children: "Export your current Data"
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("pre", {
                    className: "p-3 text-xxs border border-gray-700 break-all whitespace-normal max-h-screen overflow-y-auto",
                    children: JSON.stringify((0, $99ad227a70ba4a26$export$2e2bcd8739ae039).getState())
                })
            ]
        }));
        setModalVisible(true);
    }
    function importState() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a7a957692d7d71ba$export$66e9bd133833526f), {
            closeForm: closeModal
        }));
        setModalVisible(true);
    }
    function closeModal() {
        setModalContent('');
        setModalVisible(false);
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mt-8 text-xs text-center text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "m-0 p-0 bg-none text-gray-200 hover:text-white",
                        onClick: saveManually,
                        children: "Save manually"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "m-0 ml-5 p-0 bg-none text-gray-200 hover:text-white",
                        onClick: exportState,
                        children: "Export"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "m-0 ml-5 p-0 bg-none text-gray-200 hover:text-white",
                        onClick: importState,
                        children: "Import"
                    })
                ]
            }),
            modalVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: modalVisible,
                closeModal: closeModal,
                children: modalContent
            })
        ]
    });
}


function $a572afac44151ae1$export$a06f1c675e846f6f() {
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "mt-8 ",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1427468d87f900ab$export$4185cd96ab7232d1), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "text-xs text-center text-gray-500 mt-4",
                children: [
                    "Created by ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                        href: "https://kovah.de/",
                        className: "text-gray-200 hover:text-white",
                        children: "Kovah"
                    }),
                    ". Source at ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                        href: "https://github.com/Kovah/Tradefinder",
                        className: "text-gray-200 hover:text-white",
                        children: "Github"
                    })
                ]
            })
        ]
    });
}



parcelRequire("fgmOP");
function $6a6c33cd92946d32$export$8b251419efc915eb() {
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h1", {
        className: "mt-4 title text-3xl text-center uppercase tracking-widest font-black",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("svg", {
                className: "mr-4",
                viewBox: "0 0 512 512",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                        d: "m192 0h-160a32 32 0 0 0 -32 32v160a32 32 0 0 0 32 32h160a32 32 0 0 0 32-32v-160a32 32 0 0 0 -32-32zm-16 120a8 8 0 0 1 -8 8h-112a8 8 0 0 1 -8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm16 168h-160a32 32 0 0 0 -32 32v160a32 32 0 0 0 32 32h160a32 32 0 0 0 32-32v-160a32 32 0 0 0 -32-32zm-29.09 140.29a8 8 0 0 1 0 11.31l-11.31 11.31a8 8 0 0 1 -11.31 0l-28.29-28.28-28.29 28.29a8 8 0 0 1 -11.31 0l-11.31-11.32a8 8 0 0 1 0-11.31l28.28-28.29-28.29-28.29a8 8 0 0 1 0-11.31l11.31-11.31a8 8 0 0 1 11.31 0l28.3 28.28 28.29-28.29a8 8 0 0 1 11.31 0l11.31 11.31a8 8 0 0 1 0 11.31l-28.28 28.3zm317.09-428.29h-160a32 32 0 0 0 -32 32v160a32 32 0 0 0 32 32h160a32 32 0 0 0 32-32v-160a32 32 0 0 0 -32-32zm-16 120a8 8 0 0 1 -8 8h-40v40a8 8 0 0 1 -8 8h-16a8 8 0 0 1 -8-8v-40h-40a8 8 0 0 1 -8-8v-16a8 8 0 0 1 8-8h40v-40a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v40h40a8 8 0 0 1 8 8z",
                        opacity: ".4"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                        d: "m162.91 360.39-11.31-11.31a8 8 0 0 0 -11.31 0l-28.29 28.29-28.3-28.28a8 8 0 0 0 -11.31 0l-11.31 11.31a8 8 0 0 0 0 11.31l28.29 28.29-28.28 28.29a8 8 0 0 0 0 11.31l11.31 11.32a8 8 0 0 0 11.31 0l28.29-28.29 28.29 28.28a8 8 0 0 0 11.31 0l11.31-11.31a8 8 0 0 0 0-11.31l-28.28-28.29 28.28-28.3a8 8 0 0 0 0-11.31zm181.09-232.39h40v40a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8v-16a8 8 0 0 0 -8-8h-40v-40a8 8 0 0 0 -8-8h-16a8 8 0 0 0 -8 8v40h-40a8 8 0 0 0 -8 8v16a8 8 0 0 0 8 8zm-176-32h-112a8 8 0 0 0 -8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0 -8-8zm312 192h-160a32 32 0 0 0 -32 32v160a32 32 0 0 0 32 32h160a32 32 0 0 0 32-32v-160a32 32 0 0 0 -32-32zm-16 152a8 8 0 0 1 -8 8h-112a8 8 0 0 1 -8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm0-64a8 8 0 0 1 -8 8h-112a8 8 0 0 1 -8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8z"
                    })
                ]
            }),
            "Tradefinder"
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");


function $771c3ac3cbdcc149$export$42bc6f3454472a9e(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            dispatch((0, $18a41a277371f899$export$fb9705de59d96855)(name));
            props.closeForm();
        }
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Create new Item"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "create-item-name",
                children: "Item Name"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "text",
                id: "create-item-name",
                value: name,
                minLength: "1",
                autoFocus: true,
                required: true,
                onChange: (e)=>setName(e.target.value),
                className: "my-4 input"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "submit",
                className: "btn btn-primary",
                children: "Add Item"
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");



function $dd517661729bf626$export$aa1977f5fa7b1cfa(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.oldName);
    const [confirmDelete, setConfirmDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            dispatch((0, $18a41a277371f899$export$60832f4899fbf6a1)({
                ident: props.ident,
                newName: name
            }));
            props.closeForm();
        }
    }
    function doDeleteItem() {
        dispatch((0, $7f0ad747d29c8911$export$658e4a4ec22c4ecc)(props.ident));
        dispatch((0, $18a41a277371f899$export$8d8542dbbc23fe1a)(props.ident));
        props.closeForm();
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h3", {
                className: "text-2xl mb-4",
                children: [
                    "Edit ",
                    props.oldName
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "hidden",
                value: props.ident
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "edit-item-name",
                className: "block mb-2",
                children: "Item Name"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "text",
                id: "edit-item-name",
                value: name,
                minLength: "1",
                autoFocus: true,
                required: true,
                onChange: (e)=>setName(e.target.value),
                className: "my-4 input"
            }),
            confirmDelete && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mb-4 border border-red-400 p-3 text-sm",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "text-red-300",
                        children: "This removes the item from all associated locations and trades."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-3 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-sm",
                                onClick: ()=>setConfirmDelete(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                onClick: doDeleteItem,
                                className: "btn btn-sm btn-danger",
                                children: "Delete Item"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setConfirmDelete(true),
                        className: "btn btn-danger",
                        children: "Delete Item"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "submit",
                        className: "ml-auto btn btn-primary",
                        children: "Change Item"
                    })
                ]
            })
        ]
    });
}



function $49f9264303d155a6$export$5388a23595565024() {
    let items = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $18a41a277371f899$export$d2f92acf417bbf5d));
    const [modalContent, setModalContent] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [modalVisible, setModalVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const listItems = items.map((item)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
            type: "button",
            className: "border border-gray-850 p-4 text-center text-2xl rounded-sm hover:border-primary-700 hover:shadow-md transition-shadow duration-200",
            onClick: ()=>toggleEditForm(item),
            children: item.name
        }, item.ident));
    function toggleCreateForm() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $771c3ac3cbdcc149$export$42bc6f3454472a9e), {
            closeForm: closeModal
        }));
        setModalVisible(true);
    }
    function toggleEditForm(item) {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd517661729bf626$export$aa1977f5fa7b1cfa), {
            ident: item.ident,
            oldName: item.name,
            closeForm: closeModal
        }));
        setModalVisible(true);
    }
    function closeModal() {
        setModalContent('');
        setModalVisible(false);
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                        className: "mr-4 text-2xl font-bold",
                        children: "Items"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "ml-auto btn btn-primary",
                        onClick: toggleCreateForm,
                        children: "Add Item"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3",
                children: listItems.length > 0 ? listItems : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                    className: "text-sm text-gray-500",
                    children: "No items available yet."
                })
            }),
            modalVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: modalVisible,
                closeModal: closeModal,
                children: modalContent
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");





var $fgmOP = parcelRequire("fgmOP");


function $8d0d2e42bd53021f$export$26adc19edd66543f(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            if (props.selectAfterAdding) dispatch((0, $7f0ad747d29c8911$export$43c4347663e5def6)(name));
            else dispatch((0, $7f0ad747d29c8911$export$f664da56b7f6aade)(name));
            props.closeForm();
        }
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Add new Location"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "create-location-name",
                children: "Location Name"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "text",
                id: "create-location-name",
                value: name,
                minLength: "1",
                autoFocus: true,
                required: true,
                onChange: (e)=>setName(e.target.value),
                className: "my-4 input"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "submit",
                className: "btn btn-primary",
                children: "Add Location"
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");


function $a322d854b03fb315$export$14bb640a6f0257cc(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.oldName);
    const [confirmDelete, setConfirmDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            dispatch((0, $7f0ad747d29c8911$export$487137bcf5607d79)({
                ident: props.ident,
                newName: name
            }));
            props.closeForm();
        }
    }
    function doDeleteLocation() {
        dispatch((0, $7f0ad747d29c8911$export$37d55cdde99fe3d6)(props.ident));
        props.closeForm();
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h3", {
                className: "text-2xl mb-4",
                children: [
                    "Edit ",
                    props.oldName
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "hidden",
                value: props.ident
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "edit-location-name",
                className: "block mb-2",
                children: "Location Name"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                type: "text",
                id: "edit-location-name",
                value: name,
                minLength: "1",
                autoFocus: true,
                required: true,
                onChange: (e)=>setName(e.target.value),
                className: "my-4 input"
            }),
            confirmDelete && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mb-4 border border-red-400 p-3 text-sm",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "text-red-300",
                        children: "This deletes the location, its item values, and related trades."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-3 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-sm",
                                onClick: ()=>setConfirmDelete(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                onClick: doDeleteLocation,
                                className: "btn btn-sm btn-danger",
                                children: "Delete Location"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setConfirmDelete(true),
                        className: "btn btn-danger",
                        children: "Delete Location"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "submit",
                        className: "ml-auto btn btn-primary",
                        children: "Update Location"
                    })
                ]
            })
        ]
    });
}


function $f39e1d29c88fdc81$export$fbd30df0ff5ba7ac() {
    let locations = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $7f0ad747d29c8911$export$c07c686062478869));
    const [modalContent, setModalContent] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [modalVisible, setModalVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const listLocations = locations.map((location)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
            type: "button",
            className: "border border-gray-850 p-4 text-center text-2xl rounded-sm hover:border-primary-700 hover:shadow-md transition-shadow",
            onClick: ()=>toggleEditForm(location),
            children: location.name
        }, location.ident));
    function toggleCreateForm() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8d0d2e42bd53021f$export$26adc19edd66543f), {
            closeForm: closeModal
        }));
        setModalVisible(true);
    }
    function toggleEditForm(location) {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a322d854b03fb315$export$14bb640a6f0257cc), {
            ident: location.ident,
            oldName: location.name,
            closeForm: closeModal
        }));
        setModalVisible(true);
    }
    function closeModal() {
        setModalContent('');
        setModalVisible(false);
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                        className: "mr-4 text-2xl font-bold",
                        children: "Locations"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "ml-auto btn btn-primary",
                        onClick: toggleCreateForm,
                        children: "Add Location"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3",
                children: listLocations.length > 0 ? listLocations : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                    className: "text-sm text-gray-500",
                    children: "No locations available yet."
                })
            }),
            modalVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: modalVisible,
                closeModal: closeModal,
                children: modalContent
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");


function $a22e55c628a9e7d6$export$2f2852c3a8d33364(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const availableLocations = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $7f0ad747d29c8911$export$c07c686062478869));
    const selectedLocations = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $7f0ad747d29c8911$export$54c0ead5958f48c));
    const locationSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createRef();
    const selectableLocations = availableLocations.filter((location)=>{
        return !selectedLocations.includes(location.ident);
    });
    const locationOptions = selectableLocations.map((location)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
            value: location.ident,
            children: location.name
        }, location.ident));
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            dispatch((0, $7f0ad747d29c8911$export$e351c0c2c904809e)(locationSelect.current.value));
            props.closeForm();
        }
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Select existing Location"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "location-ident",
                children: "Location"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("select", {
                name: "location-ident",
                id: "location-ident",
                required: true,
                ref: locationSelect,
                className: "input",
                children: locationOptions
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "submit",
                className: "btn btn-primary",
                children: "Select Location"
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");



function $2938ae105ec41acb$export$1d6463957f81e989(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const availableItems = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $18a41a277371f899$export$d2f92acf417bbf5d));
    const itemSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createRef();
    const selectableItems = availableItems.filter((newItem)=>{
        return props.location.items.filter((item)=>item.ident === newItem.ident).length === 0;
    });
    const itemOptions = selectableItems.map((item)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
            value: item.ident,
            children: item.name
        }, item.ident));
    function handleSubmit(event) {
        event.preventDefault();
        if (event.target.checkValidity()) {
            dispatch((0, $7f0ad747d29c8911$export$83c89a5c8795b284)({
                location: props.location.ident,
                item: itemSelect.current.value
            }));
            props.closeForm();
        }
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                className: "text-2xl mb-4",
                children: "Select existing Item"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                htmlFor: "item-ident",
                children: "Item"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("select", {
                name: "item-ident",
                id: "item-ident",
                required: true,
                ref: itemSelect,
                className: "input",
                children: itemOptions
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                type: "submit",
                className: "btn btn-primary",
                children: "Select Item"
            })
        ]
    });
}




var $fgmOP = parcelRequire("fgmOP");



function $a96876bddf87a5da$export$6d08773d2e66f8f2(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const dataChanged = (0, $fgmOP.useRef)(false);
    const [confirmRemove, setConfirmRemove] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const inputClass = 'input input-xs';
    const allItems = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $18a41a277371f899$export$d2f92acf417bbf5d));
    const itemDetails = allItems.find((item)=>{
        return item.ident === props.item.ident;
    });
    const [buyAmount, setBuyAmount] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.item.buyAmount);
    const [buyValue, setBuyValue] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.item.buyValue);
    const [sellAmount, setSellAmount] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.item.sellAmount);
    const [sellValue, setSellValue] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(props.item.sellValue);
    // Listen to changes of the buy and sell values and amounts
    (0, $fgmOP.useEffect)(()=>{
        // Only update the item if some data was changed, or it will end in an endless React hook loop
        if (dataChanged.current) dispatch((0, $7f0ad747d29c8911$export$d9447039c2332a76)({
            location: props.locationIdent,
            item: {
                ident: props.item.ident,
                buyAmount: parseInputNumber(buyAmount),
                buyValue: parseInputNumber(buyValue),
                sellAmount: parseInputNumber(sellAmount),
                sellValue: parseInputNumber(sellValue)
            }
        }));
    }, [
        buyAmount,
        buyValue,
        sellAmount,
        sellValue
    ]);
    if (!itemDetails) return null;
    function doRemoveItem() {
        dispatch((0, $7f0ad747d29c8911$export$29061e42202a73cf)({
            location: props.locationIdent,
            item: props.item.ident
        }));
    }
    function parseInputNumber(value) {
        const parsedValue = parseFloat(value);
        return Number.isFinite(parsedValue) ? parsedValue : 0;
    }
    function changeBuyAmount(e) {
        dataChanged.current = true;
        setBuyAmount(e.target.value);
    }
    function changeBuyValue(e) {
        dataChanged.current = true;
        setBuyValue(e.target.value);
    }
    function changeSellAmount(e) {
        dataChanged.current = true;
        setSellAmount(e.target.value);
    }
    function changeSellValue(e) {
        dataChanged.current = true;
        setSellValue(e.target.value);
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "location-item border-b border-gray-850 py-1 grid grid-cols-1 sm:grid-cols-3 gap-1 text-xs",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h4", {
                className: "break-words",
                children: [
                    itemDetails.name,
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        className: "location-item-remove hidden text-xs text-gray-500 hover:text-red-400 focus:text-red-400 py-0 px-2",
                        type: "button",
                        onClick: ()=>setConfirmRemove(true),
                        title: "Remove this Item",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("svg", {
                            className: "icon",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "grid grid-cols-3 gap-1 mb-1 text-center text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "text-xxs pt-1",
                                children: "Amount"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "uppercase text-green-400 opacity-75",
                                children: "Buys"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "text-xxs pt-1",
                                children: "Value"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-1",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                type: "number",
                                value: buyAmount,
                                className: inputClass,
                                step: "0.01",
                                onChange: changeBuyAmount,
                                "aria-label": `${itemDetails.name} buy amount`
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                type: "number",
                                value: buyValue,
                                className: inputClass,
                                step: "0.01",
                                onChange: changeBuyValue,
                                "aria-label": `${itemDetails.name} buy value`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "grid grid-cols-3 gap-1 mb-1 text-center text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "text-xxs pt-1",
                                children: "Value"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "uppercase text-red-400 opacity-75",
                                children: "Sells"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "text-xxs pt-1",
                                children: "Amount"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-1",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                type: "number",
                                value: sellValue,
                                className: inputClass,
                                step: "0.01",
                                onChange: changeSellValue,
                                "aria-label": `${itemDetails.name} sell value`
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                type: "number",
                                value: sellAmount,
                                className: inputClass,
                                step: "0.01",
                                onChange: changeSellAmount,
                                "aria-label": `${itemDetails.name} sell amount`
                            })
                        ]
                    })
                ]
            }),
            confirmRemove && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "sm:col-span-3 border border-red-400 p-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                        className: "text-red-300",
                        children: [
                            "Remove ",
                            itemDetails.name,
                            " from this location?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-2 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-xs",
                                onClick: ()=>setConfirmRemove(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-xs btn-danger",
                                onClick: doRemoveItem,
                                children: "Remove Item"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $6446f2961b7abee2$export$18a2be9195644f38(props) {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const [modalVisible, setModalVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const [modalContent, setModalContent] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [confirmRemove, setConfirmRemove] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const locationClass = 'border-l border-r border-b border-gray-850 p-1 rounded-xs' + (props.isFirst ? ' rounded-t-sm border-t' : '') + (props.isLast ? ' rounded-b-sm' : '');
    const headingsTitle = props.location.itemsVisible ? 'Minimize this Location' : 'Maximize this Location';
    const itemWrapperClass = props.location.itemsVisible ? 'block' : 'hidden';
    const items = props.location.items.map((item)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a96876bddf87a5da$export$6d08773d2e66f8f2), {
            item: item,
            locationIdent: props.location.ident
        }, item.ident));
    function toggleItemsVisible() {
        dispatch((0, $7f0ad747d29c8911$export$df9a0b1efb3771bd)(props.location.ident));
    }
    function selectNewItem() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2938ae105ec41acb$export$1d6463957f81e989), {
                    closeForm: closeModal,
                    location: props.location
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                    type: "button",
                    className: "mt-6 text-sm text-gray-400 hover:text-gray-200",
                    onClick: addAndSelectNewItem,
                    children: "Add new Item"
                })
            ]
        }));
        setModalVisible(true);
    }
    function addAndSelectNewItem() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $771c3ac3cbdcc149$export$42bc6f3454472a9e), {
                    closeForm: selectNewItem
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                    type: "button",
                    className: "mt-6 text-sm text-gray-400 hover:text-gray-200",
                    onClick: selectNewItem,
                    children: "Add existing Item"
                })
            ]
        }));
        setModalVisible(true);
    }
    function removeLocation() {
        dispatch((0, $7f0ad747d29c8911$export$554dd94b68a2985a)(props.location.ident));
    }
    function closeModal() {
        setModalVisible(false);
        setModalContent('');
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        "data-ident": props.location.ident,
        className: locationClass,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        title: headingsTitle,
                        onClick: toggleItemsVisible,
                        className: "mr-1 text-xxs cursor-pointer font-mono",
                        children: props.location.itemsVisible ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            children: "-"
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            children: "+"
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                        className: "text-lg font-bold",
                        children: props.location.name
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "ml-auto btn btn-xs",
                        onClick: selectNewItem,
                        children: "Add Item"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "ml-1 btn btn-xs",
                        onClick: ()=>setConfirmRemove(true),
                        title: "Remove this Location",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("svg", {
                            className: "icon",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
                            })
                        })
                    })
                ]
            }),
            confirmRemove && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "my-2 border border-red-400 p-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "text-red-300",
                        children: "Remove this location from trading and clear its item values?"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-2 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-xs",
                                onClick: ()=>setConfirmRemove(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-xs btn-danger",
                                onClick: removeLocation,
                                children: "Remove"
                            })
                        ]
                    })
                ]
            }),
            props.location.items.length > 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: itemWrapperClass,
                children: items
            }),
            modalVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: modalVisible,
                closeModal: closeModal,
                children: modalContent
            })
        ]
    });
}





parcelRequire("fgmOP");



function $e4b5b06dae4ddbff$export$f5dd818bff069720(number, numberFormat) {
    const formatted = new Intl.NumberFormat([
        numberFormat.locale,
        'en-US'
    ], {
        minimumFractionDigits: numberFormat.decimals,
        maximumFractionDigits: numberFormat.decimals
    }).format(number);
    return formatted.toString();
}



function $a60fd10dd1ca5be1$var$toNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
}
function $a60fd10dd1ca5be1$var$getMinimumProfit(options = {}) {
    return options.minimumProfit || {
        type: 'percent',
        amount: 0
    };
}
function $a60fd10dd1ca5be1$var$passesMinimumProfit(trade, minimumProfit) {
    const amount = $a60fd10dd1ca5be1$var$toNumber(minimumProfit.amount);
    if (amount <= 0) return true;
    if (minimumProfit.type === 'percent') return trade.profitPercentage >= amount;
    if (minimumProfit.type === 'valueTotal') return trade.profitTotal >= amount;
    return trade.profit >= amount;
}
function $a60fd10dd1ca5be1$export$babd9d795c85ae99({ items: items = [], locations: locations = [], options: options = {} }) {
    const itemNames = new Map(items.map((item)=>[
            item.ident,
            item.name
        ]));
    const minimumProfit = $a60fd10dd1ca5be1$var$getMinimumProfit(options);
    const possibleTrades = [];
    locations.forEach((location)=>{
        if (!Array.isArray(location.items) || location.items.length === 0) return;
        location.items.forEach((item)=>{
            const sellAmount = $a60fd10dd1ca5be1$var$toNumber(item.sellAmount);
            const sellValue = $a60fd10dd1ca5be1$var$toNumber(item.sellValue);
            const itemName = itemNames.get(item.ident);
            if (!itemName || sellAmount <= 0 || sellValue <= 0) return;
            locations.forEach((newLocation)=>{
                if (newLocation.ident === location.ident || !Array.isArray(newLocation.items) || newLocation.items.length === 0) return;
                const possibleItem = newLocation.items.find((newItem)=>newItem.ident === item.ident);
                if (!possibleItem) return;
                const buyAmount = $a60fd10dd1ca5be1$var$toNumber(possibleItem.buyAmount);
                const buyValue = $a60fd10dd1ca5be1$var$toNumber(possibleItem.buyValue);
                if (buyAmount <= 0 || buyValue <= 0 || sellValue >= buyValue) return;
                const itemAmount = Math.min(sellAmount, buyAmount);
                const profit = buyValue - sellValue;
                const profitTotal = profit * itemAmount;
                const profitPercentage = profit / sellValue * 100;
                const trade = {
                    from: location.name,
                    to: newLocation.name,
                    item: itemName,
                    amount: itemAmount,
                    buyFor: sellValue,
                    sellFor: buyValue,
                    profit: profit,
                    profitTotal: profitTotal,
                    profitPercentage: profitPercentage
                };
                if ($a60fd10dd1ca5be1$var$passesMinimumProfit(trade, minimumProfit)) possibleTrades.push(trade);
            });
        });
    });
    return possibleTrades.sort((a, b)=>b.profitTotal - a.profitTotal);
}


function $0c37a591af242c6c$export$58e35d6fa7120452() {
    const allItems = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $18a41a277371f899$export$d2f92acf417bbf5d));
    const locations = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $7f0ad747d29c8911$export$c07c686062478869));
    const options = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $74fec6a0f0fbb7d8$export$d2312e68e1f5ad00));
    const possibleTrades = (0, $a60fd10dd1ca5be1$export$babd9d795c85ae99)({
        items: allItems,
        locations: locations,
        options: options
    });
    const allTrades = possibleTrades.map((trade)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            className: "border border-gray-850 p-2 rounded-xs",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "flex-1 text-red-400",
                            children: trade.from
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "px-3 text-sm text-gray-500",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("svg", {
                                className: "icon",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                    d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "flex-1 text-right text-green-400",
                            children: trade.to
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    className: "flex items-center justify-between my-2",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            className: "flex-1 text-sm text-gray-500",
                            children: [
                                "Buy ",
                                (0, $e4b5b06dae4ddbff$export$f5dd818bff069720)(trade.amount, options.numberFormat),
                                " @ ",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    className: "text-red-400",
                                    children: (0, $e4b5b06dae4ddbff$export$f5dd818bff069720)(trade.buyFor, options.numberFormat)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "flex-1 px-2 text-sm text-center",
                            children: trade.item
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            className: "flex-1 pl-2 text-sm text-right text-gray-500",
                            children: [
                                "Sell @ ",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    className: "text-green-400",
                                    children: (0, $e4b5b06dae4ddbff$export$f5dd818bff069720)(trade.sellFor, options.numberFormat)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    className: "text-right text-sm text-gray-500",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                            className: "mr-2",
                            children: [
                                "Profit: ",
                                (0, $e4b5b06dae4ddbff$export$f5dd818bff069720)(trade.profitTotal, options.numberFormat)
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("small", {
                            className: "text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("svg", {
                                    className: "icon",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 576 512",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                        d: "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
                                    })
                                }),
                                "\xa0",
                                (0, $e4b5b06dae4ddbff$export$f5dd818bff069720)(trade.profitPercentage, options.numberFormat),
                                "%"
                            ]
                        })
                    ]
                })
            ]
        }, trade.from + trade.item + trade.to));
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "grid gap-2",
        children: [
            allTrades.length > 0 && allTrades,
            allTrades.length === 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "text-center my-6 opacity-25",
                children: "No trades available yet."
            })
        ]
    });
}


function $560e03e07b6d34c6$export$8e99cd83c5001464() {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const tradingLocations = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $7f0ad747d29c8911$export$fdc19266b79822e));
    const [modalVisible, setModalVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false);
    const [modalContent, setModalContent] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState('');
    const [locationItemsVisible, setLocationItemsVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(true);
    const itemToggleTitle = locationItemsVisible ? 'Minimize all Locations' : 'Maximize all Locations';
    const locationDisplay = tradingLocations.map((location, index, data)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6446f2961b7abee2$export$18a2be9195644f38), {
            location: location,
            isFirst: index === 0,
            isLast: index === data.length - 1
        }, location.ident));
    function selectNewLocation() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a22e55c628a9e7d6$export$2f2852c3a8d33364), {
                    closeForm: closeModal
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                    type: "button",
                    className: "mt-6 text-sm text-gray-400 hover:text-gray-200",
                    onClick: addAndSelectNewLocation,
                    children: "Add new Location"
                })
            ]
        }));
        setModalVisible(true);
    }
    function addAndSelectNewLocation() {
        setModalContent(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8d0d2e42bd53021f$export$26adc19edd66543f), {
                    closeForm: closeModal,
                    selectAfterAdding: true
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                    type: "button",
                    className: "mt-6 text-sm text-gray-400 hover:text-gray-200",
                    onClick: selectNewLocation,
                    children: "Add existing Location"
                })
            ]
        }));
        setModalVisible(true);
    }
    function closeModal() {
        setModalVisible(false);
        setModalContent('');
    }
    function toggleLocationDisplay() {
        dispatch((0, $7f0ad747d29c8911$export$b20ad5d8d3a2f09b)(!locationItemsVisible));
        setLocationItemsVisible(!locationItemsVisible);
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                        className: "mr-4 text-2xl font-bold",
                        children: "Trading"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        className: "ml-auto btn btn-primary",
                        onClick: selectNewLocation,
                        children: "Add Location"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mt-4 grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "md:col-span-3",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                        type: "button",
                                        title: itemToggleTitle,
                                        onClick: toggleLocationDisplay,
                                        className: 'mr-1 text-xxs cursor-pointer font-mono' + (tradingLocations.length === 0 ? ' hidden' : ''),
                                        children: locationItemsVisible ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            children: "-"
                                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            children: "+"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                                        className: "text-lg",
                                        children: "Locations"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    tradingLocations.length > 0 && locationDisplay,
                                    tradingLocations.length === 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        className: "text-center my-6",
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: " opacity-25",
                                                children: "No locations selected yet."
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                                type: "button",
                                                onClick: selectNewLocation,
                                                className: "opacity-50 hover:opacity-100",
                                                children: "Select one"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "md:col-span-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                                className: "text-lg mb-2",
                                children: "Trades"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $0c37a591af242c6c$export$58e35d6fa7120452), {})
                        ]
                    })
                ]
            }),
            modalVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: modalVisible,
                closeModal: closeModal,
                children: modalContent
            })
        ]
    });
}



parcelRequire("fgmOP");
function $fae9301fc461a933$export$c8424c4d8ba2150() {
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                className: "text-2xl font-bold",
                children: "About the Tradefinder"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mt-4 max-w-2xl",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                        className: "mb-3",
                        children: [
                            "The Tradefinder is web tool to find the most profitable trades between two locations, where one is selling a good and another is buying that good at a higher price. Additionally, you may specify the amount that can be bought or sold.",
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                            "Trades which are not profitable are discarded."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                        className: "mt-6 mb-2 text-xl font-bold",
                        children: "How to use the Tradefinder"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "mb-3",
                        children: "Opening the tool for the first time will add some example locations and some items to it, so you start experimenting right away."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "mb-3",
                        children: "After adding a location to the trading overview, you can add items to that location. Once added, you can start editing the amounts or prices. If an item is not sold or bought, simply leave the amount and value at zero."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Once you added at least two locations with the same item, the Tradefinder will calculate the possible trades. If a profitable trade (profit > 0) is found, it will be displayed in the trades overview on the right side."
                    })
                ]
            })
        ]
    });
}






var $fgmOP = parcelRequire("fgmOP");





function $b96dba2d4eabda47$export$c019608e5b5bb4cb() {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const options = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $74fec6a0f0fbb7d8$export$d2312e68e1f5ad00));
    const [confirmation, setConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(null);
    function doChangeNumberFormatLocale(event) {
        dispatch((0, $74fec6a0f0fbb7d8$export$1f04b3405eb70a7)(event.target.value));
    }
    function doChangeNumberFormatDecimals(event) {
        dispatch((0, $74fec6a0f0fbb7d8$export$557a79cc98d72ae0)(event.target.value));
    }
    function doChangeMinimumProfitType(event) {
        dispatch((0, $74fec6a0f0fbb7d8$export$d40e5a47fbc08b32)(event.target.value));
    }
    function doChangeMinimumProfitAmount(event) {
        dispatch((0, $74fec6a0f0fbb7d8$export$22dbdbba8c6ce0d1)(event.target.value));
    }
    function openCleanStartConfirmation() {
        setConfirmation('clean-start');
    }
    function openCompleteWipeConfirmation() {
        setConfirmation('complete-wipe');
    }
    function closeConfirmation() {
        setConfirmation(null);
    }
    function confirmCleanStart() {
        dispatch((0, $7f0ad747d29c8911$export$5f506d78c27ad5d)());
        dispatch((0, $18a41a277371f899$export$25c2a6760898c183)());
        closeConfirmation();
    }
    function confirmCompleteWipe() {
        localStorage.removeItem('state');
        window.location.reload();
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                className: "text-2xl font-bold",
                children: "Options"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-8",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                htmlFor: "option-number-format-locale",
                                className: "block text-xl",
                                children: "Number Format"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Change how numbers appear in the application."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("select", {
                                name: "option-number-format-locale",
                                id: "option-number-format-locale",
                                value: options.numberFormat.locale,
                                onChange: doChangeNumberFormatLocale,
                                className: "input mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                        value: "en-US",
                                        children: "US (10,000.00)"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                        value: "de-DE",
                                        children: "EU (10.000,00)"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                        value: "fr",
                                        children: "French (10 000,00)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                htmlFor: "option-number-format-decimals",
                                className: "block text-xl",
                                children: "Decimals"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Choose the amount of decimals displayed for numbers."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                type: "number",
                                min: "0",
                                max: "10",
                                name: "option-number-format-decimals",
                                id: "option-number-format-decimals",
                                className: "input mt-2",
                                value: options.numberFormat.decimals,
                                onChange: doChangeNumberFormatDecimals
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                htmlFor: "option-minimum-profit-amount",
                                className: "block text-xl",
                                children: "Minimum Profit"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Set a minimum amount or percentage a trade must generate."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Example: if you want to double your investment, set the percentage to 200%."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Example 2: if you want to earn at least $20 per sold item, set the profit per item to 20."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Example 3: if you want to earn at least $100 per trade, set the total profit amount to 100."
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                className: "flex items-center mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                        name: "option-minimum-profit-amount",
                                        id: "option-minimum-profit-amount",
                                        className: "input",
                                        value: options.minimumProfit.amount,
                                        onChange: doChangeMinimumProfitAmount
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("select", {
                                        name: "option-minimum-profit-type",
                                        id: "option-minimum-profit-type",
                                        value: options.minimumProfit.type,
                                        onChange: doChangeMinimumProfitType,
                                        className: "input border-l-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                                value: "percent",
                                                children: "Profit in Percent"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                                value: "value",
                                                children: "Profit per item"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                                                value: "valueTotal",
                                                children: "total Profit"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "mt-16 p-4 border border-red-400 border-opacity-50 rounded-xs",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h2", {
                        className: "text-xl font-bold text-red-400",
                        children: "Danger Zone"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-8",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                                className: "text-red-400",
                                children: "Clean Start"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Deletes all locations and items to start with a blank canvas. This operation cannot be undone!"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-danger",
                                    onClick: openCleanStartConfirmation,
                                    children: "Start clean"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-8",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                                className: "text-red-400",
                                children: "Complete Wipe"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("small", {
                                children: "Deletes all personal data and restores the example state of the application. This operation cannot be undone!"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-danger",
                                    onClick: openCompleteWipeConfirmation,
                                    children: "Wipe all data"
                                })
                            })
                        ]
                    })
                ]
            }),
            confirmation === 'clean-start' && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: true,
                closeModal: closeConfirmation,
                label: "Confirm clean start",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                        className: "text-2xl mb-4",
                        children: "Start Clean?"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "text-sm text-gray-300",
                        children: "This deletes all locations and items. Your display options stay unchanged."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-6 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn",
                                onClick: closeConfirmation,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-danger",
                                onClick: confirmCleanStart,
                                children: "Delete Locations and Items"
                            })
                        ]
                    })
                ]
            }),
            confirmation === 'complete-wipe' && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $759f317cd367f5b4$export$2b77a92f1a5ad772), {
                visible: true,
                closeModal: closeConfirmation,
                label: "Confirm complete wipe",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                        className: "text-2xl mb-4",
                        children: "Wipe All Data?"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "text-sm text-gray-300",
                        children: "This deletes the saved browser data for Tradefinder and reloads the app with example data."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "mt-6 flex items-center justify-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn",
                                onClick: closeConfirmation,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-danger",
                                onClick: confirmCompleteWipe,
                                children: "Wipe and Reload"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


const $cf0db9cc91d0ce26$export$258c460c80f2afaf = 'TRADING';
const $cf0db9cc91d0ce26$export$fe7c04b7709f792e = 'ITEMS';
const $cf0db9cc91d0ce26$export$51b14517d30aeb1 = 'LOCATIONS';
const $cf0db9cc91d0ce26$export$f6560d8c78c69f39 = 'ABOUT';
const $cf0db9cc91d0ce26$export$2f6d8fefc194047b = 'OPTIONS';
const $cf0db9cc91d0ce26$var$tabs = [
    {
        id: $cf0db9cc91d0ce26$export$f6560d8c78c69f39,
        label: 'About'
    },
    {
        id: $cf0db9cc91d0ce26$export$258c460c80f2afaf,
        label: 'Trading'
    },
    {
        id: $cf0db9cc91d0ce26$export$51b14517d30aeb1,
        label: 'Locations'
    },
    {
        id: $cf0db9cc91d0ce26$export$fe7c04b7709f792e,
        label: 'Items'
    },
    {
        id: $cf0db9cc91d0ce26$export$2f6d8fefc194047b,
        label: 'Options'
    }
];
function $cf0db9cc91d0ce26$export$861edd1ccea2f746() {
    const dispatch = (0, $08c3108423076a6d$export$8ad76b76a4c905f8)();
    const savedTab = (0, $08c3108423076a6d$export$2105062e25df4afe)((0, $74fec6a0f0fbb7d8$export$85965c60fa984327));
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(savedTab);
    let tabContent;
    if (activeTab === $cf0db9cc91d0ce26$export$fe7c04b7709f792e) tabContent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $49f9264303d155a6$export$5388a23595565024), {});
    else if (activeTab === $cf0db9cc91d0ce26$export$51b14517d30aeb1) tabContent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f39e1d29c88fdc81$export$fbd30df0ff5ba7ac), {});
    else if (activeTab === $cf0db9cc91d0ce26$export$258c460c80f2afaf) tabContent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $560e03e07b6d34c6$export$8e99cd83c5001464), {});
    else if (activeTab === $cf0db9cc91d0ce26$export$f6560d8c78c69f39) tabContent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $fae9301fc461a933$export$c8424c4d8ba2150), {});
    else if (activeTab === $cf0db9cc91d0ce26$export$2f6d8fefc194047b) tabContent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b96dba2d4eabda47$export$c019608e5b5bb4cb), {});
    function changeTab(toTab) {
        setActiveTab(toTab);
        dispatch((0, $74fec6a0f0fbb7d8$export$8a589571d67b4921)(toTab));
    }
    function tabClass(isActive) {
        return 'py-3 px-2 sm:px-4 border-r border-gray-900 hover:bg-gray-800 focus:outline-hidden focus:bg-gray-800 ' + (isActive ? 'bg-gray-800 text-white' : 'bg-gray-850 text-gray-300');
    }
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "my-8",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "flex overflow-x-auto trading-wider sm:tracking-widest text-xs",
                role: "tablist",
                "aria-label": "Tradefinder sections",
                children: $cf0db9cc91d0ce26$var$tabs.map((tab)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        id: `tab-${tab.id.toLowerCase()}`,
                        role: "tab",
                        "aria-selected": activeTab === tab.id,
                        "aria-controls": "main-panel",
                        className: tabClass(activeTab === tab.id),
                        onClick: ()=>changeTab(tab.id),
                        children: tab.label
                    }, tab.id))
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                id: "main-panel",
                role: "tabpanel",
                "aria-labelledby": `tab-${activeTab.toLowerCase()}`,
                className: "p-4 bg-gray-800 shadow-lg rounded-xs rounded-t-none",
                children: tabContent
            })
        ]
    });
}


function $8cf9aa60a6e9826d$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "container mx-auto max-w-8xl p-4 md:p-8",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6a6c33cd92946d32$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cf0db9cc91d0ce26$export$861edd1ccea2f746), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a572afac44151ae1$export$a06f1c675e846f6f), {})
        ]
    });
}


(0, $99ad227a70ba4a26$export$2e2bcd8739ae039).subscribe(()=>{
    (0, $8c0f91bab1d0a112$export$fb931cd598921492)((0, $99ad227a70ba4a26$export$2e2bcd8739ae039).getState());
});
const $38519af2e2e0b551$var$container = document.getElementById('root');
const $38519af2e2e0b551$var$root = (0, $5fdae19e1117f068$exports.createRoot)($38519af2e2e0b551$var$container); // createRoot(container!) if you use TypeScript
$38519af2e2e0b551$var$root.render(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $08c3108423076a6d$export$2881499e37b75b9a), {
    store: (0, $99ad227a70ba4a26$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8cf9aa60a6e9826d$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=repo.59f5cb42.js.map
